﻿import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import Feature from 'ol/Feature.js';
import Circle from 'ol/geom/Circle.js';
import { Circle as CircleStyle, Icon, Fill, Stroke, RegularShape, Style, Text } from 'ol/style.js';
import { Polygon, MultiPolygon, LineString, MultiLineString, Point, MultiPoint, GeometryCollection } from 'ol/geom.js';
import { defaults as defaultInteractions, Draw, Modify, DragBox, Select, Snap } from 'ol/interaction.js';
import { click, altKeyOnly, shiftKeyOnly } from 'ol/events/condition.js';
import {platformModifierKeyOnly} from 'ol/events/condition';
import Map from 'ol/Map.js';
import Collection from 'ol/Collection.js';
import { Utility } from '../Utility.js';
export { RoadBuilderTool };

/**
 * Class RoadBuilderTool
 */
const RoadBuilderTool = function () {

    // Define this
    var myRoadBuilderTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Utility
    this._utility = new Utility();

    // Geojson Format
    this._geojsonFormat = new GeoJSON();

    // Style draw line road
    this._styleDrawLineRoad = [
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 255, 0.8)',
                width: 3
            })
        }),
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 1)',
                width: 2
            })
        }),
        new Style({
            fill: new Fill({
                color: 'rgba(255, 255, 0, 0.8)'
            }),
            stroke: new Stroke({
                color: 'rgba(0, 0, 0, 1)',
                //lineDash: [10, 10],
                width: 1
            }),
            image: new CircleStyle({
                radius: 5,
                stroke: new Stroke({
                    color: 'rgba(0, 0, 0, 0.7)'
                }),
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.2)'
                })
            })
        })
    ];

    // Style line sub road
    this._styleLineSubRoad = [
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 0.5)',
                width: 8
            })
        })
    ];

    // Already initialize
    this._toolInitialize = false;

    // Style point interception
    this._stylePointRoad = [
        new Style({
            image: new CircleStyle({
                radius: 7,
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 1)'
                }),
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 2
                }),
            })
        }),
        new Style({
            image: new CircleStyle({
                radius: 5,
                stroke: new Stroke({
                    color: 'rgba(0, 0, 0, 1)',
                    width: 2
                }),
                fill: new Fill({
                    color: 'rgba(255, 255, 0, 1)',
                })
            })
        })
    ];

    // Style draw police number
    this._stylePolicePoint =
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 255, 1)',
                width: 6
            }),
            fill: new Fill({
                color: 'rgba(255, 255, 255, 1)'
            }),
            image: new CircleStyle({
                radius: 4,
                stroke: new Stroke({
                    color: '#ff3d00',
                    width: 1
                }),
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 1)'
                })
            })
        });

    // Hash table freguesia
    this._hashTableFreguesia = {};

    // Hash reference
    this._hashReference = {};

    // List sub road of police number
    this._listSubRoadPolice = [];

    // Layer buffer police number
    this._layerBufferPolice = null;

    // Style for buffer police number
    this._bufferPoliceStyle =
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 255, 0.1)',
                width: 1
            })//,
            //fill: new Fill({
            //    color: 'rgba(255, 255, 255, 0.1)'
            //}),
            //image: new CircleStyle({
            //    radius: 5,
            //    stroke: new Stroke({
            //        color: 'rgba(255, 255, 0, 1)',
            //        width: 2
            //    }),
            //    fill: new Fill({
            //        color: 'rgba(255, 255, 0, 0.2)'
            //    })
            //})
        });

    // Style sub road police number closer
    this._styleSubRoadPoliceCloser = [
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 0.5)',
                width: 12
            }),
            fill: new Fill({
                color: 'rgba(255, 255, 0, 0.1)'
            })
        }),
        new Style({
            stroke: new Stroke({
                color: 'rgba(34, 139, 34, 0.5)',
                width: 4
            }),
            fill: new Fill({
                color: 'rgba(255, 255, 0, 0.5)'
            })
        })
    ];

    // Style sub road police number
    this._styleSubRoadPolice = [
        new Style({
            stroke: new Stroke({
                color: 'rgba(0, 191, 255, 0.5)',
                width: 10
            }),
            fill: new Fill({
                color: 'rgba(95, 158, 160, 0.1)'
            })
        }),
        new Style({
            stroke: new Stroke({
                color: 'rgba(173, 216, 230, 0.5)',
                width: 4
            }),
            fill: new Fill({
                color: 'rgba(255, 255, 0, 0.5)'
            })
        })
    ];

    // Style for police number associate to a sub road
    this._stylePoliceAssociateToSubRoad = [
        new Style({
            image: new CircleStyle({
                radius: 4,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 1
                }),
                fill: new Fill({
                    color: 'rgba(255, 0, 0, 1)'
                })
            })
        }),
        new Style({
            image: new CircleStyle({
                radius: 5,
                stroke: new Stroke({
                    color: 'rgba(0, 0, 0, 1)',
                    width: 1
                }),
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0)'
                })
            })
        })
    ];

    // Style for police number associate to a sub road on select mode
    this._stylePoliceAssociateToSubRoadSelect = function (feature) {
        return [
                new Style({
                    image: new CircleStyle({
                        radius: 4,
                        stroke: new Stroke({
                            color: 'rgba(255, 255, 255, 1)',
                            width: 1
                        }),
                        fill: new Fill({
                            color: 'rgba(255, 0, 0, 1)'
                        })
                    })
                }),
                new Style({
                    image: new CircleStyle({
                        radius: 5,
                        stroke: new Stroke({
                            color: 'rgba(255, 128, 0, 1)',
                            width: 1
                        }),
                        fill: new Fill({
                            color: 'rgba(255, 255, 255, 0)'
                        })
                    })
                }),
                new Style({
                    text: new Text({
                        font: 'normal 11px Calibri', //"Verdana", "Open Sans", "Arial Unicode MS", "sans-serif"', //font: '12px Calibri,sans-serif',
                        placement: 'point',
                        overflow: true,
                        fill: new Fill({
                            color: "rgba(255, 255, 255, 1)"
                        }),
                        stroke: new Stroke({
                            color: "rgba(0, 0, 0, 1)",
                            width: 3
                        }),
                        textBaseline: 'bottom',
                        offsetY: -2,
                        text: feature.getProperties().POL_DESIG
                    })
                })
        ];
    };

    // Style draw for police number associate to a sub road
    this._stylePolygonDraw = [
        new Style({
            image: new CircleStyle({
                radius: 4,
                stroke: new Stroke({
                    color: 'rgba(35, 181, 119, 1)',
                    width: 1
                }),
                fill: new Fill({
                    color: 'rgba(255, 0, 0, 1)'
                })
            })
        }),
        new Style({
            fill: new Fill({
                color: 'rgba(35, 181, 119, .2)'
            }),
            stroke: new Stroke({
                color: 'rgba(35, 181, 119, 1)',
                width: 0.5
            })
        }),
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 255, 1)',
                width: 0.5
            })
        })
    ];

    // Style layer draw for police number associate to a sub road
    this._stylePolygonLayerDraw = [
        new Style({
            fill: new Fill({
                color: 'rgba(255, 255, 255, .1)'
            }),
            stroke: new Stroke({
                color: 'rgba(0, 128, 255, 1)',
                width: 0.5
            })
        }),
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 1)',
                width: 1
            })
        })
    ];

    // Style draw modify for police number associate to a sub road
    this._stylePolygonDrawModify = [
        new Style({
            image: new CircleStyle({
                radius: 4,
                stroke: new Stroke({
                    color: 'rgba(102, 153, 255, 1)',
                    width: 1
                }),
                fill: new Fill({
                    color: 'rgba(255, 0, 0, 1)'
                })
            })
        }),
        new Style({
            fill: new Fill({
                color: 'rgba(35, 181, 119, .5)'
            }),
            stroke: new Stroke({
                color: 'rgba(102, 153, 255, 1)',
                width: 1
            })
        }),
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 255, 1)',
                width: 1
            })
        })
    ];

    // Buffer size for police number in meters
    this._bufferSize = 500;

    // Buffer size for police number in km
    this._bufferPoliceSizeKm = 0.5;

    // List id sub road police number
    this._listIdSubRoadPolice = [];

    // Array with all sub road police number near
    this._arrayFeatureSubRoadPolice = [];

    // Style for select road, subroad or police number
    this._styleSelectRoad = function (feature)
    {
        var layerName = feature.getId().split('.')[0];
        var property = feature.getProperties();
        var text = "";
        var style = null;
        switch(layerName)
        {
            case "VW_NPOLICIA_III":
                text = property.POL_DESIG;
                style = [
                    new Style({
                        image: new CircleStyle({
                            radius: 4,
                            stroke: new Stroke({
                                color: 'rgba(255, 255, 255, 1)',
                                width: 1
                            }),
                            fill: new Fill({
                                color: 'rgba(255, 255, 0, 1)'
                            })
                        })
                    }),
                    new Style({
                        image: new CircleStyle({
                            radius: 5,
                            stroke: new Stroke({
                                color: 'rgba(0, 0, 0, 1)',
                                width: 1
                            }),
                            fill: new Fill({
                                color: 'rgba(255, 255, 255, 0)'
                            })
                        })
                    }),
                    new Style({
                        text: new Text({
                            font: 'normal 14px Calibri', //"Verdana", "Open Sans", "Arial Unicode MS", "sans-serif"', //font: '12px Calibri,sans-serif',
                            placement: 'point',
                            overflow: true,
                            fill: new Fill({
                                color: "rgba(255, 255, 255, 1)"
                            }),
                            stroke: new Stroke({
                                color: "rgba(0, 0, 0, 1)",
                                width: 3
                            }),
                            textBaseline: 'bottom',
                            offsetY: -2,
                            text: text
                        })
                    })
                ];
                break;
            case "V_ESTRADAS":
                var firstFeatureSelected = myRoadBuilderTool._select.getFeatures().getArray()[0];
                var countFeatureSelected = myRoadBuilderTool._select.getFeatures().getArray().length;
                var colorStroke = 'rgba(0, 0, 255, 0.5)';

                // Change color for the first subroad selected if subroad selected are in diferente road
                if( firstFeatureSelected.getProperties().IDTROCO === property.IDTROCO && countFeatureSelected > 1 && myRoadBuilderTool._CheckIfSubroadSelectedDiferenteRoad())
                {
                    colorStroke = 'rgba(255, 0, 0, 0.5)';
                }

                text = property.TROCO;
                style = [
                    new Style({
                        stroke: new Stroke({
                            color: colorStroke,
                            width: 8
                        })
                    }),
                    new Style({
                        stroke: new Stroke({
                            color: 'rgba(255, 255, 0, 1)',
                            width: 3
                        })
                    }),
                    new Style({
                        stroke: new Stroke({
                            color: 'rgba(255, 0, 0, 1)',
                            width: 2
                        })
                    }),
                    new Style({
                        stroke: new Stroke({
                            color: 'rgba(255, 255, 255, 1)',
                            width: 1
                        })
                    }),
                    new Style({
                        text: new Text({
                            font: 'normal 14px Calibri', //"Verdana", "Open Sans", "Arial Unicode MS", "sans-serif"', //font: '12px Calibri,sans-serif',
                            placement: 'line',
                            overflow: true,
                            fill: new Fill({
                                color: "rgba(255, 255, 255, 1)"
                            }),
                            stroke: new Stroke({
                                color: "rgba(0, 0, 0, 1)",
                                width: 3
                            }),
                            textBaseline: 'bottom',
                            offsetY: -2,
                            text: text
                        })
                    })
                ];
                break;
            default:
                // do nothing
        }

        return style;
    };

    // Layer subroad from road
    this._layerSubRoadFromRoad = null;

    // Feature subroad from road selected
    this._featureSubRoadFromRoadSelected = null;

    // Feature road from road selected
    this._featureRoadSelected = null;

    // Layer source name of police number
    this._layerSourceNamePoliceNumber = "";

    // Drag box for road selection
    this._dragBoxSelectRoad = null;

    // layer info road
    this._layerInfoRoad = {};

    // layer info sub road
    this._layerInfoSubRoad = {};

    // layer info sub road in map
    this._layerNameSubRoadInMap = "";

    // Layer draw line road
    this._layerDrawLineRoad = null;

    // Modify line road
    this._modifyDrawLineRoad = null;

    // Layer info line road
    this._layerInfoLineRoad = null;

    // Interaction draw line road
    this._drawLineRoad = null;

    // Interaction split
    this._drawPointSplit = null;

    // Layer split
    this._layerPointSplit = null;

    // Layer split subroad
    this._layerSubRoadSplit = null;

    // Layer split road
    this._layerRoadSplit = null;

    // Hash new subroad from split
    this._splitSubRoadInfo = {};

    // Hash new road from split
    this._splitRoadInfo = {};

    // Style point split
    this._styleSplit = [
        new Style({
            image: new RegularShape({
                fill: new Fill({
                    color: 'red'
                }),
                stroke: new Stroke({
                    color: 'black',
                    width: 4
                }),
                points: 4,
                radius: 5,
                radius2: 0,
                angle: Math.PI / 4
            })
        }),
        new Style({
            image: new RegularShape({
                fill: new Fill({
                    color: 'red'
                }),
                stroke: new Stroke({
                    color: 'white',
                    width: 3
                }),
                points: 4,
                radius: 5,
                radius2: 0,
                angle: Math.PI / 4
            })
        })
    ];

    // feature colection intercepted
    this._collectionFeatureIntercepted = new Collection();

    // Layer point interception
    this._layerPointRoad = null;

    // Hash of of {feature intercepted, array point interception}
    this._hashFeatureIntercepted = {};

    // Hash new subroad information
    this._updateSubRoadInfo = {};

    // Hash new subroad information
    this._createRoadInfo = {};

    // Interaction modify road
    this._modify = null;

    // Start Modify
    this._startModify = false;

    // Interaction select
    this._select = null;

    // Interaction drag box for select 
    this._dragBox = null;

    // User select modify road
    this._useSelectModify = false;

    // Sub road layer
    this._layerSubRoadLine = null;

    // Layer police point
    this._layerPolicePoint = null

    // Interaction draw point police number
    this._drawPointPolice = null;

    // Indicate if draw road instersec with any other road
    this._hasInterception = false;

    // Actice tool
    this._hashActiveTool = {};

    // Line wkt line merge
    this._lineMergeWkt = null

    // Feature line wkt line merge
    this._FeaturelineMergeWkt = null

    // Mode save sub road
    this._modeSaveSubRoad = "";

    // Mode type
    this._elementTypeForOperarion = "road";

    // Indicate if key shift was pressed
    this._shiftPressed = false;

    // Merge road information
    this._mergeRoadInfo = {};

    // List history road
    this._listHistoryRoad = {};

    // Id Road selected in modify
    this._idRoadSelectedInModify = null;

    // Id Road selected in modify
    this._arraySubRoadFeatureModify = [];

    // -- end private variable --------------------------------------------------------------------

    // -- begin public variable -------------------------------------------------------------------

    // feature colection use in road builder tool
    this.collectionFeatureSet = new Collection();

    // Datatable history Road
    this._datatablehistoryRoad = null;

    // -- end public variable ---------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Menu definition
     */
    this.BuildMenuBar = function ()
    {
        // --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
        // -- Road && Police button -------------------------------------------------------------------------------------------------------------------------------------------------------
        // --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

        // -- Open Draw road mode -----------------------------------------------------------------
        const buttonRoadMode = document.createElement('li');
        buttonRoadMode.className = "border-right";

        const buttonRoadModeContainer = document.createElement('a');
        buttonRoadModeContainer.id = 'target-gpi-road-mode';
        buttonRoadModeContainer.className = 'road-builder-tool';
        buttonRoadModeContainer.setAttribute('title', 'Funcionalidades sobre arruamento');

        const buttonRoadModeContent = document.createElement('div');
        buttonRoadModeContent.className = 'menu-icon';
        buttonRoadModeContent.innerHTML = '<i class="fa fa-road"></i>';

        buttonRoadModeContainer.appendChild(buttonRoadModeContent);
        buttonRoadMode.appendChild(buttonRoadModeContainer);

        /**
         * Draw polygon handle
         */
        const handleRoadMode = function ()
        {                
            if($('#target-gpi-road-mode').hasClass('active'))
            {
                // Road mode desactice
                $('#target-toggle-option-road-builder-tool').hide("slide");
                $('#target-gpi-draw-road').hide("slide");
                $('#target-gpi-clean-road-builder-tool').hide("slide");
                $('#target-gpi-submit-road-builder-tool').hide("slide");
                $('#target-gpi-snapping-road-builder-tool').hide("slide");
                $('#target-gpi-road-tool-select-road').hide("slide");
                //$('#target-gpi-draw-sub-road').hide("slide");
                $('#target-gpi-road-tool-split-road').hide("slide");
                $('#target-gpi-road-tool-merge-sub-road').hide("slide");
                $('#target-gpi-road-info-road-builder-tool').hide("slide");
                $('#target-gpi-road-info-road-history-tool').hide("slide");
                $('#target-gpi-road-delete-road-builder-tool').hide("slide");
                $('#target-gpi-police-tool-select-by-polygon-submit').hide("slide");
                $('#target-gpi-police-tool-select-by-polygon-clean').hide("slide");

                // Clean all road information
                myRoadBuilderTool._CleanAllRoad();

                // Show police mode
                $('#target-gpi-police-mode').show("slide");

                // Reset cursor
                document.body.style.cursor = 'default';

                // Desactice button draw road
                if($('#target-gpi-draw-road').parent().hasClass("active")) {
                    myRoadBuilderTool._drawLineRoad.setActive(false);
                    myRoadBuilderTool._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-draw-road');
                    myRoadBuilderTool._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-draw-road');
                    $('#target-gpi-draw-road').parent().removeClass("active");
                }

                // Desactive snaping button
                if($('#target-gpi-snapping-road-builder-tool').hasClass('hold-single-button')) {
                    myRoadBuilderTool._mapSgs._snappingTool.update(!myRoadBuilderTool._mapSgs._snappingTool._isActive);
                    $('#target-gpi-snapping-road-builder-tool').removeClass('hold-single-button');
                }

                // Desactice button split sub road
                if($('#target-gpi-road-tool-split-road').parent().hasClass("active")) {
                    myRoadBuilderTool._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-road-tool-split-road');
                    myRoadBuilderTool._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-road-tool-split-road');
                    $('#target-gpi-road-tool-split-road').parent().removeClass("active");
                }

                // Desactive button select sub road
                if($('#target-gpi-road-tool-select-road').parent().hasClass("active")) {
                    myRoadBuilderTool._ClearSelect();
                    myRoadBuilderTool._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-road-tool-select-road');
                    myRoadBuilderTool._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-road-tool-select-road');
                    $('#target-gpi-road-tool-select-road').parent().removeClass("active");
                }
            }
            else
            {
                // Road mode active
                $('#target-toggle-option-road-builder-tool').show("slide");
                if ($('#target-toggle-option-road-builder-tool').hasClass("subroad"))
                    $('#target-gpi-draw-road').hide();
                else
                    $('#target-gpi-draw-road').show("slide");
                $('#target-gpi-clean-road-builder-tool').show("slide");
                $('#target-gpi-snapping-road-builder-tool').show("slide");
                $('#target-gpi-road-tool-select-road').show("slide");
                $('#target-gpi-road-info-road-history-tool').hide("slide");

                // Hide police mode
                $('#target-gpi-police-mode').hide("slide");
            }

            $('#target-gpi-road-mode').toggleClass('active')
        }

        buttonRoadMode.addEventListener('click', handleRoadMode, false);
        buttonRoadMode.addEventListener('touchstart', handleRoadMode, false);

        // -- Open police mode ----------------------------------------------------------------
        const buttonPoliceMode = document.createElement('li');

        const buttonPoliceModeContainer = document.createElement('a');
        buttonPoliceModeContainer.id = 'target-gpi-police-mode';
        buttonPoliceModeContainer.className = 'road-builder-tool';
        buttonPoliceModeContainer.setAttribute('title', 'Funcionalidades sobre números de polícia');

        const buttonPoliceModeContent = document.createElement('div');
        buttonPoliceModeContent.className = 'menu-icon';
        buttonPoliceModeContent.innerHTML = '<i class="material-icons">more_vert</i>';

        buttonPoliceModeContainer.appendChild(buttonPoliceModeContent);
        buttonPoliceMode.appendChild(buttonPoliceModeContainer);

        /**
         * Draw point police number handle
         */
        const handlePoliceMode = function ()
        {
            // Desactive police mode
            if($('#target-gpi-police-mode').hasClass('active'))
            {
                // Police mode desactice
                $('#target-gpi-draw-police-number').hide("slide");
                $('#target-gpi-clean-road-builder-tool').hide("slide");
                $('#target-gpi-submit-road-builder-tool').hide("slide");
                $('#target-gpi-police-tool-select').hide("slide");
                $('#target-gpi-police-tool-select-by-polygon').hide("slide");
                $('#target-gpi-police-tool-select-by-polygon-submit').hide("slide");
                $('#target-gpi-police-tool-select-by-polygon-clean').hide("slide");

                // Clean all police number
                myRoadBuilderTool._CleanAllPolice();

                // Show police mode
                $('#target-gpi-road-mode').show("slide");

                // Reset cursor
                document.body.style.cursor = 'default';

                // Desactive button draw point police number
                if($('#target-gpi-draw-police-number').parent().hasClass("active")) {
                    //myRoadBuilderTool._drawPointPolice.setActive(false);
                    myRoadBuilderTool._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-draw-police-number');
                    myRoadBuilderTool._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-draw-police-number');
                    //$('#target-gpi-draw-police-number').parent().removeClass("active");
                    myRoadBuilderTool._ActicePoliceDrawTool($('#target-gpi-draw-police-number').parent()[0], false);
                }

                // Desactive button select sub road police number
                if($('#target-gpi-police-tool-select').parent().hasClass("active")) {
                    //myRoadBuilderTool._ClearSelect();
                    myRoadBuilderTool._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-police-tool-select');
                    myRoadBuilderTool._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-police-tool-select');
                    //$('#target-gpi-police-tool-select').parent().removeClass("active");
                    myRoadBuilderTool._ActiveSelectTool($('#target-gpi-police-tool-select').parent()[0], false);
                }

                // Desactive button select police number associate to sub road
                if($('#target-gpi-police-tool-select-by-polygon').parent().hasClass("active"))
                {
                    myRoadBuilderTool._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-police-tool-select-by-polygon');
                    myRoadBuilderTool._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-police-tool-select-by-polygon');
                    myRoadBuilderTool._ActiveSelectPoliceNumberByPolygonTool($('#target-gpi-police-tool-select-by-polygon').parent()[0], false);
                }
            }
            else
            {
                // Road mode active
                $('#target-gpi-draw-police-number').show("slide");
                $('#target-gpi-clean-road-builder-tool').show("slide");
                $('#target-gpi-police-tool-select').show("slide");
                $('#target-gpi-police-tool-select-by-polygon').show("slide");

                // Hide police mode
                $('#target-gpi-road-mode').hide("slide");
            }

            $('#target-gpi-police-mode').toggleClass('active')
        }

        buttonPoliceMode.addEventListener('click', handlePoliceMode, false);
        buttonPoliceMode.addEventListener('touchstart', handlePoliceMode, false);

        // -- Clean ---------------------------------------------------------------------------
        const buttonCleanRoadBuilderTool = document.createElement('li');
        buttonCleanRoadBuilderTool.className = "border-left";

        const buttonCleanRoadBuilderToolContainer = document.createElement('a');
        buttonCleanRoadBuilderToolContainer.id = 'target-gpi-clean-road-builder-tool';
        buttonCleanRoadBuilderToolContainer.setAttribute('title', 'Limpar');
        buttonCleanRoadBuilderToolContainer.setAttribute('style', 'display:none');

        const buttonCleanRoadBuilderToolContent = document.createElement('div');
        buttonCleanRoadBuilderToolContent.className = 'menu-icon refresh';
        buttonCleanRoadBuilderToolContent.innerHTML = '<i class="gpi gpi-apagar"></i>';

        buttonCleanRoadBuilderToolContainer.appendChild(buttonCleanRoadBuilderToolContent);
        buttonCleanRoadBuilderTool.appendChild(buttonCleanRoadBuilderToolContainer);

        /**
         * Clean handle
         */
        const handleCleanRoadBuilderTool = function ()
        {
            // Clean police tool
            if($('#target-gpi-police-mode').hasClass('active')) {
                // Clean all police number
                myRoadBuilderTool._CleanAllPolice();
            }

            // Clean road tool
            if($('#target-gpi-road-mode').hasClass('active'))
            {
                // If split road active clean only split road
                if(myRoadBuilderTool._hashActiveTool.splitRoad && myRoadBuilderTool._hashActiveTool.splitRoad.active)
                {
                    myRoadBuilderTool._CleanSplitRoad();
                    return;
                }

                // Clean all road
                myRoadBuilderTool._CleanAllRoad();

                // If draw road active reactive draw
                if(myRoadBuilderTool._hashActiveTool.drawRoad && myRoadBuilderTool._hashActiveTool.drawRoad.active)
                    myRoadBuilderTool._drawLineRoad.setActive(true);
            }

            // Clear highlight
            myRoadBuilderTool._mapSgs.layerHighlightOverlay.getSource().clear();

            // Clean selection
            myRoadBuilderTool._CleanSelect();
        };

        buttonCleanRoadBuilderTool.addEventListener('click', handleCleanRoadBuilderTool, false);
        buttonCleanRoadBuilderTool.addEventListener('touchstart', handleCleanRoadBuilderTool, false);

        // -- Submit --------------------------------------------------------------------------
        const buttonSubmitRoadBuilderTool = document.createElement('li');
        buttonSubmitRoadBuilderTool.className = "border-left";

        const buttonSubmitRoadBuilderToolContainer = document.createElement('a');
        buttonSubmitRoadBuilderToolContainer.id = 'target-gpi-submit-road-builder-tool';
        buttonSubmitRoadBuilderToolContainer.setAttribute('title', 'Submeter pedido');
        buttonSubmitRoadBuilderToolContainer.setAttribute('style', 'display:none');

        const buttonSubmitRoadBuilderToolContent = document.createElement('div');
        buttonSubmitRoadBuilderToolContent.className = 'menu-icon refresh';
        buttonSubmitRoadBuilderToolContent.innerHTML = '<i class="fa fa-check modal-location-plant-button"></i>';

        buttonSubmitRoadBuilderToolContainer.appendChild(buttonSubmitRoadBuilderToolContent);
        buttonSubmitRoadBuilderTool.appendChild(buttonSubmitRoadBuilderToolContainer);

        /**
         * Submit road
         */
        const handleSubmitRoadBuilderTool = function ()
        {
            // Road create form
            if($('#target-gpi-road-mode').hasClass('active'))
            {
                // Draw road
                if ($('#target-gpi-draw-road').parent().hasClass("active")) {
                    if (myRoadBuilderTool._hasInterception) {
                        // Clear form add road
                        myRoadBuilderTool._CleanFormRoad();

                        // Build form
                        myRoadBuilderTool._BuildRoadInformation();
                    }
                    else {
                        if (myRoadBuilderTool._layerDrawLineRoad.getSource().getFeatures().length == 0) {
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["warning"]("Desenhe primeiro uma rua");
                            toastr.options.positionClass = 'toast-bottom-center';
                        }
                        else {
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["warning"]("O arruamento tem que estar ligado a rede de estrada existente.");
                            toastr.options.positionClass = 'toast-bottom-center';
                        }

                        return;
                    }
                }

                // Select element
                if($('#target-gpi-road-tool-select-road').parent().hasClass("active"))
                {

                    // if split road selected
                    if(
                        myRoadBuilderTool._hashActiveTool.splitRoad &&
                        myRoadBuilderTool._hashActiveTool.splitRoad.active
                      )
                    {
                        switch(myRoadBuilderTool._elementTypeForOperarion)
                        {
                            case "road":
                                myRoadBuilderTool._SplitRoad();
                                break;
                            case "subroad":
                                if(Object.keys(myRoadBuilderTool._splitSubRoadInfo.newSubRoadRoad.hashSubRoad).length > 0)
                                    myRoadBuilderTool._SplitSubRoadGeometry();
                                break;
                            default:
                                // do nothing
                        }                    
                    }

                    // Modify element
                    //if( myRoadBuilderTool._modify && myRoadBuilderTool._modify.getActive() )
                    if (Object.keys(myRoadBuilderTool._updateSubRoadInfo).length > 0)
                    {
                        switch(myRoadBuilderTool._elementTypeForOperarion)
                        {
                            case "subroad":
                                myRoadBuilderTool._UpdateSubRoadGeometry();
                                break;
                            default:
                                // do nothing
                        }
                    }
                }
            }

            // Police number create form
            if($('#target-gpi-police-mode').hasClass('active'))
            {
                // Clear form add road
                myRoadBuilderTool._CleanFormAddPolice();
                // Build form
                myRoadBuilderTool._BuildPoliceInformation();
            }
        };

        buttonSubmitRoadBuilderTool.addEventListener('click', handleSubmitRoadBuilderTool, false);
        buttonSubmitRoadBuilderTool.addEventListener('touchstart', handleSubmitRoadBuilderTool, false);

        // -- Close ---------------------------------------------------------------------------
        const buttonCloseRoadBuilderTool = document.createElement('li');
        buttonCloseRoadBuilderTool.className = "border-left";

        const buttonCloseRoadBuilderToolContainer = document.createElement('a');
        buttonCloseRoadBuilderToolContainer.setAttribute('title', 'Fechar');

        const buttonCloseRoadBuilderToolContent = document.createElement('div');
        buttonCloseRoadBuilderToolContent.className = 'menu-icon refresh';
        buttonCloseRoadBuilderToolContent.innerHTML = '<i class="fa fa-times modal-location-plant-button"></i>';

        buttonCloseRoadBuilderToolContainer.appendChild(buttonCloseRoadBuilderToolContent);
        buttonCloseRoadBuilderTool.appendChild(buttonCloseRoadBuilderToolContainer);

        /**
         * close road builder tool handle
         */
        const handleCloseRoadBuilderTool = function ()
        {
            // Close road build tool
            $('#menubar-bottom-road-builder-tool').toggle('ol-hidden');

            // If road tool active
            if($('#target-gpi-road-mode').hasClass('active'))
            {
                handleRoadMode();
            }

            // If police tool active
            if($('#target-gpi-police-mode').hasClass('active'))
            {
                handlePoliceMode();
            }

            // Id modify active, remove modify and select
            if(myRoadBuilderTool._modify && myRoadBuilderTool._modify.getActive())
            {
                myRoadBuilderTool._UndoModify();
            }

            // Clean highlight
            myRoadBuilderTool._mapSgs.layerHighlightOverlay.getSource().clear();

            // Reset default cursor
            document.body.style.cursor = 'default';

            // Clear Info feature
            $('#offcanvas-info').removeClass('show');
                
            // Reset tooltips
            if(myRoadBuilderTool._mapSgs.tooltips) {
                if (!myRoadBuilderTool._mapSgs.map.hasListener('singleclick', myRoadBuilderTool._mapSgs.tooltips.BuildInfoTooltips))
                    myRoadBuilderTool._mapSgs.map.on('singleclick', async (e) => { await myRoadBuilderTool._mapSgs.tooltips.BuildInfoTooltips(e); });
            }

            // Hide menu botton bar
            if ($('#id-menubar-bottom-road-builder-tool').is(':visible'))
                $('#id-menubar-bottom-road-builder-tool').toggle('ol-hidden');
        };

        buttonCloseRoadBuilderTool.addEventListener('click', handleCloseRoadBuilderTool, false);
        buttonCloseRoadBuilderTool.addEventListener('touchstart', handleCloseRoadBuilderTool, false);

        // --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
        // -- Road button -----------------------------------------------------------------------------------------------------------------------------------------------------------------
        // --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

        // -- Toggle road or subroad --------------------------------------------------------------
        const buttonToggleRoadOption = document.createElement('li');

        const buttonToggleRoadOptionContainer = document.createElement('a');
        buttonToggleRoadOptionContainer.id = 'target-toggle-option-road-builder-tool';
        buttonToggleRoadOptionContainer.className = 'road-builder-tool road active';
        buttonToggleRoadOptionContainer.setAttribute('title', 'Seleccione o tipo de elemento');
        buttonToggleRoadOptionContainer.setAttribute('style', 'display:none');

        const buttonToggleRoadOptionContent = document.createElement('div');
        buttonToggleRoadOptionContent.className = 'menu-icon';
        buttonToggleRoadOptionContent.innerHTML = '<span>Rua</span>';

        buttonToggleRoadOptionContainer.appendChild(buttonToggleRoadOptionContent);
        buttonToggleRoadOption.appendChild(buttonToggleRoadOptionContainer);

        const handleToggleRoadOption = function ()
        {
            myRoadBuilderTool._ActiveOptionRoad();
        };

        buttonToggleRoadOption.addEventListener('click', handleToggleRoadOption, false);
        buttonToggleRoadOption.addEventListener('touchstart', handleToggleRoadOption, false);

        // -- Draw road  --------------------------------------------------------------------------
        const buttonDrawRoad = document.createElement('li');

        const buttonDrawRoadContainer = document.createElement('a');
        buttonDrawRoadContainer.setAttribute('href', '#target-gpi-draw-road');
        buttonDrawRoadContainer.id = 'target-gpi-draw-road';
        buttonDrawRoadContainer.className = 'target';
        buttonDrawRoadContainer.setAttribute('title', 'Desenhar arruamento');
        buttonDrawRoadContainer.setAttribute('style', 'display:none');

        const buttonDrawRoadContent = document.createElement('div');
        buttonDrawRoadContent.className = 'menu-icon';
        buttonDrawRoadContent.innerHTML = '<i class="gpi gpi-linha"></i>';

        buttonDrawRoadContainer.appendChild(buttonDrawRoadContent);
        buttonDrawRoad.appendChild(buttonDrawRoadContainer);

        /**
         * Draw line road handle
         */
        const handleDrawRoad = function ()
        {
            // Desactive select tool if active
            if(myRoadBuilderTool._hashActiveTool.roadToolSelectRoad && myRoadBuilderTool._hashActiveTool.roadToolSelectRoad.active)
                myRoadBuilderTool._ActiveSelectTool(myRoadBuilderTool._hashActiveTool.roadToolSelectRoad.node, false);

            // Desactive split sub road tool if active
            if(myRoadBuilderTool._hashActiveTool.splitRoad && myRoadBuilderTool._hashActiveTool.splitRoad.active)
                myRoadBuilderTool._ActiveSplitRoadTool(myRoadBuilderTool._hashActiveTool.splitRoad.node, false);

            myRoadBuilderTool._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-draw-road');
            myRoadBuilderTool._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-draw-road');

            if($(this).hasClass('active'))
                myRoadBuilderTool._ActiveDrawRoadTool(this, false);
            else
                myRoadBuilderTool._ActiveDrawRoadTool(this, true);
        };

        buttonDrawRoad.addEventListener('click', handleDrawRoad, false);
        buttonDrawRoad.addEventListener('touchstart', handleDrawRoad, false);

        // -- Snapping ----------------------------------------------------------------------------------
        const buttonRoadBuilderToolSnapping = document.createElement('li');

        const buttonRoadBuilderToolSnappingContainer = document.createElement('a');
        buttonRoadBuilderToolSnappingContainer.id = 'target-gpi-snapping-road-builder-tool';
        buttonRoadBuilderToolSnappingContainer.setAttribute('title', 'Snapping');
        buttonRoadBuilderToolSnappingContainer.setAttribute('style', 'display:none');

        const buttonRoadBuilderToolSnappingContent = document.createElement('div');
        buttonRoadBuilderToolSnappingContent.className = 'menu-icon';
        buttonRoadBuilderToolSnappingContent.innerHTML = '<i class="gpi gpi-snapping"></i>';

        buttonRoadBuilderToolSnappingContainer.appendChild(buttonRoadBuilderToolSnappingContent);
        buttonRoadBuilderToolSnapping.appendChild(buttonRoadBuilderToolSnappingContainer);

        /**
         * Snapping Handle
         */
        const handleRoadBuilerToolSnapping = function ()
        {
            // Set snapping button as active on menu
            $('#target-gpi-snapping-road-builder-tool').toggleClass('hold-single-button');

            // Update snapping status
            myRoadBuilderTool._mapSgs._snappingTool.update(!myRoadBuilderTool._mapSgs._snappingTool._isActive);
        };
        buttonRoadBuilderToolSnapping.addEventListener('click', handleRoadBuilerToolSnapping, false);
        buttonRoadBuilderToolSnapping.addEventListener('touchstart', handleRoadBuilerToolSnapping, false);

        // -- Road tool - Select road -------------------------------------------------------------
        const buttonRoadToolSelectRoad = document.createElement('li');
        buttonRoadToolSelectRoad.className = "border-right";

        const buttonRoadToolSelectRoadContainer = document.createElement('a');
        buttonRoadToolSelectRoadContainer.setAttribute('href', '#target-gpi-road-tool-select-road');
        buttonRoadToolSelectRoadContainer.id = 'target-gpi-road-tool-select-road';
        buttonRoadToolSelectRoadContainer.className = 'target';
        buttonRoadToolSelectRoadContainer.setAttribute('title', 'Selecionar arruamento');
        buttonRoadToolSelectRoadContainer.setAttribute('style', 'display:none');

        const buttonRoadToolSelectRoadContent = document.createElement('div');
        buttonRoadToolSelectRoadContent.className = 'menu-icon';
        buttonRoadToolSelectRoadContent.innerHTML = '<i class="gpi gpi-selecionar"></i>';

        buttonRoadToolSelectRoadContainer.appendChild(buttonRoadToolSelectRoadContent);
        buttonRoadToolSelectRoad.appendChild(buttonRoadToolSelectRoadContainer);

        /**
         * Select road buider tool Handle
         */
        const handleRoadToolSelectRoad = function ()
        {
            myRoadBuilderTool._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-road-tool-select-road');
            myRoadBuilderTool._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-road-tool-select-road');

            // Mode Road
            if($('#target-gpi-road-mode').hasClass('active'))
            {
                // Desactive draw police tool if active
                if(myRoadBuilderTool._hashActiveTool.drawPoliceNumber && myRoadBuilderTool._hashActiveTool.drawPoliceNumber.active)
                    myRoadBuilderTool._ActicePoliceDrawTool(myRoadBuilderTool._hashActiveTool.drawPoliceNumber.node, false);

                // Desactive draw road tool if active
                if(myRoadBuilderTool._hashActiveTool.drawRoad && myRoadBuilderTool._hashActiveTool.drawRoad.active)
                    myRoadBuilderTool._ActiveDrawRoadTool(myRoadBuilderTool._hashActiveTool.drawRoad.node, false);

                if($(this).hasClass('active'))
                    myRoadBuilderTool._ActiveSelectTool(this, false);
                else
                    myRoadBuilderTool._ActiveSelectTool(this, true);
            }
        };

        buttonRoadToolSelectRoad.addEventListener('click', handleRoadToolSelectRoad, false);
        buttonRoadToolSelectRoad.addEventListener('touchstart', handleRoadToolSelectRoad, false);

        // -- Draw sub road -----------------------------------------------------------------------
        //const buttonSubDrawRoad = document.createElement('li');

        //const buttonSubDrawRoadContainer = document.createElement('a');
        //buttonSubDrawRoadContainer.setAttribute('href', '#target-gpi-draw-sub-road');
        //buttonSubDrawRoadContainer.id = 'target-gpi-draw-sub-road';
        //buttonSubDrawRoadContainer.className = 'target small';
        //buttonSubDrawRoadContainer.setAttribute('title', 'adicionar troço');
        //buttonSubDrawRoadContainer.setAttribute('style', 'display:none');

        //const buttonSubDrawRoadContent = document.createElement('div');
        //buttonSubDrawRoadContent.className = 'menu-icon';
        //buttonSubDrawRoadContent.innerHTML = '<i class="gpi gpi-linha"></i>';

        //buttonSubDrawRoadContainer.appendChild(buttonSubDrawRoadContent);
        //buttonSubDrawRoad.appendChild(buttonSubDrawRoadContainer);

        ///**
        // * Draw line road handle
        // */
        //const handleDrawSubRoad = function ()
        //{
        //    toastr["warning"]("Funcionalidade ainda não disponível para o arruamento");
        //    return;

        //    // Desactive select tool if active
        //    if(myRoadBuilderTool._hashActiveTool.roadToolSelectRoad && myRoadBuilderTool._hashActiveTool.roadToolSelectRoad.active)
        //        myRoadBuilderTool._ActiveSelectTool(myRoadBuilderTool._hashActiveTool.roadToolSelectRoad.node, false);

        //    // Desactive split sub road tool if active
        //    if(myRoadBuilderTool._hashActiveTool.splitRoad && myRoadBuilderTool._hashActiveTool.splitRoad.active)
        //        myRoadBuilderTool._ActiveSplitSubRoadTool(myRoadBuilderTool._hashActiveTool.splitRoad.node, false);

        //    myRoadBuilderTool._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-draw-road');
        //    myRoadBuilderTool._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-draw-road');

        //    if($(this).hasClass('active'))
        //        myRoadBuilderTool._ActiveDrawRoadTool(this, false);
        //    else
        //        myRoadBuilderTool._ActiveDrawRoadTool(this, true);
        //};

        //buttonSubDrawRoad.addEventListener('click', handleDrawSubRoad, false);
        //buttonSubDrawRoad.addEventListener('touchstart', handleDrawSubRoad, false);

        // -- Road tool - split road --------------------------------------------------------------
        const buttonRoadToolSplitRoad = document.createElement('li');

        const buttonRoadToolSplitRoadContainer = document.createElement('a');
        buttonRoadToolSplitRoadContainer.setAttribute('href', '#target-gpi-road-tool-split-road');
        buttonRoadToolSplitRoadContainer.id = 'target-gpi-road-tool-split-road';
        buttonRoadToolSplitRoadContainer.className = 'target small';
        buttonRoadToolSplitRoadContainer.setAttribute('title', 'Separar arruamento');
        buttonRoadToolSplitRoadContainer.setAttribute('style', 'display:none');

        const buttonRoadToolSplitRoadContent = document.createElement('div');
        buttonRoadToolSplitRoadContent.className = 'menu-icon';
        buttonRoadToolSplitRoadContent.innerHTML = '<i class="material-icons" style="padding-top: 18px;">call_split</i>';

        buttonRoadToolSplitRoadContainer.appendChild(buttonRoadToolSplitRoadContent);
        buttonRoadToolSplitRoad.appendChild(buttonRoadToolSplitRoadContainer);

        /**
         * Select road buider tool Handle
         */
        const handleRoadToolSplitRoad = function ()
        {
            // If road hold button only if road selected
            if(myRoadBuilderTool._elementTypeForOperarion === "road" && !myRoadBuilderTool._CheckIfSplitToolActivation())
            {
                return;
            }

            // Desactive select tool if active
            //if(myRoadBuilderTool._hashActiveTool.roadToolSelectRoad && myRoadBuilderTool._hashActiveTool.roadToolSelectRoad.active)
            //    myRoadBuilderTool._ActiveSelectTool(myRoadBuilderTool._hashActiveTool.roadToolSelectRoad.node, false);

            // Desactive draw road tool if active
            if(myRoadBuilderTool._hashActiveTool.drawRoad && myRoadBuilderTool._hashActiveTool.drawRoad.active)
                myRoadBuilderTool._ActiveDrawRoadTool(myRoadBuilderTool._hashActiveTool.drawRoad.node, false);

            myRoadBuilderTool._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-road-tool-split-road');
            myRoadBuilderTool._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-road-tool-split-road');

            if($(this).hasClass('active'))
            {
                switch(myRoadBuilderTool._elementTypeForOperarion)
                {
                    case "road":
                        myRoadBuilderTool._ActiveSplitRoadTool(this, false);
                        break;
                    case "subroad":
                        myRoadBuilderTool._ActiveSplitSubRoadTool(this, false);
                        break;
                    default:
                        // do nothing
                }
            }
            else
            {
                switch(myRoadBuilderTool._elementTypeForOperarion)
                {
                    case "road":
                        myRoadBuilderTool._ActiveSplitRoadTool(this, true);
                        break;
                    case "subroad":
                        myRoadBuilderTool._ActiveSplitSubRoadTool(this, true);
                        break;
                    default:
                        // do nothing
                } 
            }
        };

        buttonRoadToolSplitRoad.addEventListener('click', handleRoadToolSplitRoad, false);
        buttonRoadToolSplitRoad.addEventListener('touchstart', handleRoadToolSplitRoad, false);

        // -- Road tool - merge Road -----------------------------------------------------------
        const buttonRoadToolMergeRoad = document.createElement('li');

        const buttonRoadToolMergeRoadContainer = document.createElement('a');
        buttonRoadToolMergeRoadContainer.id = 'target-gpi-road-tool-merge-sub-road';
        buttonRoadToolMergeRoadContainer.className = 'small';
        buttonRoadToolMergeRoadContainer.setAttribute('title', 'Fundir arruamento');
        buttonRoadToolMergeRoadContainer.setAttribute('style', 'display:none');

        const buttonRoadToolMergeRoadContent = document.createElement('div');
        buttonRoadToolMergeRoadContent.className = 'menu-icon';
        buttonRoadToolMergeRoadContent.innerHTML = '<i class="material-icons" style="padding-top: 18px;">call_merge</i>';

        buttonRoadToolMergeRoadContainer.appendChild(buttonRoadToolMergeRoadContent);
        buttonRoadToolMergeRoad.appendChild(buttonRoadToolMergeRoadContainer);

        /**
         * Select road buider tool Handle
         */
        const handleRoadToolMergeRoad = function ()
        {
            switch(myRoadBuilderTool._elementTypeForOperarion)
            {
                case "road":
                    // Mode save road from merge
                    myRoadBuilderTool._MergeRoad();
                    break;
                case "subroad":
                    // Mode save sub road from merge
                    myRoadBuilderTool._MergeSubRoad();
                    break;
                default:
                // do nothing
            }
        };

        buttonRoadToolMergeRoad.addEventListener('click', handleRoadToolMergeRoad, false);
        buttonRoadToolMergeRoad.addEventListener('touchstart', handleRoadToolMergeRoad, false);

        // -- Road Information --------------------------------------------------------------------
        const buttonRoadBuilderToolRoadInfo = document.createElement('li');

        const buttonRoadBuilderToolRoadInfoContainer = document.createElement('a');
        buttonRoadBuilderToolRoadInfoContainer.id = 'target-gpi-road-info-road-builder-tool';
        buttonRoadBuilderToolRoadInfoContainer.className = 'small';
        buttonRoadBuilderToolRoadInfoContainer.setAttribute('title', 'Obter informação');
        buttonRoadBuilderToolRoadInfoContainer.setAttribute('style', 'display:none');

        const buttonRoadBuilderToolRoadInfoContent = document.createElement('div');
        buttonRoadBuilderToolRoadInfoContent.className = 'menu-icon';
        buttonRoadBuilderToolRoadInfoContent.innerHTML = '<i class="fa fa-info"></i>';

        buttonRoadBuilderToolRoadInfoContainer.appendChild(buttonRoadBuilderToolRoadInfoContent);
        buttonRoadBuilderToolRoadInfo.appendChild(buttonRoadBuilderToolRoadInfoContainer);

        /**
         * Get information Handle
         */
        const handleRoadBuilerToolRoadInfo = function ()
        {
            myRoadBuilderTool._GetRoadInformation();
        };

        buttonRoadBuilderToolRoadInfo.addEventListener('click', handleRoadBuilerToolRoadInfo, false);
        buttonRoadBuilderToolRoadInfo.addEventListener('touchstart', handleRoadBuilerToolRoadInfo, false);

        // -- Road History --------------------------------------------------------------------
        const buttonRoadBuilderToolHistoryInfo = document.createElement('li');

        const buttonRoadBuilderToolHistoryInfoContainer = document.createElement('a');
        buttonRoadBuilderToolHistoryInfoContainer.id = 'target-gpi-road-info-road-history-tool';
        buttonRoadBuilderToolHistoryInfoContainer.className = 'small';
        buttonRoadBuilderToolHistoryInfoContainer.setAttribute('title', 'Obter histórico');
        buttonRoadBuilderToolHistoryInfoContainer.setAttribute('style', 'display:none');

        const buttonRoadBuilderToolHistoryInfoContent = document.createElement('div');
        buttonRoadBuilderToolHistoryInfoContent.className = 'menu-icon';
        buttonRoadBuilderToolHistoryInfoContent.innerHTML = '<i class="fa fa-history"></i>';

        buttonRoadBuilderToolHistoryInfoContainer.appendChild(buttonRoadBuilderToolHistoryInfoContent);
        buttonRoadBuilderToolHistoryInfo.appendChild(buttonRoadBuilderToolHistoryInfoContainer);

        /**
         * Get information Handle
         */
        const handleRoadBuilerToolHistoryInfo = function () {
            myRoadBuilderTool.getRoadHistory();
        };

        buttonRoadBuilderToolHistoryInfo.addEventListener('click', handleRoadBuilerToolHistoryInfo, false);
        buttonRoadBuilderToolHistoryInfo.addEventListener('touchstart', handleRoadBuilerToolHistoryInfo, false);

        // -- Road undo ---------------------------------------------------------------------------
        const buttonRoadBuilderToolUndoModify = document.createElement('li');

        const buttonRoadBuilderToolUndoModifyContainer = document.createElement('a');
        buttonRoadBuilderToolUndoModifyContainer.id = 'target-gpi-undo-modify-road-builder-tool';
        buttonRoadBuilderToolUndoModifyContainer.className = 'small';
        buttonRoadBuilderToolUndoModifyContainer.setAttribute('title', 'Undo');
        buttonRoadBuilderToolUndoModifyContainer.setAttribute('style', 'display:none');

        const buttonRoadBuilderToolUndoModifyContent = document.createElement('div');
        buttonRoadBuilderToolUndoModifyContent.className = 'menu-icon';
        buttonRoadBuilderToolUndoModifyContent.innerHTML = '<i class="fa fa-undo"></i>';

        buttonRoadBuilderToolUndoModifyContainer.appendChild(buttonRoadBuilderToolUndoModifyContent);
        buttonRoadBuilderToolUndoModify.appendChild(buttonRoadBuilderToolUndoModifyContainer);

        /**
         * Get information Handle
         */
        const handleRoadBuilerToolUndoModify = function ()
        {
            // Clean all road
            myRoadBuilderTool._CleanAllRoad();
            myRoadBuilderTool._UndoModify();
        };

        buttonRoadBuilderToolUndoModify.addEventListener('click', handleRoadBuilerToolUndoModify, false);
        buttonRoadBuilderToolUndoModify.addEventListener('touchstart', handleRoadBuilerToolUndoModify, false);

        // -- Delete road -------------------------------------------------------------------------
        const buttonRoadBuilderToolRoadDelete = document.createElement('li');

        const buttonRoadBuilderToolRoadDeleteContainer = document.createElement('a');
        buttonRoadBuilderToolRoadDeleteContainer.id = 'target-gpi-road-delete-road-builder-tool';
        buttonRoadBuilderToolRoadDeleteContainer.className = 'small';
        buttonRoadBuilderToolRoadDeleteContainer.setAttribute('title', 'Remover arruamento');
        buttonRoadBuilderToolRoadDeleteContainer.setAttribute('style', 'display:none');

        const buttonRoadBuilderToolRoadDeleteContent = document.createElement('div');
        buttonRoadBuilderToolRoadDeleteContent.className = 'menu-icon';
        buttonRoadBuilderToolRoadDeleteContent.innerHTML = '<i class="fa fa-trash"></i>';

        buttonRoadBuilderToolRoadDeleteContainer.appendChild(buttonRoadBuilderToolRoadDeleteContent);
        buttonRoadBuilderToolRoadDelete.appendChild(buttonRoadBuilderToolRoadDeleteContainer);

        /**
         * Delete road Handle
         */
        const handleRoadBuilerToolRoadDelete = function ()
        {
            myRoadBuilderTool._DeleteElementFirstStep();
        };

        buttonRoadBuilderToolRoadDelete.addEventListener('click', handleRoadBuilerToolRoadDelete, false);
        buttonRoadBuilderToolRoadDelete.addEventListener('touchstart', handleRoadBuilerToolRoadDelete, false);

        // --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
        // -- Police button ---------------------------------------------------------------------------------------------------------------------------------------------------------------
        // --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

        // -- Draw police number  -------------------------------------------------------------
        const buttonDrawPoliceNumber = document.createElement('li');
        buttonCloseRoadBuilderTool.className = "border-left";

        const buttonDrawPoliceNumberContainer = document.createElement('a');
        buttonDrawPoliceNumberContainer.setAttribute('href', '#target-gpi-draw-police-number');
        buttonDrawPoliceNumberContainer.id = 'target-gpi-draw-police-number';
        buttonDrawPoliceNumberContainer.className = 'target';
        buttonDrawPoliceNumberContainer.setAttribute('title', 'Marcar número de policia');
        buttonDrawPoliceNumberContainer.setAttribute('style', 'display:none');

        const buttonDrawPoliceNumberContent = document.createElement('div');
        buttonDrawPoliceNumberContent.className = 'menu-icon';
        buttonDrawPoliceNumberContent.innerHTML = '<i class="gpi gpi-ponto"></i>';

        buttonDrawPoliceNumberContainer.appendChild(buttonDrawPoliceNumberContent);
        buttonDrawPoliceNumber.appendChild(buttonDrawPoliceNumberContainer);

        /**
         * Draw police number handle
         */
        const handleDrawPoliceNumber = function ()
        {
            // Desactive select tool if active
            if(myRoadBuilderTool._hashActiveTool.policeToolSelect && myRoadBuilderTool._hashActiveTool.policeToolSelect.active)
                myRoadBuilderTool._ActiveSelectTool(myRoadBuilderTool._hashActiveTool.policeToolSelect.node, false);

            // Desactive select by polygon tool if active
            if(myRoadBuilderTool._hashActiveTool.policeToolSelectByPolygon && myRoadBuilderTool._hashActiveTool.policeToolSelectByPolygon.active)
                myRoadBuilderTool._ActiveSelectPoliceNumberByPolygonTool(myRoadBuilderTool._hashActiveTool.policeToolSelectByPolygon.node, false);

            myRoadBuilderTool._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-draw-police-number');
            myRoadBuilderTool._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-draw-police-number');

            if($(this).hasClass('active'))
                myRoadBuilderTool._ActicePoliceDrawTool(this, false);
            else
                myRoadBuilderTool._ActicePoliceDrawTool(this, true);

            // Register active tool
            myRoadBuilderTool._hashActiveTool.drawPoliceNumber = {
                active: $(this).hasClass('active'),
                node: this
            }
        };

        buttonDrawPoliceNumber.addEventListener('click', handleDrawPoliceNumber, false);
        buttonDrawPoliceNumber.addEventListener('touchstart', handleDrawPoliceNumber, false);

        // -- Select section for police number ----------------------------------------------------
        const buttonPoliceToolSelect = document.createElement('li');

        const buttonPoliceToolSelectContainer = document.createElement('a');
        buttonPoliceToolSelectContainer.setAttribute('href', '#target-gpi-police-tool-select');        
        buttonPoliceToolSelectContainer.id = 'target-gpi-police-tool-select';
        buttonPoliceToolSelectContainer.className = 'target';
        buttonPoliceToolSelectContainer.setAttribute('title', 'Selecionar troço ou número de polícia');
        buttonPoliceToolSelectContainer.setAttribute('style', 'display:none');

        const buttonPoliceToolSelectContent = document.createElement('div');
        buttonPoliceToolSelectContent.className = 'menu-icon';
        buttonPoliceToolSelectContent.innerHTML = '<i class="gpi gpi-selecionar"></i>';

        buttonPoliceToolSelectContainer.appendChild(buttonPoliceToolSelectContent);
        buttonPoliceToolSelect.appendChild(buttonPoliceToolSelectContainer);

        /**
         * Select road buider tool Handle
         */
        const handlePoliceToolSelect = function ()
        {
            myRoadBuilderTool._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-police-tool-select');
            myRoadBuilderTool._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-police-tool-select');

            // Mode police
            if($('#target-gpi-police-mode').hasClass('active'))
            {
                // Desactive draw police tool if active
                if(myRoadBuilderTool._hashActiveTool.drawPoliceNumber && myRoadBuilderTool._hashActiveTool.drawPoliceNumber.active)
                    myRoadBuilderTool._ActicePoliceDrawTool(myRoadBuilderTool._hashActiveTool.drawPoliceNumber.node, false);

                // Desactive select by polygon tool if active
                if(myRoadBuilderTool._hashActiveTool.policeToolSelectByPolygon && myRoadBuilderTool._hashActiveTool.policeToolSelectByPolygon.active)
                    myRoadBuilderTool._ActiveSelectPoliceNumberByPolygonTool(myRoadBuilderTool._hashActiveTool.policeToolSelectByPolygon.node, false);

                if($(this).hasClass('active'))
                    myRoadBuilderTool._ActiveSelectTool(this, false);
                else
                {
                    // Active layer police
                    var layerInfoPolice = myRoadBuilderTool._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName(myRoadBuilderTool._layerSourceNamePoliceNumber)[0];
                    myRoadBuilderTool._mapSgs.layerTree.layerTreeObj.check(myRoadBuilderTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfoPolice.id.toString()));

                    // Clear all subroad and police number selected
                    myRoadBuilderTool._layerSubRoadPoliceSelected.getSource().clear();
                    myRoadBuilderTool._layerPoliceAssociateToSubRoadSelected.getSource().clear();

                    // Select subroad
                    myRoadBuilderTool._elementTypeForOperarion = "subroad";
                    myRoadBuilderTool._ActiveSelectTool(this, true);
                }
            }

            // Register active tool
            myRoadBuilderTool._hashActiveTool.policeToolSelect = {
                active: $(this).hasClass('active'),
                node: this
            }
        };

        buttonPoliceToolSelect.addEventListener('click', handlePoliceToolSelect, false);
        buttonPoliceToolSelect.addEventListener('touchstart', handlePoliceToolSelect, false);

        // -- Select police number by polygon -----------------------------------------------------
        const buttonPoliceToolSelectPolygon = document.createElement('li');

        const buttonPoliceToolSelectPolygonContainer = document.createElement('a');
        buttonPoliceToolSelectPolygonContainer.setAttribute('href', '#target-gpi-police-tool-select-by-polygon');        
        buttonPoliceToolSelectPolygonContainer.id = 'target-gpi-police-tool-select-by-polygon';
        buttonPoliceToolSelectPolygonContainer.className = 'target';
        buttonPoliceToolSelectPolygonContainer.setAttribute('title', 'Selecionar números de polícia por polígno');
        buttonPoliceToolSelectPolygonContainer.setAttribute('style', 'display:none');

        const buttonPoliceToolSelectPolygonContent = document.createElement('div');
        buttonPoliceToolSelectPolygonContent.className = 'menu-icon';
        buttonPoliceToolSelectPolygonContent.innerHTML = '<i class="gpi gpi-poligono"></i>';

        buttonPoliceToolSelectPolygonContainer.appendChild(buttonPoliceToolSelectPolygonContent);
        buttonPoliceToolSelectPolygon.appendChild(buttonPoliceToolSelectPolygonContainer);

        /**
         * Select police number by polygon handle
         */
        const handlePoliceToolSelectPolygon = function ()
        {
            myRoadBuilderTool._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-police-tool-select-by-polygon');
            myRoadBuilderTool._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-police-tool-select-by-polygon');

            // Mode police
            if($('#target-gpi-police-mode').hasClass('active'))
            {
                // Desactive draw police tool if active
                if(myRoadBuilderTool._hashActiveTool.drawPoliceNumber && myRoadBuilderTool._hashActiveTool.drawPoliceNumber.active)
                    myRoadBuilderTool._ActicePoliceDrawTool(myRoadBuilderTool._hashActiveTool.drawPoliceNumber.node, false);

                // Desactive select tool if active
                if(myRoadBuilderTool._hashActiveTool.policeToolSelect && myRoadBuilderTool._hashActiveTool.policeToolSelect.active)
                    myRoadBuilderTool._ActiveSelectTool(myRoadBuilderTool._hashActiveTool.policeToolSelect.node, false, this);

                if($(this).hasClass('active'))
                {
                    // Desactive tool
                    myRoadBuilderTool._ActiveSelectPoliceNumberByPolygonTool(this, false);
                }
                else
                {
                    if(myRoadBuilderTool._layerSubRoadPoliceSelected.getSource().getFeatures().length !== 1)
                    {
                        // set warning msg
                        if (myRoadBuilderTool._layerSubRoadPoliceSelected.getSource().getFeatures().length === 0) {
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["warning"]("Seleccione primeiro um troço");
                            toastr.options.positionClass = 'toast-bottom-center';
                        }
                        else {
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["warning"]("Seleccione apenas um troço");
                            toastr.options.positionClass = 'toast-bottom-center';
                        }

                        // Remove self hold button
                        myRoadBuilderTool._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-police-tool-select-by-polygon');
                        myRoadBuilderTool._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-police-tool-select-by-polygon');

                        return;
                    }

                    // Actice tool
                    myRoadBuilderTool._ActiveSelectPoliceNumberByPolygonTool(this, true);
                }
            }

            // Register active tool
            myRoadBuilderTool._hashActiveTool.policeToolSelectByPolygon = {
                active: $(this).hasClass('active'),
                node: this
            }
        };

        buttonPoliceToolSelectPolygon.addEventListener('click', handlePoliceToolSelectPolygon, false);
        buttonPoliceToolSelectPolygon.addEventListener('touchstart', handlePoliceToolSelectPolygon, false);

        // --  Select police number by polygon - submit -------------------------------------------
        const buttonPoliceToolSelectPolygonSubmit = document.createElement('li');

        const buttonPoliceToolSelectPolygonSubmitContainer = document.createElement('a');
        buttonPoliceToolSelectPolygonSubmitContainer.setAttribute('href', '#target-gpi-police-tool-select-by-polygon-submit');
        buttonPoliceToolSelectPolygonSubmitContainer.id = 'target-gpi-police-tool-select-by-polygon-submit';
        buttonPoliceToolSelectPolygonSubmitContainer.className = 'target small';
        buttonPoliceToolSelectPolygonSubmitContainer.setAttribute('title', 'Associar os números de policia ao troço seleccionado');
        buttonPoliceToolSelectPolygonSubmitContainer.setAttribute('style', 'display:none');

        const buttonPoliceToolSelectPolygonSubmitContent = document.createElement('div');
        buttonPoliceToolSelectPolygonSubmitContent.className = 'menu-icon';
        buttonPoliceToolSelectPolygonSubmitContent.innerHTML = '<i class="fa fa-check"></i>';

        buttonPoliceToolSelectPolygonSubmitContainer.appendChild(buttonPoliceToolSelectPolygonSubmitContent);
        buttonPoliceToolSelectPolygonSubmit.appendChild(buttonPoliceToolSelectPolygonSubmitContainer);

        /**
         * Submit police number to the subroad selected Handle
         */
        const handlePoliceToolSelectPolygonSubmit = function ()
        {
            myRoadBuilderTool._AssociatePoliceNumberToSubRoad();
        };

        buttonPoliceToolSelectPolygonSubmit.addEventListener('click', handlePoliceToolSelectPolygonSubmit, false);
        buttonPoliceToolSelectPolygonSubmit.addEventListener('touchstart', handlePoliceToolSelectPolygonSubmit, false);

        // --  Select police number by polygon - clean --------------------------------------------
        const buttonPoliceToolSelectPolygonClean = document.createElement('li');

        const buttonPoliceToolSelectPolygonCleanContainer = document.createElement('a');
        buttonPoliceToolSelectPolygonCleanContainer.setAttribute('href', '#target-gpi-police-tool-select-by-polygon-clean');
        buttonPoliceToolSelectPolygonCleanContainer.id = 'target-gpi-police-tool-select-by-polygon-clean';
        buttonPoliceToolSelectPolygonCleanContainer.className = 'target small';
        buttonPoliceToolSelectPolygonCleanContainer.setAttribute('title', 'Remover selecção');
        buttonPoliceToolSelectPolygonCleanContainer.setAttribute('style', 'display:none');

        const buttonPoliceToolSelectPolygonCleanContent = document.createElement('div');
        buttonPoliceToolSelectPolygonCleanContent.className = 'menu-icon';
        buttonPoliceToolSelectPolygonCleanContent.innerHTML = '<i class="fa fa-eraser"></i>';

        buttonPoliceToolSelectPolygonCleanContainer.appendChild(buttonPoliceToolSelectPolygonCleanContent);
        buttonPoliceToolSelectPolygonClean.appendChild(buttonPoliceToolSelectPolygonCleanContainer);

        /**
         * Submit police number to the subroad selected Handle
         */
        const handlePoliceToolSelectPolygonClean = function ()
        {
            myRoadBuilderTool._CleanSelectPoliceNumberByPolygonTool();
        };

        buttonPoliceToolSelectPolygonClean.addEventListener('click', handlePoliceToolSelectPolygonClean, false);
        buttonPoliceToolSelectPolygonClean.addEventListener('touchstart', handlePoliceToolSelectPolygonClean, false);

        // --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
        // -- Build Menu ------------------------------------------------------------------------------------------------------------------------------------------------------------------
        // --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

        // -- Main menu bar road builder tool -------------------------------------------------
        const mainMenuRoadBuilderTool = document.createElement('ul');
        mainMenuRoadBuilderTool.id = 'main-menu-road-builder-tool';
        mainMenuRoadBuilderTool.className = 'map-controls menubar-bottom';

        mainMenuRoadBuilderTool.appendChild(buttonRoadMode);
        mainMenuRoadBuilderTool.appendChild(buttonPoliceMode);
        mainMenuRoadBuilderTool.appendChild(buttonToggleRoadOption);
        mainMenuRoadBuilderTool.appendChild(buttonDrawRoad);
        mainMenuRoadBuilderTool.appendChild(buttonDrawPoliceNumber);
        mainMenuRoadBuilderTool.appendChild(buttonRoadBuilderToolSnapping);
        mainMenuRoadBuilderTool.appendChild(buttonPoliceToolSelect);
        mainMenuRoadBuilderTool.appendChild(buttonPoliceToolSelectPolygon);
        mainMenuRoadBuilderTool.appendChild(buttonPoliceToolSelectPolygonSubmit);
        mainMenuRoadBuilderTool.appendChild(buttonPoliceToolSelectPolygonClean);
        mainMenuRoadBuilderTool.appendChild(buttonRoadToolSelectRoad);
        //mainMenuRoadBuilderTool.appendChild(buttonSubDrawRoad);
        mainMenuRoadBuilderTool.appendChild(buttonRoadToolSplitRoad);
        mainMenuRoadBuilderTool.appendChild(buttonRoadToolMergeRoad);
        mainMenuRoadBuilderTool.appendChild(buttonRoadBuilderToolRoadInfo);
        mainMenuRoadBuilderTool.appendChild(buttonRoadBuilderToolHistoryInfo);
        mainMenuRoadBuilderTool.appendChild(buttonRoadBuilderToolUndoModify);
        mainMenuRoadBuilderTool.appendChild(buttonRoadBuilderToolRoadDelete);
        mainMenuRoadBuilderTool.appendChild(buttonCleanRoadBuilderTool);
        mainMenuRoadBuilderTool.appendChild(buttonSubmitRoadBuilderTool);
        mainMenuRoadBuilderTool.appendChild(buttonCloseRoadBuilderTool);

        // -- Menu panel road builder tool ----------------------------------------------------
        const menuPanelRoadBuilderTool = document.createElement('div');
        menuPanelRoadBuilderTool.appendChild(mainMenuRoadBuilderTool);

        return menuPanelRoadBuilderTool;
    }

    /**
     * Save alfanumeric information from a police number
     * @param{int} id, police number identifier
     */
    this.SaveAlfaPoliceNumber = function(id)
    {
        var fieldForm = $('#id-form-edit-layer-detail-field').serializeJSON();
        var nPoliceObj = {
            objectid: id,
            pol_cod: fieldForm.POL_COD,
            pol_desig: fieldForm.POL_DESIG,
            utilizacao: $('#prop_id_UTILIZACAO').val(),
            npiso: fieldForm.NPISOS,
            piso: fieldForm.PISO,
            pol_reg_user: myRoadBuilderTool._mapSgs._settings.userInfo.userName
        }

        $.ajax({
            type: 'POST',
            url: '/rest/app/RoadBuilderTool/SaveAlfaPoliceNumber',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(nPoliceObj),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na gravação do número de polícia");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Close edition
                            myRoadBuilderTool._mapSgs.layerTree.CloseEdition(false);

                            // Refresh police number layer
                            var layerInfo = myRoadBuilderTool._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName(myRoadBuilderTool._layerSourceNamePoliceNumber)[0];
                            var layer = myRoadBuilderTool._mapSgs._utility.GetLayerByName(myRoadBuilderTool._mapSgs.map, layerInfo.layerNameKey);
                            layer.getSource().clear();

                            toastr.options.positionClass = 'toast-top-center';
                            toastr["success"]("Número de polícia gravado com sucesso");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na gravação do número de polícia");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                    }
                }

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na gravação do número de polícia");
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Style for select road
     */
    this._styleSelectAllSubRoadFromRoad = function (feature)
    {
        // randon color
        var colorRandom = 'rgba(' + Math.round((Math.random()*(255 - 0) + 0)) + ', ' + Math.round((Math.random()*(255 - 0) + 0)) + ', ' + Math.round((Math.random()*(255 - 0) + 0)) + ', 1)';

        return [
            new Style({
                stroke: new Stroke({
                    color: 'rgba(0, 0, 255, 0.5)',
                    width: 8
                })
            }),
            new Style({
                stroke: new Stroke({
                    color: colorRandom, //'rgba(255, 255, 0, 1)',
                    width: 3
                })
            }),
            new Style({
                stroke: new Stroke({
                    color: 'rgba(255, 0, 0, 1)',
                    width: 2
                })
            }),
            new Style({
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 1
                })
            }),
            new Style({
                text: new Text({
                    font: 'normal 14px Calibri', //"Verdana", "Open Sans", "Arial Unicode MS", "sans-serif"', //font: '12px Calibri,sans-serif',
                    placement: 'line',
                    overflow: true,
                    fill: new Fill({
                        color: "rgba(255, 255, 255, 1)"
                    }),
                    stroke: new Stroke({
                        color: "rgba(0, 0, 0, 1)",
                        width: 3
                    }),
                    textBaseline: 'bottom',
                    offsetY: -2,
                    text: feature.getProperties().TROCO
                })
            })
        ];
    };

    /**
     * Style for select split road
     */
    this._styleSelectAllSubRoadFromSplitRoad = function (feature)
    {
        // randon color
        var colorRandom = 'rgba(' + Math.round((Math.random()*(255 - 0) + 0)) + ', ' + Math.round((Math.random()*(255 - 0) + 0)) + ', ' + Math.round((Math.random()*(255 - 0) + 0)) + ', 0.5)';

        return [
            new Style({
                stroke: new Stroke({
                    color: colorRandom,
                    width: 14
                })
            })
        ];
    };

    /**
     * Split road
     */
    this._SplitRoad = function()
    {
        if (myRoadBuilderTool._selectedFeaturesSplitRoad.getArray().length == 0) {
            toastr.options.positionClass = 'toast-top-center';
            toastr["warning"]("Nenhum troço da rua seleccionado");
            toastr.options.positionClass = 'toast-bottom-center';
            return;
        }

        // Start wait
        myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Get road identifier
        var idRoad = myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures()[0].getProperties().ARR_SEQ;

        // Mode save sub road
        myRoadBuilderTool._modeSaveSubRoad = "split_road";

        $.ajax({
            type: 'GET',
            url: '/rest/app/RoadBuilderTool/GetRoadInformation?arrSeq=' + idRoad,
            contentType: "application/json",
            dataType: 'json',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na obtenção de informação de arruamento");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Clean form
                            myRoadBuilderTool._CleanFormRoad();

                            // Active read in subroad
                            myRoadBuilderTool._ActiveForWriteOrReadFormRoad("subroad", true);

                            // Active write in road
                            myRoadBuilderTool._ActiveForWriteOrReadFormRoad("road", false);

                            // Get subroad information only by the subroad selected
                            var hashSubroadFreguesia = {};
                            var listSubroad = [];
                            var lengthRoad = 0;
                            for(var p = 0; p < myRoadBuilderTool._selectedFeaturesSplitRoad.getArray().length; p++)
                            {
                                var feature = myRoadBuilderTool._selectedFeaturesSplitRoad.getArray()[p];
                                var idSubroad = feature.getProperties().IDTROCO;
                                lengthRoad += Math.round(feature.getGeometry().getLength()*100)/100;

                                // Set freguesia information by subroad selected
                                hashSubroadFreguesia[idSubroad] = data.result.hash_sub_road_freguesia[idSubroad];

                                // Set subroad information by subroad selected
                                listSubroad.push(data.result.list_sub_road.find(c => c.id_troco == idSubroad));
                            }

                            // Set length road
                            data.result.road.length = lengthRoad;

                            // Set list freguesia
                            var listFreguesiaRoad = [];
                            var hashDtccfr = {};

                            for(var o = 0; o < Object.keys(hashSubroadFreguesia).length; o++)
                            {
                                var arraySubroad = hashSubroadFreguesia[Object.keys(hashSubroadFreguesia)[o]];
                                
                                for(var d = 0; d < arraySubroad.length; d++)
                                {
                                    var subroadFreguesiaInfo = arraySubroad[d];
                                    var dtccfr = subroadFreguesiaInfo.dtccfr;

                                    var freguesiaRoad = data.result.list_freguesia_road.find(c=> c.dtccfr == subroadFreguesiaInfo.dtccfr);
                                    if( freguesiaRoad != undefined)
                                    {
                                        if(hashDtccfr[subroadFreguesiaInfo.dtccfr] == undefined)
                                        {
                                            listFreguesiaRoad.push(freguesiaRoad);
                                            hashDtccfr[subroadFreguesiaInfo.dtccfr] = 1;
                                        }
                                    }
                                }
                            }

                            // Title
                            $('#id-modal-road-build-tool-road-header-title')[0].innerHTML = 'Criação de novo Arruamento';

                            // Reset all active tab
                            $('#id-modal-road-build-tool-road-sub-road-info-li').parent().parent().find('li').removeClass('active');
                            $('#id-modal-road-build-tool-road-content .tab-pane').removeClass('active');

                            // Active tab edit sub road
                            $('#id-modal-road-build-tool-road-sub-road-info-li').parent().hide();

                            // Show and active tab road
                            $('#id-modal-road-build-tool-road-info-li').parent().show();
                            $('#id-modal-road-build-tool-road-info-li').parent().addClass('active');
                            $('#id-modal-road-build-tool-road-info').addClass('active');
                            $('#id-modal-road-build-tool-road-info-li').attr('title', 'Informação Geral');
                            $('#id-modal-road-build-tool-road-info-li')[0].innerHTML = 'Informação Geral';

                            // Active tab road detail
                            $('#id-modal-road-build-tool-road-info-detail-li').parent().show();
                            $('#id-modal-road-build-tool-road-info-detail-li').attr('title', 'Informação de detalhe');
                            $('#id-modal-road-build-tool-road-info-detail-li')[0].innerHTML = 'Informação de detalhe';

                            // Title tab list subroad
                            $('#id-modal-road-build-tool-road-list-sub-road-info-li').parent().show();
                            $('#id-modal-road-build-tool-road-list-sub-road-info-li').attr('title', 'Informação de troços');
                            $('#id-modal-road-build-tool-road-list-sub-road-info-li')[0].innerHTML = 'Informação de troços';

                            // Title tab road detail
                            $('#id-modal-road-build-tool-road-info-road-intersect-li').parent().hide();

                            // Fill button title save
                            $('#id-modal-road-build-tool-road-save').attr("title", "Gravar arruamento seleccionado");

                            // Fill form subroad info
                            //myRoadBuilderTool._FillForm(data.result.sub_road, 'id-modal-road-build-tool-road-sub-road-info-form');

                            // Fill road information
                            myRoadBuilderTool._FillForm(data.result.road, 'id-modal-road-build-tool-road-info-form');

                            // Fill road freguesia information
                            for(var i = 0; i < listFreguesiaRoad.length; i++)
                            {
                                var objRoadFreguesia = listFreguesiaRoad[i];

                                myRoadBuilderTool._hashTableFreguesia["road"].row.add({
                                    id_freguesia: objRoadFreguesia.id_freguesia,
                                    freguesia: objRoadFreguesia.freguesia,
                                    dtccfr: objRoadFreguesia.dtccfr
                                });
                                myRoadBuilderTool._hashTableFreguesia["road"].draw();
                            }

                            // Fill road detail information
                            myRoadBuilderTool._FillForm(data.result.road, 'id-modal-road-build-tool-road-info-detail-form');

                            // Fill subroad information
                            myRoadBuilderTool._BuildListSubRoadInformation(listSubroad, hashSubroadFreguesia, -1);

                            // Show modal
                            $('#id-modal-road-build-tool-road').show();

                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na obtenção de informação de arruamento");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                    }
                }

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na obtenção de informação de arruamento");
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /**
     * Split subroad
     */
    this._SplitSubRoadGeometry = function()
    {
        // Start wait
        myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', true);

        $.ajax({
            type: 'POST',
            url: '/rest/app/RoadBuilderTool/_SplitSubRoadGeometry',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(myRoadBuilderTool._splitSubRoadInfo.newSubRoadRoad),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na separação do troço");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Desactive split if exists
                            myRoadBuilderTool._ActiveSplitSubRoadTool(myRoadBuilderTool._hashActiveTool.splitRoad.node, false);

                            // Refresh layer road
                            myRoadBuilderTool._RefreshLayerRoad();

                            toastr.options.positionClass = 'toast-top-center';
                            toastr["success"]("Troço separado com sucesso");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na separação do troço");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                    }
                }

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na separação do troço");
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /**
     * Update subroad geometry
     */
    this._UpdateSubRoadGeometry = function()
    {
        // Start wait
        myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', true);

        $.ajax({
            type: 'POST',
            url: '/rest/app/RoadBuilderTool/_UpdateSubRoadGeometry',
            xhrFields: {
                withCredentials: true
            },
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(myRoadBuilderTool._updateSubRoadInfo),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro de gravação");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Desactive modify if exists
                            myRoadBuilderTool._ClearModify();

                            // Clean Select
                            myRoadBuilderTool._CleanSelect();

                            // Refresh layer road
                            myRoadBuilderTool._RefreshLayerRoad();

                            // Clean all
                            myRoadBuilderTool._CleanAllRoad();

                            toastr.options.positionClass = 'toast-top-center';
                            toastr["success"]("Geometria alterada com sucesso");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                        case "ROAD_NOT_CONTINOUS":
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["warning"]("Arruamento com geometria descontinua");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro de gravação");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                    }
                }

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro de gravação");
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /**
     * Undo modify
     */
    this._UndoModify = function()
    {
        // Clear modify
        myRoadBuilderTool._ClearModify();

        // Clean Select
        myRoadBuilderTool._CleanSelect();

        // Refresh layer road
        myRoadBuilderTool._RefreshLayerRoad();
    }

    /**
     * Undo modify
     */
    this._UndoModify2 = function () {
        // Clear modify
        myRoadBuilderTool._ClearModify2();

        // Clean Select
        myRoadBuilderTool._CleanSelect();

        // Refresh layer road
        //myRoadBuilderTool._RefreshLayerRoad();
    }

    /**
     * Active toggle road option
     */
    this._ActiveOptionRoad = function()
    {
        $('#target-toggle-option-road-builder-tool').toggleClass('road subroad');

        // Remove selection of a subroad
        if(myRoadBuilderTool._hashActiveTool.roadToolSelectRoad && myRoadBuilderTool._hashActiveTool.roadToolSelectRoad.active)
        {
            myRoadBuilderTool._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-road-tool-select-road');
            myRoadBuilderTool._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-road-tool-select-road');
            myRoadBuilderTool._ActiveSelectTool(myRoadBuilderTool._hashActiveTool.roadToolSelectRoad.node, false);
        }

        // Type element road for operation
        if($('#target-toggle-option-road-builder-tool').hasClass('road'))
        {
            // Close split sub road if active
            if ($('#target-gpi-road-tool-split-road').parent().hasClass("active")) {
                $('#target-gpi-road-tool-split-road')[0].click();
            }

            $('#target-toggle-option-road-builder-tool span')[0].innerHTML = 'Rua';
            myRoadBuilderTool._elementTypeForOperarion = "road";

            // Change title button
            $('#target-gpi-road-tool-select-road').attr('title', 'Selecionar arruamento');
            $('#target-gpi-road-tool-split-road').attr('title', 'Separar arruamento');
            $('#target-gpi-road-tool-merge-sub-road').attr('title', 'Fundir arruamento');
            $('#target-gpi-road-delete-road-builder-tool').attr('title', 'Remover arruamento');

            // show draw road
            $('#target-gpi-draw-road').show("slide");

            // If select road is active show draw sub road
            //if($('#target-gpi-road-tool-select-road').hasClass('hold-button'))
            //    $('#target-gpi-draw-sub-road').show("slide");
        }

        // Type element subroad for operation
        if($('#target-toggle-option-road-builder-tool').hasClass('subroad'))
        {
            // Close draw interaction if active
            if ($('#target-gpi-draw-road').parent().hasClass("active")) { //$('#target-gpi-road-mode').hasClass('active')) {
                $('#target-gpi-draw-road')[0].click();
            }

            // Close split road if active
            if ($('#target-gpi-road-tool-split-road').parent().hasClass("active")) {
                $('#target-gpi-road-tool-split-road')[0].click();
            }

            $('#target-toggle-option-road-builder-tool span')[0].innerHTML = 'Troço';
            myRoadBuilderTool._elementTypeForOperarion = "subroad";

            // Change title button
            $('#target-gpi-road-tool-select-road').attr('title', 'Selecionar troço');
            $('#target-gpi-road-tool-split-road').attr('title', 'Separar troço');
            $('#target-gpi-road-tool-merge-sub-road').attr('title', 'Fundir troço');
            $('#target-gpi-road-delete-road-builder-tool').attr('title', 'Remover troço');

            // Close draw sub road - Sub road are draw um road mode because only can create sub road in the edge of the road
            $('#target-gpi-draw-sub-road').hide("slide");

            // Close draw road
            $('#target-gpi-draw-road').hide("slide");

            // Remove multi selection road
            myRoadBuilderTool._shiftPressed = false;
            $('#target-gpi-road-tool-select-road').removeClass('select-multi');
        }

        // Clean road tool
        if ($('#target-gpi-road-mode').hasClass('active')) {
            // Clean road
            // If split road active clean only split road
            if (myRoadBuilderTool._hashActiveTool.splitRoad && myRoadBuilderTool._hashActiveTool.splitRoad.active) {
                myRoadBuilderTool._CleanSplitRoad();
                return;
            }

            // Clean all road
            myRoadBuilderTool._CleanAllRoad();

            // If draw road active reactive draw
            if (myRoadBuilderTool._hashActiveTool.drawRoad && myRoadBuilderTool._hashActiveTool.drawRoad.active)
                myRoadBuilderTool._drawLineRoad.setActive(true);
        }

        // Clear highlight
        myRoadBuilderTool._mapSgs.layerHighlightOverlay.getSource().clear();

        // Clean selection
        myRoadBuilderTool._CleanSelect();
    }

    /**
     * Actice police draw tool
     * @param {dom} element, node element of the button (li)
     * @param {boolean} active, true active tool otherwise desactive 
     */
    this._ActicePoliceDrawTool = function(element, active)
    {                
        // Clean all police number
        myRoadBuilderTool._CleanAllPolice();
                
        // Desactive interaction
        myRoadBuilderTool._drawPointPolice.setActive(false);

        // Clear Info feature
        $('#offcanvas-info').removeClass('show');

        // Desactice tool
        if(!active)
        {
            $(element).removeClass('active');
            $(element).find('a').removeClass('hold-button');

            // Remove interaction
            myRoadBuilderTool._drawPointPolice.setActive(false);

            // Reset cursor
            document.body.style.cursor = 'default';

            // Active tooltip
            if(myRoadBuilderTool._mapSgs.tooltips)
                myRoadBuilderTool._mapSgs.map.on('singleclick', async (e) => { await myRoadBuilderTool._mapSgs.tooltips.BuildInfoTooltips(e); });

            // Hide submit button
            $('#target-gpi-submit-road-builder-tool').hide("slide");
        }
        else { // Active tool
            $(element).addClass('active');

            // Active interaction
            myRoadBuilderTool._drawPointPolice.setActive(true);

            // Set cursor
            document.body.style.cursor = 'crosshair';

            // Desactive interaction
            if(myRoadBuilderTool._mapSgs.tooltips)
                myRoadBuilderTool._mapSgs.map.un('singleclick', myRoadBuilderTool._mapSgs.tooltips.BuildInfoTooltips);

            // Show button submit
            $('#target-gpi-submit-road-builder-tool').show("slide");
        }

        // Register active tool
        myRoadBuilderTool._hashActiveTool.drawPoliceNumber = {
            active: active,
            node: element
        }
    }

    /**
     * Active select tool
     * @param {dom} element, node element of the button (li)
     * @param {boolean} active, true active tool otherwise desactive
     * @param {dom} nextElement, next node to be active
     */
    this._ActiveSelectTool = function (element, active, nextElement)
    {
        // Desactive tool
        if(!active)
        {
            $(element).removeClass('active');
            $(element).find('a').removeClass('hold-button');

            // Desactive interaction road select
            myRoadBuilderTool._select.setActive(false);
            myRoadBuilderTool._dragBox.setActive(false);
            
            // Reset event layer tooltips
            if(myRoadBuilderTool._mapSgs.tooltips)
                myRoadBuilderTool._mapSgs.map.on('singleclick', async (e) => { await myRoadBuilderTool._mapSgs.tooltips.BuildInfoTooltips(e); });
                        
            // Reset cursor
            document.body.style.cursor = 'default';

            // Clear selection
            myRoadBuilderTool._ClearSelect();
            myRoadBuilderTool._ClearModify();
            if($('#target-gpi-road-mode').hasClass('active'))
            {
                myRoadBuilderTool._ClearSelectionRoad();
            }
            if($('#target-gpi-police-mode').hasClass('active'))
            {
                if(nextElement !== undefined && $(nextElement).find('a')[0].id === 'target-gpi-police-tool-select-by-polygon')
                {
                    myRoadBuilderTool._mapSgs.layerHighlightOverlay.getSource().clear();
                }
                else
                {
                    myRoadBuilderTool._ClearSelectionRoad();
                }
            }
            
            // Only on road mode
            if($('#target-gpi-road-mode').hasClass('active'))
            {
                //$('#target-gpi-draw-sub-road').hide("slide");
                $('#target-gpi-road-tool-split-road').hide("slide");
                $('#target-gpi-road-tool-merge-sub-road').hide("slide");
                $('#target-gpi-road-info-road-builder-tool').hide("slide");
                $('#target-gpi-road-info-road-history-tool').hide("slide");
                $('#target-gpi-undo-modify-road-builder-tool').hide("slide");
                $('#target-gpi-road-delete-road-builder-tool').hide("slide");
                //$('#target-gpi-draw-sub-road').hide("slide");               
                $('#target-gpi-police-tool-select-by-polygon-submit').hide("slide");
                $('#target-gpi-police-tool-select-by-polygon-clean').hide("slide");
            }
        }
        else { // Active tool
            $(element).addClass('active');

            // Set selection 
            myRoadBuilderTool._ActiveSelectRoad();

            // Remove event layer tooltips
            if(myRoadBuilderTool._mapSgs.tooltips)
                myRoadBuilderTool._mapSgs.map.un('singleclick', myRoadBuilderTool._mapSgs.tooltips.BuildInfoTooltips);

            // Change cursor
            document.body.style.cursor = 'crosshair';

            // Only on road mode
            if($('#target-gpi-road-mode').hasClass('active'))
            {
                $('#target-gpi-road-tool-split-road').show("slide");
                $('#target-gpi-road-tool-merge-sub-road').show("slide");
                $('#target-gpi-road-info-road-builder-tool').show("slide");
                
                $('#target-gpi-undo-modify-road-builder-tool').show("slide");
                $('#target-gpi-road-delete-road-builder-tool').show("slide");

                switch(myRoadBuilderTool._elementTypeForOperarion)
                {
                    case "road":
                        $('#target-gpi-road-info-road-history-tool').show("slide");
                        break;
                    default:
                        $('#target-gpi-road-info-road-history-tool').hide("slide");
                }
            }
        }

        // Register active tool
        myRoadBuilderTool._hashActiveTool.roadToolSelectRoad = {
            active: active,
            node: element
        }
    }

    /**
     * Active select police number by polygon tool
     * @param {dom} element, node element of the button (li)
     * @param {boolean} active, true active tool otherwise desactive 
     */
    this._ActiveSelectPoliceNumberByPolygonTool = function (element, active)
    {
        // Desactive tool
        if(!active)
        {
            $(element).removeClass('active');
            $(element).find('a').removeClass('hold-button');

            // Desactive police number selection by polygon
            myRoadBuilderTool._interactionDrawPoliceNumber.setActive(false);
            myRoadBuilderTool._interactionModifyPoliceNumber.setActive(false);
            myRoadBuilderTool._interactionSelectPoliceNumber.setActive(false);
            
            // Reset event layer tooltips
            if(myRoadBuilderTool._mapSgs.tooltips)
                myRoadBuilderTool._mapSgs.map.on('singleclick', async (e) => { await myRoadBuilderTool._mapSgs.tooltips.BuildInfoTooltips(e); });
                        
            // Reset cursor
            document.body.style.cursor = 'default';

            // Clear selection
            myRoadBuilderTool._CleanSelectPoliceNumberByPolygonTool();

            // Clear subroad and police number selected 
            myRoadBuilderTool._layerSubRoadPoliceSelected.getSource().clear();
            myRoadBuilderTool._layerPoliceAssociateToSubRoadSelected.getSource().clear();

            // Hide sub button
            $('#target-gpi-police-tool-select-by-polygon-submit').hide('slide');
            $('#target-gpi-police-tool-select-by-polygon-clean').hide('slide');

        }
        else { // Active tool
            $(element).addClass('active');

            // Active layer police
            var layerInfoPolice = myRoadBuilderTool._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName(myRoadBuilderTool._layerSourceNamePoliceNumber)[0];
            myRoadBuilderTool._mapSgs.layerTree.layerTreeObj.check(myRoadBuilderTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfoPolice.id.toString()));

            // Active police number selection by polygon
            myRoadBuilderTool._interactionDrawPoliceNumber.setActive(true);
            myRoadBuilderTool._interactionModifyPoliceNumber.setActive(true);

            // View subroad and police number selected
            myRoadBuilderTool._layerSubRoadPoliceSelected.setVisible(true);
            myRoadBuilderTool._layerPoliceAssociateToSubRoadSelected.setVisible(true);

            // Remove event layer tooltips
            if(myRoadBuilderTool._mapSgs.tooltips)
                myRoadBuilderTool._mapSgs.map.un('singleclick', myRoadBuilderTool._mapSgs.tooltips.BuildInfoTooltips);

            // Change cursor
            document.body.style.cursor = 'crosshair';

            // Shoe sub button
            $('#target-gpi-police-tool-select-by-polygon-submit').show('slide');
            $('#target-gpi-police-tool-select-by-polygon-clean').show('slide');
        }

        // Register active tool
        myRoadBuilderTool._hashActiveTool.policeToolSelectByPolygon = {
            active: active,
            node: element
        }
    }

    /**
     * Active select tool
     * @param {dom} element, node element of the button (li)
     * @param {boolean} active, true active tool otherwise desactive 
     */
    this._ActiveDrawRoadTool = function (element, active)
    {
        // Clean all road
        myRoadBuilderTool._CleanAllRoad();

        // Desactive tool
        if(!active) {
            $(element).removeClass('active');
            $(element).find('a').removeClass('hold-button');

            // Desactive interaction draw line
            myRoadBuilderTool._drawLineRoad.setActive(false);

            // Desactive interaction modify draw line
            myRoadBuilderTool._modifyDrawLineRoad.setActive(false);

            // Reset cursor
            document.body.style.cursor = 'default';

            // Actice tooltip
            if(myRoadBuilderTool._mapSgs.tooltips)
                myRoadBuilderTool._mapSgs.map.on('singleclick', async (e) => { await myRoadBuilderTool._mapSgs.tooltips.BuildInfoTooltips(e); });

            // Hide submit button
            $('#target-gpi-submit-road-builder-tool').hide("slide");
        }
        else { // Active tool
            $(element).addClass('active');

            // Active interaction
            myRoadBuilderTool._drawLineRoad.setActive(true);

            // Set cursor
            document.body.style.cursor = 'crosshair';

            // Desactive tooltip
            if(myRoadBuilderTool._mapSgs.tooltips)
                myRoadBuilderTool._mapSgs.map.un('singleclick', myRoadBuilderTool._mapSgs.tooltips.BuildInfoTooltips);

            // Show button submit
            $('#target-gpi-submit-road-builder-tool').show("slide");
        }

        // Register active tool
        myRoadBuilderTool._hashActiveTool.drawRoad = {
            active: active,
            node: element
        }
    }

    /**
     * Number of road selected
     */
    this._NumberRoadSelected = function()
    {
        var hashRoad = {};
        var count = 1;
        myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures().forEach(function(featureIn, index)
        {
            var arrSeq = featureIn.getProperties().ARR_SEQ;
            if(!hashRoad[arrSeq])
                hashRoad[arrSeq] = count++;
        });
        var countSelectedFeature = Object.keys(hashRoad).length;

        return countSelectedFeature;
    }

    /**
     * Check if split road tool can be active
     */
    this._CheckIfSplitToolActivation = function()
    {
        // Only if selected active with only one road selected
        if(myRoadBuilderTool._hashActiveTool.roadToolSelectRoad && myRoadBuilderTool._hashActiveTool.roadToolSelectRoad.active)
        {
            // Verify if only one road is selected
            var hashRoad = {};
            var count = 1;
            myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures().forEach(function(featureIn, index)
            {
                var arrSeq = featureIn.getProperties().ARR_SEQ;
                if(!hashRoad[arrSeq])
                    hashRoad[arrSeq] = count++;
            });
            var countSelectedFeature = Object.keys(hashRoad).length;

            if( countSelectedFeature != 1 )
            {
                if (countSelectedFeature > 1) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["warning"]("Seleccione apenas um arruamento");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["warning"]("Seleccione um arruamento");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                return false;
            }

            return true;
        }

        return false;
    }

    /**
     * Actice split road tool
     * @param {dom} element, node element of the button (li)
     * @param {boolean} active, true active tool otherwise desactive 
     */
    this._ActiveSplitRoadTool = function (element, active)
    {
        // Desactive tool
        if(!active)
        {
            $(element).removeClass('active');
            $(element).find('a').removeClass('hold-button');

            // Desactive road selection by polygon
            myRoadBuilderTool._interactionDrawSplitRoad.setActive(false);
            myRoadBuilderTool._interactionModifySplitRoad.setActive(false);
            myRoadBuilderTool._interactionSelectSplitRoad.setActive(false);
            
            // Reset cursor
            document.body.style.cursor = 'default';

            // Clear selection
            myRoadBuilderTool._CleanSplitRoad();

            // Active interaction road draw
            myRoadBuilderTool._select.setActive(true);
            myRoadBuilderTool._dragBox.setActive(true);

            // Hide submit button
            $('#target-gpi-submit-road-builder-tool').hide("slide");
        }
        else { // Active tool
            $(element).addClass('active');

            // Active police number selection by polygon
            myRoadBuilderTool._interactionDrawSplitRoad.setActive(true);
            myRoadBuilderTool._interactionModifySplitRoad.setActive(true);

            // Change cursor
            document.body.style.cursor = 'crosshair';

            // Desactive interaction road draw
            myRoadBuilderTool._select.setActive(false);
            myRoadBuilderTool._dragBox.setActive(false);

            // Show button submit
            $('#target-gpi-submit-road-builder-tool').show("slide");
        }

        // Register active tool
        myRoadBuilderTool._hashActiveTool.splitRoad = {
            active: active,
            node: element
        }
    }

    /**
     * Actice split sub road tool
     * @param {dom} element, node element of the button (li)
     * @param {boolean} active, true active tool otherwise desactive 
     */
    this._ActiveSplitSubRoadTool = function(element, active)
    {                                
        // Desactive interaction
        myRoadBuilderTool._drawPointSplit.setActive(false);

        // Clear Info feature
        $('#offcanvas-info').removeClass('show');

        // Desactice tool
        if(!active)
        {
            $(element).removeClass('active');
            $(element).find('a').removeClass('hold-button');

            if(myRoadBuilderTool._hashActiveTool.roadToolSelectRoad.active)
                myRoadBuilderTool._select.setActive(true);

            // Clear Split
            myRoadBuilderTool._ClearSplitSubroad();
            
            // Reset cursor
            document.body.style.cursor = 'default';

            // Hide submit button
            $('#target-gpi-submit-road-builder-tool').hide("slide");

            // Active tooltip
            if($('#target-gpi-road-tool-select-road').hasClass('hold-button'))
            {
                // Active select again
                myRoadBuilderTool._select.setActive(true);
            }
            else
            {
                if(myRoadBuilderTool._mapSgs.tooltips)
                    myRoadBuilderTool._mapSgs.map.on('singleclick', async (e) => { await myRoadBuilderTool._mapSgs.tooltips.BuildInfoTooltips(e); });
            }
        }
        else { // Active tool
            var featureSelected = null;

            // Check first if any subroad or road is selected
            switch(myRoadBuilderTool._elementTypeForOperarion)
            {
                //case "subroad":
                //    var lengthSelectedFeature = myRoadBuilderTool._select.getFeatures().getArray().length;
                //    if(lengthSelectedFeature != 1)
                //    {
                //        toastr["warning"]('Seleccione apenas um troço');
                //        return;
                //    }
                //    break;
                case "road":
                    var lengthSelectedRoadFeature = myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures().length;
                    if(lengthSelectedRoadFeature < 1)
                    {
                        toastr.options.positionClass = 'toast-top-center';
                        toastr["warning"]('Seleccione primeiro um arruamento');
                        toastr.options.positionClass = 'toast-bottom-center';
                        return;
                    }
                    break;
                default:
                    // do nothing
            }

            $(element).addClass('active');

            // Clear sub road layer
            myRoadBuilderTool._layerSubRoadLine.getSource().clear();
            myRoadBuilderTool._layerPointSplit.getSource().clear();
            myRoadBuilderTool._layerPointRoad.getSource().clear();
            myRoadBuilderTool._layerSubRoadSplit.getSource().clear();
            
            // Select 
            switch(myRoadBuilderTool._elementTypeForOperarion)
            {
                case "subroad":
                    // Get selected feature
                    featureSelected = myRoadBuilderTool._select.getFeatures().getArray()[0];

                    // Add selected feature to layerSubRoadLine
                    myRoadBuilderTool._layerSubRoadSplit.getSource().addFeature(featureSelected);

                    // First point
                    var featureFirstPoint = new Feature({
                        geometry: new Point(featureSelected.getGeometry().getFirstCoordinate()),
                        name: "first-point-info-line-subroad",
                        id: featureSelected.getId() + ".first" 
                    });
                    myRoadBuilderTool._layerPointRoad.getSource().addFeature(featureFirstPoint);

                    // Last point
                    var featureLastPoint = new Feature({
                        geometry: new Point(featureSelected.getGeometry().getLastCoordinate()),
                        name: "last-point-info-line-subroad",
                        id: featureSelected.getId() + ".last"
                    });
                    myRoadBuilderTool._layerPointRoad.getSource().addFeature(featureLastPoint);
                    break;
                //case "road":
                //    var lengthSelectedRoadFeature = myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures().length;

                //    // Clean Select
                //    myRoadBuilderTool._CleanSelect();
            
                //    // Desactive Select
                //    myRoadBuilderTool._select.setActive(false);

                //    for(var i=0; i < lengthSelectedRoadFeature; i++)
                //    {
                //        // Add selected feature to layerSubRoadLine
                //        myRoadBuilderTool._layerSubRoadSplit.getSource().addFeature(myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures()[i]);                        
                //    }

                //    break;
                default:
                    // do nothing
            }

            // Active interaction
            myRoadBuilderTool._drawPointSplit.setActive(true);

            // Set cursor
            document.body.style.cursor = 'crosshair';

            // Show button submit
            $('#target-gpi-submit-road-builder-tool').show("slide");

            // Desactive interaction
            if(myRoadBuilderTool._mapSgs.tooltips)
                myRoadBuilderTool._mapSgs.map.un('singleclick', myRoadBuilderTool._mapSgs.tooltips.BuildInfoTooltips);
        }

        // Register active tool
        myRoadBuilderTool._hashActiveTool.splitRoad = {
            active: active,
            node: element
        };
    }

    /**
     * Delete element first step - ask for it
     */
    this._DeleteElementFirstStep = function()
    {
        var countSelectedFeature = 0;

        // Define title
        var titleWarning = "";
        var moreSelected = false;
        switch(myRoadBuilderTool._elementTypeForOperarion)
        {
            case "road":
                $('#id-modal-road-build-tool-road-delete-header-title')[0].innerHTML = "Remover o arruamento seleccionado?";
                titleWarning = "arruamento";
                countSelectedFeature = myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures().length;
                var hashRoad = {};
                myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures().forEach(function(featureIn, index)
                {
                    var arrSeq = featureIn.getProperties().ARR_SEQ;
                    if(!hashRoad[arrSeq])
                        hashRoad[arrSeq] = 1;
                });
                moreSelected = (Object.keys(hashRoad).length > 1);
                break;
            case "subroad":
                $('#id-modal-road-build-tool-road-delete-header-title')[0].innerHTML = "Remover o troço seleccionado?";
                titleWarning = "troço";
                countSelectedFeature = myRoadBuilderTool._select.getFeatures().getArray().length;
                moreSelected = (countSelectedFeature > 1);
                break;
            default:
                // do nothing
        }

        // Check if no road or subroad is selected
        if( countSelectedFeature === 0)
        {
            toastr.options.positionClass = 'toast-top-center';
            toastr["warning"]("Seleccione um " + titleWarning);
            toastr.options.positionClass = 'toast-bottom-center';
            return;
        }

        // Check if more then one road or subroad is selected
        if(moreSelected)
        {
            toastr.options.positionClass = 'toast-top-center';
            toastr["warning"]("Seleccione apenas um " + titleWarning);
            toastr.options.positionClass = 'toast-bottom-center';
            return;
        }

        // Show modal
        $('#id-modal-road-build-tool-road-delete').show();
    }

    /**
     * Delete element second step - delete for sure
     */
    this._DeleteElementSecondStep  = function()
    {
        var feature = null;
        var id = -1;
        var titleWarning = "";

        // Start wait
        myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Hide modal
        $('#id-modal-road-build-tool-road-delete').hide();

        // Get id element
        switch(myRoadBuilderTool._elementTypeForOperarion)
        {
            case "road":
                id = myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures()[0].getProperties().ARR_SEQ;
                titleWarning = "arruamento";
                break;
            case "subroad":
                feature = myRoadBuilderTool._select.getFeatures().getArray()[0];
                titleWarning = "";
                id = feature.getProperties().IDTROCO;
                titleWarning = "troço";
                break;
            default:
                // do nothing
        }

        $.ajax({
            type: 'GET',
            url: '/rest/app/RoadBuilderTool/GetDeleteElement?elementType=' + myRoadBuilderTool._elementTypeForOperarion + '&id=' + id,
            contentType: "application/json",
            dataType: 'json',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na remoção do " + titleWarning);
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            switch(myRoadBuilderTool._elementTypeForOperarion)
                            {
                                case "road":
                                    // Clean road selected
                                    myRoadBuilderTool._ClearSelectionRoad();
                                    // Remove from collectionFeatureSet the element removed
                                    myRoadBuilderTool._RemoveSubRoadFromCollectionFeatureSet("ARR_SEQ", id);
                                    break;
                                case "subroad":
                                    // Clean subroad select
                                    myRoadBuilderTool._CleanSelect();
                                    // Remove from collectionFeatureSet the element removed
                                    myRoadBuilderTool._RemoveSubRoadFromCollectionFeatureSet("IDTROCO", id);
                                    break;
                                default:
                                    // do nothing
                            }

                            // Refresh layer sub road
                            myRoadBuilderTool._RefreshLayerRoad();

                            toastr.options.positionClass = 'toast-top-center';
                            toastr["success"]("Remoção do " + titleWarning + " efectuada com sucesso");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na remoção do " + titleWarning);
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                    }
                }

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na remoção do " + titleWarning);
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /**
     * Remove from collectionFeatureSet
     * @param{string} columnName, column name
     * @param{int} id, identifier
     */
    this._RemoveSubRoadFromCollectionFeatureSet = function(columnName, id)
    {
        var arrayFeature = [];

        // Get array of feature
        switch(columnName)
        {
            case "ARR_SEQ":
                arrayFeature = myRoadBuilderTool.collectionFeatureSet.getArray().filter(c=> c.getProperties().ARR_SEQ == id);
                break;
            case "IDTROCO":
                arrayFeature = myRoadBuilderTool.collectionFeatureSet.getArray().filter(c=> c.getProperties().IDTROCO == id);
                break;
            default:
                // do nothing
        }

        // Remove all featuyre from collectionFeatureSet
        for(var i = 0; i < arrayFeature.length; i++)
        {
            var feature = arrayFeature[i];

            // Get index feature in collectionFeatureSet
            var index = myRoadBuilderTool.collectionFeatureSet.getArray().findIndex(c=> c.getProperties().IDTROCO == feature.getProperties().IDTROCO);

            // Remove feature in collectionFeatureSet if index found
            if(index != -1)
            {
                myRoadBuilderTool.collectionFeatureSet.getArray().splice(index,1);
            }
        }
    }

    /**
     * Clean all object police
     */
    this._CleanAllPolice = function()
    {
        // Clean all feature road creation
        myRoadBuilderTool._layerPolicePoint.getSource().clear();
        myRoadBuilderTool._arrayFeatureSubRoadPolice = [];
        myRoadBuilderTool._listSubRoadPolice = [];
        myRoadBuilderTool._layerBufferPolice.getSource().clear();
        myRoadBuilderTool.layerSubRoadPoliceCloser.getSource().clear();
        myRoadBuilderTool.layerSubRoadPolice.getSource().clear();
        myRoadBuilderTool._listIdSubRoadPolice = [];
        myRoadBuilderTool._mapSgs.layerHighlightOverlay.getSource().clear();

        if(myRoadBuilderTool._hashActiveTool.policeToolSelect && myRoadBuilderTool._hashActiveTool.policeToolSelect.active) {
            if (myRoadBuilderTool._select) {
                myRoadBuilderTool._select.setMap(undefined);
            }
        }

        // Clean form police
        myRoadBuilderTool._CleanFormAddPolice();

        // Clear all subroad and police number selected
        myRoadBuilderTool._layerSubRoadPoliceSelected.getSource().clear();
        myRoadBuilderTool._layerPoliceAssociateToSubRoadSelected.getSource().clear();

        // Clean select police number by polygon
        myRoadBuilderTool._CleanSelectPoliceNumberByPolygonTool();
        if(myRoadBuilderTool._hashActiveTool.policeToolSelectByPolygon && myRoadBuilderTool._hashActiveTool.policeToolSelectByPolygon.active)
        {
            myRoadBuilderTool._ActiveSelectPoliceNumberByPolygonTool(this, false);
        }
    }


    /**
     * Clean select police number by polygon
     */
    this._CleanSelectPoliceNumberByPolygonTool = function()
    {
        myRoadBuilderTool._selectedFeaturesPoliceNumber.clear();
        myRoadBuilderTool._sourceDrawPolygonPoliceNumber.clear();
    }

    /**
     * Clean form add road
     */
    this._CleanFormAddPolice = function()
    {
        // Clean info
        $('#id-modal-road-build-tool-add-police-info-form').find("input, textarea").val("");
        $('#id-modal-road-build-tool-add-police-info-body-select-freguesia').find('option[value]').remove();
        $("#id-modal-road-build-tool-add-police-info-body-select-freguesia").val("");
        $('#id-modal-road-build-tool-add-police-info-body-select-freguesia').selectpicker("refresh");
        $('#id-modal-road-build-tool-add-police-info-body-select-id-troco').find('option[value]').remove();
        $("#id-modal-road-build-tool-add-police-info-body-select-id-troco").val("");
        $('#id-modal-road-build-tool-add-police-info-body-select-id-troco').selectpicker("refresh");
        $("#id-modal-road-build-tool-add-police-info-body-select-utilizacao").val("");
        $('#id-modal-road-build-tool-add-police-info-body-select-utilizacao').selectpicker("refresh");
    }

    /**
     * Clean all object road
     */
    this._CleanAllRoad = function () {
        // Clean all feature road creation
        if (myRoadBuilderTool._layerDrawLineRoad.getSource()) myRoadBuilderTool._layerDrawLineRoad.getSource().clear();
        if (myRoadBuilderTool._layerPointRoad.getSource()) myRoadBuilderTool._layerPointRoad.getSource().clear();
        if (myRoadBuilderTool._layerSubRoadLine.getSource()) myRoadBuilderTool._layerSubRoadLine.getSource().clear();
        if (myRoadBuilderTool._layerSubRoadForModify.getSource()) myRoadBuilderTool._layerSubRoadForModify.getSource().clear();
        if (myRoadBuilderTool._layerPointSubRoadForModify.getSource()) myRoadBuilderTool._layerPointSubRoadForModify.getSource().clear();
        if (myRoadBuilderTool._layerInfoLineRoad.getSource()) myRoadBuilderTool._layerInfoLineRoad.getSource().clear();
        myRoadBuilderTool._updateSubRoadInfo = {};
        myRoadBuilderTool._collectionFeatureIntercepted.clear();
        myRoadBuilderTool._hashFeatureIntercepted = {};
        myRoadBuilderTool._hasInterception = false;
        myRoadBuilderTool._idRoadSelectedInModify = null;
        myRoadBuilderTool._arraySubRoadFeatureModify = [];

        // Clean form road
        myRoadBuilderTool._CleanFormRoadInfo();

        // Clean road selected
        myRoadBuilderTool._ClearSelectionRoad();

        // Clean split sub road
        myRoadBuilderTool._CleanSplitSubroad(true);

        // Clean split road
        myRoadBuilderTool._CleanSplitRoad();

        // Refresh all route layer
        var lengthLayer = Object.keys(myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info).length;
        for (var i = 0; i < lengthLayer; i++) {
            var key = Object.keys(myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info)[i];
            var layerInfo = myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info[key].layer_info;
            if (layerInfo.layerName === myRoadBuilderTool._layerNameSubRoadInMap && layerInfo.kind === 'WFS') {
                var layer = myRoadBuilderTool._mapSgs._utility.GetLayerByName(myRoadBuilderTool._mapSgs.map, layerInfo.layerNameKey);
                layer.getSource().clear();
            }
        }
    }

    /**
     * Clear split subroad
     */
    this._ClearSplitSubroad = function()
    {
        // Disble draw
        myRoadBuilderTool._drawPointSplit.setActive(false);

        // Clean Split
        myRoadBuilderTool._CleanSplitSubroad(true);

        // Clear select interaction
        myRoadBuilderTool._CleanSelect();
    }

    /**
     * Clean split subroad
     */
    this._CleanSplitSubroad = function(cleanSplitLayer)
    {
        myRoadBuilderTool._layerPointSplit.getSource().clear();
        myRoadBuilderTool._layerSubRoadLine.getSource().clear();
        myRoadBuilderTool._layerPointRoad.getSource().clear();

        if(cleanSplitLayer)
            myRoadBuilderTool._layerSubRoadSplit.getSource().clear();
    }

    /**
     * Clear split road
     */
    this._ClearSplitRoad = function()
    {
        // Disble draw polygon
        myRoadBuilderTool._interactionDrawSplitRoad.setActive(false);
        myRoadBuilderTool._interactionModifySplitRoad.setActive(false);
        myRoadBuilderTool._interactionSelectSplitRoad.setActive(false);


        // Clean Split
        myRoadBuilderTool._CleanSplitRoad();
    }

    /**
     * Clean split road
     */
    this._CleanSplitRoad = function()
    {
        myRoadBuilderTool._sourceDrawPolygonSplitRoad.clear();
        myRoadBuilderTool._selectedFeaturesSplitRoad.clear();
        myRoadBuilderTool._interactionSelectSplitRoad.setActive(false);
    }

    /**
     * Clean select road by polygon
     */
    this._CleanSelectRoadByPolygonTool = function()
    {
        myRoadBuilderTool._sourceDrawPolygonSplitRoad.clear();
    }

    /**
     * Clean form add road
     */
    //this._CleanFormAddRoad = function()
    //{
    //    // Clean info
    //    $('#id-modal-road-build-tool-add-road-info-form').find("input, textarea").val("");
    //    $("#id-modal-road-build-tool-add-road-info-body-select-id-tipo-rua").val("");
    //    $('#id-modal-road-build-tool-add-road-info-body-select-id-tipo-rua').selectpicker("refresh");

    //    // Clean info detail
    //    $('#id-modal-road-build-tool-add-road-info-detail-body-data-actua');
    //    $('#id-modal-road-build-tool-add-road-info-detail-form').find("input, textarea").val("");

    //    // Clean sub road
    //    $('#id-modal-road-build-tool-add-road-info-sub-body-sub-road-zone').empty();
    //    $('#id-modal-road-build-tool-add-road-info-sub-count').val("");
    //    $('#id-modal-road-build-tool-add-road-info-sub-total-length').val("");

    //    // Clean road intersect
    //    $('#id-modal-road-build-tool-add-road-info-sub-body-road-intersect-zone').empty();
    //    $('#id-modal-road-build-tool-add-road-info-road-intersect-count').val();
    //}

    /**
     * Clean road form
     */
    this._CleanFormRoad = function()
    {
        // Clean form road information
        myRoadBuilderTool._CleanFormRoadInfo();

        // Clean form subroad information
        myRoadBuilderTool._CleanFormSubRoadInfo();
    }

    /**
     * Clean form road information
     */
    this._CleanFormRoadInfo = function()
    {
        // Clean info
        $('#id-modal-road-build-tool-road-info-form').find("input, textarea").val("");
        $('#id-modal-road-build-tool-road-info-select-id-arruamento-class').val("");
        $('#id-modal-road-build-tool-road-info-select-id-arruamento-class').selectpicker("refresh");
        $("#id-modal-road-build-tool-road-info-select-id-tipo-rua").val("");
        $('#id-modal-road-build-tool-road-info-select-id-tipo-rua').selectpicker("refresh");
        if(myRoadBuilderTool._hashTableFreguesia['road'] !== undefined) myRoadBuilderTool._hashTableFreguesia['road'].clear().draw();
        
        // Clean info detail
        $('#id-modal-road-build-tool-road-info-detail-form').find("input, textarea").val("");

        // Clean road intersect
        $('#id-modal-road-build-tool-road-info-sub-body-road-intersect-zone').empty();
        $('#id-modal-road-build-tool-road-info-road-intersect-count').val();
    }

    /**
     * Clean form subroad information
     */
    this._CleanFormSubRoadInfo = function()
    {
        // Clean sub road info
        $('#id-modal-road-build-tool-road-sub-road-info-form').find("input, textarea").val("");
        $("#id-modal-road-build-tool-road-sub-road-info-select-one-way").val("");
        $('#id-modal-road-build-tool-road-sub-road-info-select-one-way').selectpicker("refresh");
        if(myRoadBuilderTool._hashTableFreguesia['subroad'] !== undefined) myRoadBuilderTool._hashTableFreguesia['subroad'].clear().draw()

        // Clean freguesia datatable from subroad list
        var lengthDatatableFreguesia = Object.keys(myRoadBuilderTool._hashTableFreguesia).length;
        Object.keys(myRoadBuilderTool._hashTableFreguesia).forEach(function(key)
        {
            if(key.indexOf("subroad_list_info") === 0)
            {
                myRoadBuilderTool._hashTableFreguesia[key].destroy();
                delete myRoadBuilderTool._hashTableFreguesia[key];
            }
        });
           
        // Clean list sub road to merge
        $('#id-modal-road-build-tool-road-list-sub-road-info-list-zone').empty();
        $('#id-modal-road-build-tool-road-list-sub-road-info-count').val("");
    }

    /**
     * Build police number information to form
     */
    this._BuildPoliceInformation = function()
    {
        if (myRoadBuilderTool._layerPolicePoint.getSource().getFeatures().length == 0) {
            toastr.options.positionClass = 'toast-top-center';
            toastr["warning"]("Desenhe primeiro um número de polícia");
            toastr.options.positionClass = 'toast-bottom-center';
            return;
        }

        // Verify if police number is on edificado
        var layerBuildingInfo = myRoadBuilderTool._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName("EDIFICADO");
        var coordinate = myRoadBuilderTool._layerPolicePoint.getSource().getFeatures()[0].getGeometry().getCoordinates()[0];
        var idBuilding = myRoadBuilderTool._IsPointInBuilding(layerBuildingInfo[0].layerNameKey, coordinate);

        if(idBuilding === -1)
        {
            toastr.options.positionClass = 'toast-top-center';
            toastr["warning"]("O número de polícia tem que estar contido num edificado");
            toastr.options.positionClass = 'toast-bottom-center';
            return;
        }
        $('#id-modal-road-build-tool-add-police-info-body-id-building').val(idBuilding);

        // Fill user info
        $('#id-modal-road-build-tool-add-police-info-body-pol-reg-user').val(myRoadBuilderTool._mapSgs._settings.userInfo.userName);

        // Fill data
        $('#id-modal-road-build-tool-add-police-info-body-pol-reg-data').val(myRoadBuilderTool._utility.GetNowDate());
            
        // Build result in police form
        myRoadBuilderTool._FillSubRoadForPolice();            

        // Open modal
        $('#id-modal-road-build-tool-add-police').show();
    }

    /**
     * Check if any subroad is length = 0
     */
    this._CheckLengthZero = function ()
    {
        var countFeatureSubRoad = myRoadBuilderTool._layerSubRoadLine.getSource().getFeatures().length;
        for (var i = 0; i < countFeatureSubRoad; i++)
        {
            var feature = myRoadBuilderTool._layerSubRoadLine.getSource().getFeatures()[i];
            if (feature.getGeometry().getLength() == 0)
            {
                return true;
            }
        }

        return false;
    }

    /**
     * Build road information to form
     */
    this._BuildRoadInformation = function()
    {
        if (myRoadBuilderTool._layerDrawLineRoad.getSource().getFeatures().length == 0) {
            toastr.options.positionClass = 'toast-top-center';
            toastr["warning"]("Desenhe primeiro uma rua");
            toastr.options.positionClass = 'toast-bottom-center';
            return;
        }

        if (myRoadBuilderTool._CheckLengthZero())
        {
            toastr.options.positionClass = 'toast-top-center';
            toastr["error"]("Atenção: Um dos troços com comprimento zero!");
            toastr.options.positionClass = 'toast-bottom-center';
            return;
        }

        // Save mode
        myRoadBuilderTool._modeSaveSubRoad = 'create_road';

        // Title
        $('#id-modal-road-build-tool-road-header-title')[0].innerHTML = 'Inserir nova rua';

        // Hide tab edit sub road
        $('#id-modal-road-build-tool-road-sub-road-info-li').parent().removeClass('active');
        $('#id-modal-road-build-tool-road-sub-road-info').removeClass('active');
        $('#id-modal-road-build-tool-road-sub-road-info-li').parent().hide();

        // Active tab road
        $('#id-modal-road-build-tool-road-info-li').parent().removeClass('active');
        $('#id-modal-road-build-tool-road-info').addClass('active');

        // Title tab road
        $('#id-modal-road-build-tool-road-info-li').attr('title', 'Informação geral');
        $('#id-modal-road-build-tool-road-info-li')[0].innerHTML = 'Informação geral';

        // Title tab road detaik
        $('#id-modal-road-build-tool-road-info-detail-li').attr('title', 'Informação de detalhe');
        $('#id-modal-road-build-tool-road-info-detail-li')[0].innerHTML = 'Informação de detalhe';

        // Title tab list subroad
        $('#id-modal-road-build-tool-road-list-sub-road-info-li').attr('title', 'Informação de troços');
        $('#id-modal-road-build-tool-road-list-sub-road-info-li')[0].innerHTML = 'Informação de troços';

        // Active tad road interception
        $('#id-modal-road-build-tool-road-info-road-intersect-li').parent().show();

        // Fill user info
        $('#id-modal-road-build-tool-road-info-form [name="arr_reg_user"]').val(myRoadBuilderTool._mapSgs._settings.userInfo.userName);

        // Fill data
        $('#id-modal-road-build-tool-road-info-form [name="arr_reg_data"]').val(myRoadBuilderTool._utility.GetNowDate());

        // Length total road
        var lengthRoad = myRoadBuilderTool._utility.LengthLine(myRoadBuilderTool._layerDrawLineRoad.getSource().getFeatures()[0].getGeometry());
        var lengthRoadNumber = Math.round(myRoadBuilderTool._layerDrawLineRoad.getSource().getFeatures()[0].getGeometry().getLength() * 100)/100;
        $('#id-modal-road-build-tool-road-list-sub-road-info-total-length').val(lengthRoad);
        $('#id-modal-road-build-tool-road-info-form [name="length"]').val(lengthRoadNumber);

        // Set road type for "C.M" id=6
        $('#id-modal-road-build-tool-road-info-select-id-tipo-rua').val("6");
        $('#id-modal-road-build-tool-road-info-select-id-tipo-rua').selectpicker("refresh");

        // Active write in subroad
        myRoadBuilderTool._ActiveForWriteOrReadFormRoad("list_subroad", false);

        // Active write in road
        myRoadBuilderTool._ActiveForWriteOrReadFormRoad("road", false);

        var geojsonFormat = new GeoJSON();
        myRoadBuilderTool._hashTableFreguesia["road"].clear().draw();
        var hashFreguesia = {};
        var hashRoad = {};
        var countRoadIntersect = 0;
        var countFeatureSubRoad = myRoadBuilderTool._layerSubRoadLine.getSource().getFeatures().length;
        var countSubRoad = 0;
        for(var i = 0; i < countFeatureSubRoad; i++)
        {
            var feature = myRoadBuilderTool._layerSubRoadLine.getSource().getFeatures()[i];

            // If subroad from other road then pass
            if(feature.getProperties().other_road)
            {
                continue;
            }

            // Length subroad information
            var lengthSubRoad = Math.round(feature.getGeometry().getLength() * 100)/100;
            
            var idSubRoad = feature.getProperties().id_tmp_sub_road;
            countSubRoad++;
            
            // Clone
            var cloneSubRoad = $('#id-modal-road-build-tool-road-list-sub-road-info-list').clone(true);
            var idClone = "id-modal-road-build-tool-road-list-sub-road-info-list" + "-" + i;
            cloneSubRoad.attr("id", idClone);
            $('#id-modal-road-build-tool-road-list-sub-road-info-list-zone').append(cloneSubRoad);
            $('#' + idClone).show();
            $('#' + idClone).find("input,select,a").each(function() {
                $(this).attr('id' , $(this).attr('id') + "-" + i);
                this.name = this.name.replace('[0]', '[' + i + ']');
            });
            
            // Fill subroad temporary
            $('#' + idClone + " [name='TROCO[" + i + "][IDTROCO]']").val(idSubRoad);

            // Fill length
            $('#' + idClone + ' input.extensao').val(lengthSubRoad);

            // Fill combo
            $('#' + idClone + ' div.one-way').append('<select id="id-modal-road-build-tool-road-list-sub-road-info-list-select-one-way-' + i + '" name="TROCO[' + i + '][oneway]" class="form-control one-way"></select>')
            myRoadBuilderTool._utility.FillSelect('id-modal-road-build-tool-road-list-sub-road-info-list-select-one-way-' + i, myRoadBuilderTool._hashReference["one_way"], 'oneway', 'oneway');

            // Init table freguesia subroad info
            var idTable = 'subroad_list_info_' + i
            myRoadBuilderTool._BuildFreguesiaTable(idTable, '#' + idClone + ' .table-node');

            if (myRoadBuilderTool._createRoadInfo.newSubRoad.hashSubRoad[idSubRoad]) {
                for (var u = 0; u < myRoadBuilderTool._createRoadInfo.newSubRoad.hashSubRoad[idSubRoad].listSubRoadFreguesia.length; u++) {
                    var subRoadFreguesia = myRoadBuilderTool._createRoadInfo.newSubRoad.hashSubRoad[idSubRoad].listSubRoadFreguesia[u];
                    myRoadBuilderTool._hashTableFreguesia[idTable].row.add({
                        id_freguesia: subRoadFreguesia.id_freguesia,
                        freguesia: subRoadFreguesia.freguesia,
                        dtccfr: subRoadFreguesia.dtccfr
                    });
                    myRoadBuilderTool._hashTableFreguesia[idTable].draw();

                    // Fill road freguesia information
                    if (!hashFreguesia[subRoadFreguesia.id_freguesia]) {
                        myRoadBuilderTool._hashTableFreguesia["road"].row.add({
                            id_freguesia: subRoadFreguesia.id_freguesia,
                            freguesia: subRoadFreguesia.freguesia,
                            dtccfr: subRoadFreguesia.dtccfr
                        });
                        myRoadBuilderTool._hashTableFreguesia["road"].draw();
                        hashFreguesia[subRoadFreguesia.id_freguesia] = 1;
                    }
                }
            }
        }

        // Fill road intersect information
        var lengthFeatureIntersect = myRoadBuilderTool._collectionFeatureIntercepted.getArray().length;
        for(var u = 0; u < lengthFeatureIntersect; u++)
        {
            var feature = myRoadBuilderTool._collectionFeatureIntercepted.getArray()[u];
            if(feature.getId().split(".")[0] === myRoadBuilderTool._layerNameSubRoadInMap)
            {
                var arrSeq = feature.getProperties().ARR_SEQ;
                if(!hashRoad[arrSeq]) {
                    var cqlFilter = "ARR_SEQ == " + arrSeq;
                    myRoadBuilderTool._GetRoadInfoById(myRoadBuilderTool._layerInfoRoad, cqlFilter);
                    hashRoad[arrSeq] = 1;
                    countRoadIntersect++;
                }
            }
        }

        // Fill sub road
        $('#id-modal-road-build-tool-road-list-sub-road-info-count').val(countSubRoad);

        // Fill count road intersect
        $('#id-modal-road-build-tool-road-info-road-intersect-count').val(countRoadIntersect);

        // Open modal
        $('#id-modal-road-build-tool-road').show();
    }

    /**
     * Refresh road layer
     */
    this._RefreshLayerRoad = function()
    {
        // Refresh all route layer
        var lengthLayer = Object.keys(myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info).length;
        for(var i = 0; i < lengthLayer; i++) {
            var key = Object.keys(myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info)[i];
            var layerInfo = myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info[key].layer_info;
            if((layerInfo.layerName === myRoadBuilderTool._layerNameSubRoadInMap || layerInfo.layerName === myRoadBuilderTool._layerSourceNamePoliceNumber) && layerInfo.kind === 'WFS') {
                var layer = myRoadBuilderTool._mapSgs._utility.GetLayerByName(myRoadBuilderTool._mapSgs.map, layerInfo.layerNameKey);
                layer.getSource().clear();
            }
        }
    }

    /**
     * Save sub road merge
     */
    this._SaveSubRoadMerge = function()
    {
        myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Close Modal
        $('#id-modal-road-build-tool-road').hide();

        // Json for subroad information
        var jsonSubRoad = $('#id-modal-road-build-tool-road-sub-road-info-form').serializeJSON();
        jsonSubRoad.objectid = -1;
        jsonSubRoad.id_troco = -1;
        jsonSubRoad.geom_wkt = myRoadBuilderTool._lineMergeWkt;
        jsonSubRoad.geom_srid = myRoadBuilderTool._mapSgs._settings.projection.getCode().replace('EPSG:', '');

        // List id subroad 
        var listIdSubRoadInString = "";
        var lengthFeatureSelected = myRoadBuilderTool._select.getFeatures().getArray().length;
        for(var t = 0; t < lengthFeatureSelected ; t++)
        {
            listIdSubRoadInString += myRoadBuilderTool._select.getFeatures().getArray()[t].getProperties().IDTROCO;
            if(t !== lengthFeatureSelected -1) {
                listIdSubRoadInString += ",";
            }
        }

        // List freguesia
        var countFreguesia = myRoadBuilderTool._hashTableFreguesia["subroad"].row().length;
        var arrayRow = null;
        var listSubRoadToSaveFreguesia = [];
        if(countFreguesia === 1)
            arrayRow = [myRoadBuilderTool._hashTableFreguesia["subroad"].row().data()];
        else
            arrayRow = myRoadBuilderTool._hashTableFreguesia["subroad"].row();
        for(var y = 0; y < countFreguesia; y++)
        {
            var row = arrayRow[y];
            listSubRoadToSaveFreguesia.push({
                id_freguesia: row.id_freguesia,
                freguesia: row.freguesia,
                dtccfr: row.dtccfr
            });
        }

        // Join data
        var subRoadToMergeInfo = {
            subRoadToSave: jsonSubRoad,
            listIdSubRoadToMergeInString: listIdSubRoadInString,
            listSubRoadToSaveFreguesia: listSubRoadToSaveFreguesia
        }

        $.ajax({
            type: 'POST',
            url: '/rest/app/RoadBuilderTool/SaveSubRoadMerge',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(subRoadToMergeInfo),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro no junção dos troços");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Clean selection
                            myRoadBuilderTool._CleanSelect();

                            // Refresh layer
                            myRoadBuilderTool._RefreshLayerRoad();

                            toastr.options.positionClass = 'toast-top-center';
                            toastr["success"]("Troços fundidos com sucesso");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na criação da rua");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                    }
                }

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro no junção dos troços");
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /**
     * Build list subroad information
     * @param{array} objListSubRoad, array of subroad
     * @param{hash} objHashSubRoadFreguesia, hash of list of freguesia for every subroad
     * @param{string} idSubRoadSelected, id subroad selected
     */
    this._BuildListSubRoadInformation = function(objListSubRoad, objHashSubRoadFreguesia, idSubRoadSelected)
    {
        var lengthSubRoadTotal = 0;

        // Fill count subroad
        var countFeatureSubRoad = objListSubRoad.length;
        $('#id-modal-road-build-tool-road-list-sub-road-info-count').val(countFeatureSubRoad);

        // Fill sub road information
        for(var i = 0; i < countFeatureSubRoad; i++)
        {
            var objSubRoad = objListSubRoad[i];
            var listSubRoadFreguesia = objHashSubRoadFreguesia[objSubRoad.id_troco];
            var lengthSubRoad = Math.round(objSubRoad.length_shape * 100)/100;
            lengthSubRoadTotal += lengthSubRoad;
            var subRoadSelected = (objSubRoad.id_troco === idSubRoadSelected);

            // Clone
            var cloneSubRoad = $('#id-modal-road-build-tool-road-list-sub-road-info-list').clone(true);
            var idClone = "id-modal-road-build-tool-road-list-sub-road-info-list" + "-" + i;
            cloneSubRoad.attr("id", idClone);
            $('#id-modal-road-build-tool-road-list-sub-road-info-list-zone').append(cloneSubRoad);
            if(subRoadSelected)
            {
                cloneSubRoad.addClass("selected");
                cloneSubRoad.find("border-divider").addClass("selected");
            }
            $('#' + idClone).show();
            $('#' + idClone).find("input,select,a").each(function() {
                $(this).attr('id' , $(this).attr('id') + "-" + i);
                this.name = this.name.replace('[0]', '[' + i + ']');
            });
            
            // Fill subroad id
            $('#' + idClone + " [name='TROCO[" + i + "][IDTROCO]']").val(objSubRoad.id_troco);

            // Fill ft_minutes
            $('#' + idClone + " [name='TROCO[" + i + "][ft_minutes]']").val(objSubRoad.ft_minutes);

            // Fill tf_minutes
            $('#' + idClone + " [name='TROCO[" + i + "][tf_minutes]']").val(objSubRoad.tf_minutes);

            // Fill length
            $('#' + idClone + " [name='TROCO[" + i + "][EXTENSAO]']").val(lengthSubRoad);
            //$('#' + idClone + ' input.extensao').val(lengthSubRoad);

            // Fill combo
            $('#' + idClone + ' div.one-way').append('<select id="id-modal-road-build-tool-road-list-sub-road-info-list-select-one-way-' + i + '" name="TROCO[' + i + '][oneway]" class="form-control one-way"></select>')
            myRoadBuilderTool._utility.FillSelect('id-modal-road-build-tool-road-list-sub-road-info-list-select-one-way-' + i, myRoadBuilderTool._hashReference["one_way"], 'oneway', 'oneway');
            $('#id-modal-road-build-tool-road-list-sub-road-info-list-select-one-way-' + i).val(objSubRoad.oneway);
            $('#id-modal-road-build-tool-road-list-sub-road-info-list-select-one-way-' + i).selectpicker("refresh");
            $('#id-modal-road-build-tool-road-list-sub-road-info-list-select-one-way-' + i).prop("disabled", true);

            // Init table freguesia subroad info
            var idTable = 'subroad_list_info_' + i
            myRoadBuilderTool._BuildFreguesiaTable(idTable, '#' + idClone + ' .table-node');

            if(listSubRoadFreguesia !== undefined)
            {
                for(var u = 0; u < listSubRoadFreguesia.length; u++)
                {
                    myRoadBuilderTool._hashTableFreguesia[idTable].row.add({
                        id_freguesia: listSubRoadFreguesia[u].id_freguesia,
                        freguesia: listSubRoadFreguesia[u].freguesia,
                        dtccfr:listSubRoadFreguesia[u].dtccfr
                    });
                    myRoadBuilderTool._hashTableFreguesia[idTable].draw();
                }
            }
        }

        // Fill total length of all subroad
        lengthSubRoadTotal = Math.round(lengthSubRoadTotal * 100)/100;
        $('#id-modal-road-build-tool-road-list-sub-road-info-total-length').val(lengthSubRoadTotal);
    }

    /**
     * Build merge sub road information
     * @param{string} arrSeq, sub string id
     * @param{string} subRoadDesig, subroad designation
     */
    this._BuildMergeInformation = function(arrSeq, subRoadDesig)
    {
        // Title
        $('#id-modal-road-build-tool-road-header-title')[0].innerHTML = 'Fundir Troço';

        // Reset all active tab
        $('#id-modal-road-build-tool-road-sub-road-info-li').parent().find('li').removeClass('active');
        $('#id-modal-road-build-tool-road-content .tab-pane').removeClass('active');

        // Active tab edit sub road
        $('#id-modal-road-build-tool-road-sub-road-info-li').parent().addClass('active');
        $('#id-modal-road-build-tool-road-sub-road-info').addClass('active');
        $('#id-modal-road-build-tool-road-sub-road-info-li').attr('title', 'Novo troço');
        $('#id-modal-road-build-tool-road-sub-road-info-li')[0].innerHTML = 'Novo troço';

        // Hide tab road
        $('#id-modal-road-build-tool-road-info-li').parent().hide();

        // Title tab road detail
        $('#id-modal-road-build-tool-road-info-detail-li').parent().hide();

        // Title tab list subroad
        $('#id-modal-road-build-tool-road-list-sub-road-info-li').parent().show();
        $('#id-modal-road-build-tool-road-list-sub-road-info-li').attr('title', 'Troços a fundir');
        $('#id-modal-road-build-tool-road-list-sub-road-info-li')[0].innerHTML = 'Troços a fundir';

        // Title tab road detail
        $('#id-modal-road-build-tool-road-info-road-intersect-li').parent().hide();

        // Fill count subroad
        var countFeatureSubRoad = myRoadBuilderTool._select.getFeatures().getArray().length;
        $('#id-modal-road-build-tool-road-list-sub-road-info-count').val(countFeatureSubRoad);

        // Fill road id
        $('#id-modal-road-build-tool-road-sub-road-info-form [name="arr_seq"]').val(arrSeq);

        // Fill troco
        $('#id-modal-road-build-tool-road-sub-road-info-form [name="troco"]').val(subRoadDesig);

        // Fill extension
        var lengthMergeLine = myRoadBuilderTool._featureLineMergeWkt.getGeometry().getLength();
        $('#id-modal-road-build-tool-road-sub-road-info-form [name="length_shape"]').val(Math.round(lengthMergeLine * 100)/100);

        var geojsonFormat = new GeoJSON();
        myRoadBuilderTool._hashTableFreguesia["subroad"].clear().draw();
        var hashFreguesia = {};
        var hashRoad = {};
        var countRoadIntersect = 0;
        for(var i = 0; i < countFeatureSubRoad; i++)
        {
            var feature = myRoadBuilderTool._select.getFeatures().getArray()[i];
            var lengthSubRoad = Math.round(feature.getGeometry().getLength() * 100)/100;
            
            // Clone
            var cloneSubRoad = $('#id-modal-road-build-tool-road-list-sub-road-info-list').clone(true);
            var idClone = "id-modal-road-build-tool-road-list-sub-road-info-list" + "-" + i;
            cloneSubRoad.attr("id", idClone);
            $('#id-modal-road-build-tool-road-list-sub-road-info-list-zone').append(cloneSubRoad);
            $('#' + idClone).show();
            $('#' + idClone).find("input,select,a").each(function() {
                $(this).attr('id' , $(this).attr('id') + "-" + i);
                this.name = this.name.replace('[0]', '[' + i + ']');
            });
            
            // Fill length
            $('#' + idClone + ' input.extensao').val(lengthSubRoad);

            // Fill combo
            $('#' + idClone + ' div.one-way').append('<select id="id-modal-road-build-tool-road-list-sub-road-info-list-select-one-way-' + i + '" name="TROCO[' + i + '][oneway]" class="form-control one-way"></select>')
            myRoadBuilderTool._utility.FillSelect('id-modal-road-build-tool-road-list-sub-road-info-list-select-one-way-' + i, myRoadBuilderTool._hashReference["one_way"], 'oneway', 'oneway');
            //$('#id-modal-road-build-tool-road-list-sub-road-info-list-select-one-way-' + i).val(feature.get.oneway);
            //$('#id-modal-road-build-tool-road-list-sub-road-info-list-select-one-way-' + i).selectpicker("refresh");

            // Find freguesia insub road to merge
            var featureGeojson = geojsonFormat.writeFeatureObject(feature);
            myRoadBuilderTool.collectionFeatureSet.getArray().forEach(function(featureIn, index)
            {
                if(featureIn.getId().indexOf("FREGUESIA") >= 0)
                {
                    var featureInGeoJson = geojsonFormat.writeFeatureObject(featureIn);
                    if(turf.booleanCrosses(featureGeojson, featureInGeoJson) || turf.booleanContains(featureInGeoJson, featureGeojson))
                    {
                        // Add freguesia do road
                        var featureProperty = featureIn.getProperties();

                        if(!hashFreguesia[featureProperty.DTCCFR01])
                        {
                            myRoadBuilderTool._hashTableFreguesia["subroad"].row.add({
                                id_freguesia: featureProperty.IDFREGUESIA,
                                freguesia: featureProperty.FREGUESIA,
                                dtccfr:featureProperty.DTCCFR01
                            });
                            myRoadBuilderTool._hashTableFreguesia["subroad"].draw();
                            hashFreguesia[featureProperty.DTCCFR01] = 1;
                        }

                        // Fill sub road freguesia
                        $('#' + idClone + ' input.freguesia-name').val(featureProperty.FREGUESIA);
                        $('#' + idClone + ' input.freguesia-id').val(featureProperty.IDFREGUESIA);
                        $('#' + idClone + ' input.freguesia-dtccfr').val(featureProperty.DTCCFR01);
                    }
                }
            });
        }

        // Open modal
        $('#id-modal-road-build-tool-road').show();    
    }

    /**
     * Merge road
     */
    this._MergeRoad = function()
    {
        var hashRoad = {};
        var count = 1;
        myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures().forEach(function(featureIn, index)
        {
            var arrSeq = featureIn.getProperties().ARR_SEQ;
            if(!hashRoad[arrSeq])
                hashRoad[arrSeq] = count++;
        });
        var countSelectedFeature = Object.keys(hashRoad).length;

        if( countSelectedFeature != 2 )
        {
            toastr.options.positionClass = 'toast-top-center';
            toastr["warning"]("Seleccione 2 arruamentos");
            toastr.options.positionClass = 'toast-bottom-center';
            return;
        }

        // Join data
        myRoadBuilderTool._mergeRoadInfo = {
            idRoadMain: parseInt(myRoadBuilderTool._utility.GetKeyByValue(hashRoad, 1)),
            idRoadToMerge: parseInt(myRoadBuilderTool._utility.GetKeyByValue(hashRoad, 2))
        };

         $.ajax({
            type: 'POST',
            url: '/rest/app/RoadBuilderTool/InfoForMergeRoad',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(myRoadBuilderTool._mergeRoadInfo),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na obtenção de informação dos arruamentos");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Clean form
                            myRoadBuilderTool._CleanFormRoad();

                            // Active read in subroad
                            myRoadBuilderTool._ActiveForWriteOrReadFormRoad("subroad", true);

                            // Active write in road
                            myRoadBuilderTool._ActiveForWriteOrReadFormRoad("road", false);

                            // Title
                            $('#id-modal-road-build-tool-road-header-title')[0].innerHTML = 'Informação de Arruamento';

                            // Reset all active tab
                            $('#id-modal-road-build-tool-road-sub-road-info-li').parent().parent().find('li').removeClass('active');
                            $('#id-modal-road-build-tool-road-content .tab-pane').removeClass('active');

                            // Active tab edit sub road
                            $('#id-modal-road-build-tool-road-sub-road-info-li').parent().hide();

                            // Show and active tab road
                            $('#id-modal-road-build-tool-road-info-li').parent().show();
                            $('#id-modal-road-build-tool-road-info-li').parent().addClass('active');
                            $('#id-modal-road-build-tool-road-info').addClass('active');
                            $('#id-modal-road-build-tool-road-info-li').attr('title', 'Informação Geral');
                            $('#id-modal-road-build-tool-road-info-li')[0].innerHTML = 'Informação Geral';

                            // Active tab road detail
                            $('#id-modal-road-build-tool-road-info-detail-li').parent().show();
                            $('#id-modal-road-build-tool-road-info-detail-li').attr('title', 'Informação de detalhe');
                            $('#id-modal-road-build-tool-road-info-detail-li')[0].innerHTML = 'Informação de detalhe';

                            // Title tab list subroad
                            $('#id-modal-road-build-tool-road-list-sub-road-info-li').parent().show();
                            $('#id-modal-road-build-tool-road-list-sub-road-info-li').attr('title', 'Informação de troços');
                            $('#id-modal-road-build-tool-road-list-sub-road-info-li')[0].innerHTML = 'Informação de troços';

                            // Title tab road detail
                            $('#id-modal-road-build-tool-road-info-road-intersect-li').parent().hide();

                            // Fill button title save
                            $('#id-modal-road-build-tool-road-save').attr("title", "Gravar arruamento seleccionado");

                            // Fill form subroad info
                            //myRoadBuilderTool._FillForm(data.result.list_sub_road, 'id-modal-road-build-tool-road-sub-road-info-form');

                            // Fill road information
                            myRoadBuilderTool._FillForm(data.result.road, 'id-modal-road-build-tool-road-info-form');

                            // Fill road freguesia information
                            for(var i = 0; i < data.result.list_freguesia_road.length; i++)
                            {
                                var objRoadFreguesia = data.result.list_freguesia_road[i];

                                myRoadBuilderTool._hashTableFreguesia["road"].row.add({
                                    id_freguesia: objRoadFreguesia.id_freguesia,
                                    freguesia: objRoadFreguesia.freguesia,
                                    dtccfr: objRoadFreguesia.dtccfr
                                });
                                myRoadBuilderTool._hashTableFreguesia["road"].draw();
                            }

                            // Fill road detail information
                            myRoadBuilderTool._FillForm(data.result.road, 'id-modal-road-build-tool-road-info-detail-form');

                            // Fill subroad information
                            myRoadBuilderTool._BuildListSubRoadInformation(data.result.list_sub_road, data.result.hash_sub_road_freguesia, -1);

                            // Indicate the mode to save
                            myRoadBuilderTool._modeSaveSubRoad = 'merge_road';

                            // Show modal
                            $('#id-modal-road-build-tool-road').show();

                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na obtenção de informação de arruamento");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                    }
                }

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            },
             error: function (request, status, error) {
                 toastr.options.positionClass = 'toast-top-center';
                 toastr["error"]("Erro na obtenção de informação de arruamento");
                 toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /**
     * Save merge road
     */
    this._SaveMergeRoad = function()
    {
         myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Close Modal
        $('#id-modal-road-build-tool-road').hide();

        // Prepare data
        var jsonInfo = $('#id-modal-road-build-tool-road-info-form').serializeJSON();
        var jsonInfoDetail = $('#id-modal-road-build-tool-road-info-detail-form').serializeJSON();
        var jsonRoad = Object.assign(jsonInfo, jsonInfoDetail);
        
        // Get wkt of all subroad
        var listWktLineSubroad = [];
        var srid = myRoadBuilderTool._mapSgs._settings.projection.getCode().replace('EPSG:', '');
        myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures().forEach(function(featureIn, index)
        {
            listWktLineSubroad.push(new WKT().writeGeometry(featureIn.getGeometry()));
        });
        var mergeLine = {
            listLine: listWktLineSubroad,
            srid: srid
        }
       
        // Get subroad id
        var jsonInfoSubRoad = $('#id-modal-road-build-tool-road-list-sub-road-info-form').serializeJSON();
        var countKey = Object.keys(jsonInfoSubRoad.TROCO).length;
        var listIdTroco = [];
        for(var i = 0; i < countKey; i++) {
            var key =  Object.keys(jsonInfoSubRoad.TROCO)[i];
            listIdTroco.push(parseInt(jsonInfoSubRoad.TROCO[key].IDTROCO));
        }

        // Build data
        var dataInfo = {
            roadInfo: jsonRoad,
            idRoadToMerge: myRoadBuilderTool._mergeRoadInfo.idRoadToMerge,
            listIdTroco: listIdTroco,
            mergeLine: mergeLine
        }

        $.ajax({
            type: 'POST',
            url: '/rest/app/RoadBuilderTool/SaveMergeRoad',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(dataInfo),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na fusão do arruamento");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Clean all feature
                            myRoadBuilderTool._layerDrawLineRoad.getSource().clear();
                            myRoadBuilderTool._layerPointRoad.getSource().clear();
                            myRoadBuilderTool._layerSubRoadLine.getSource().clear();
                            myRoadBuilderTool._collectionFeatureIntercepted.clear();
                            myRoadBuilderTool._hashFeatureIntercepted = {};

                            // Clean form
                            myRoadBuilderTool._CleanFormRoadInfo();

                            // Refresh all route layer
                            var lengthLayer = Object.keys(myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info).length;
                            for(var i = 0; i < lengthLayer; i++) {
                                var key = Object.keys(myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info)[i];
                                var layerInfo = myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info[key].layer_info;
                                if(layerInfo.layerName === myRoadBuilderTool._layerNameSubRoadInMap && layerInfo.kind === 'WFS') {
                                    var layer = myRoadBuilderTool._mapSgs._utility.GetLayerByName(myRoadBuilderTool._mapSgs.map, layerInfo.layerNameKey);
                                    layer.getSource().clear();
                                }
                            }
                            
                            // Clean all road
                            myRoadBuilderTool._CleanAllRoad();

                            // Clear highlight
                            myRoadBuilderTool._mapSgs.layerHighlightOverlay.getSource().clear();

                            // Clean selection
                            myRoadBuilderTool._CleanSelect();

                            toastr.options.positionClass = 'toast-top-center';
                            toastr["success"]("Arruamento fundido com sucesso");
                            toastr.options.positionClass = 'toast-bottom-center';

                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na fusão do arruamento");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                    }
                }

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na fusão do arruamento");
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /**
     * Merge sub road
     */
    this._MergeSubRoad = function()
    {
        var countSelectedFeature = myRoadBuilderTool._select.getFeatures().getArray().length;
        myRoadBuilderTool._modeSaveSubRoad = "merge_sub_road";

        // Check if one or any subroad selection
        if( countSelectedFeature <= 1)
        {
            toastr.options.positionClass = 'toast-top-center';
            toastr["warning"]("Seleccione pelo menos 2 troços");
            toastr.options.positionClass = 'toast-bottom-center';
            return;
        }

        // If subroad selected are from diferent road
        if(myRoadBuilderTool._CheckIfSubroadSelectedDiferenteRoad())
        {
            $('#id-modal-road-build-tool-road-add-subroad-name')[0].innerHTML = myRoadBuilderTool._select.getFeatures().getArray()[0].getProperties().TROCO; // First subroad selected
            $('#id-modal-road-build-tool-road-add-subroad').show();

            return;
        }

        // Build list line sub road
        var arrayLine = [];
        var arrSeq = "";
        var subRoadDesig = "";
        for(var i = 0; i < countSelectedFeature; i++)
        {
            var feature = myRoadBuilderTool._select.getFeatures().getArray()[i];
            var property = feature.getProperties();

            if(i===0) {
                arrSeq = property.ARR_SEQ;
                subRoadDesig = property.TROCO;
            }

            // Simplified the geometry
            //var cloneFeature = feature.clone();
            //for(var j = 0; j < cloneFeature.getGeometry().flatCoordinates.length; j++)
            //{
            //    cloneFeature.getGeometry().flatCoordinates[j] = Math.trunc(cloneFeature.getGeometry().flatCoordinates[j]*1000000)/1000000;
            //}

            arrayLine.push(new WKT().writeGeometry(feature.getGeometry()));
        }
        var srid = myRoadBuilderTool._mapSgs._settings.projection.getCode().replace('EPSG:', '');

        // Start wait
        myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Clean
        myRoadBuilderTool._lineMergeWkt = "";
        myRoadBuilderTool._featureLineMergeWkt = null;

        // Join data
        var mergeLine = {
            listLine: arrayLine,
            srid: srid
        }

        $.ajax({
            type: 'POST',
            url: '/rest/app/RoadBuilderTool/MergeLineWKT',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(mergeLine),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na junção de troços");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // If line is not continuous
                            if (!data.result.is_countinuous) {
                                toastr.options.positionClass = 'toast-top-center';
                                toastr["warning"]("Os troços seleccionados tem de ser continuos");
                                toastr.options.positionClass = 'toast-bottom-center';
                                // Stop wait
                                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
                                return;
                            }

                            // Get line in wkt
                            myRoadBuilderTool._lineMergeWkt = data.result.line_wkt;
                            myRoadBuilderTool._featureLineMergeWkt = new WKT().readFeature(myRoadBuilderTool._lineMergeWkt, {
                                dataProjection: myRoadBuilderTool._mapSgs._settings.projection.code_,
                                featureProjection: myRoadBuilderTool._mapSgs._settings.projection.code_
                            });

                            // Clean form
                            myRoadBuilderTool._CleanFormSubRoadInfo();

                            // Fill form
                            myRoadBuilderTool._BuildMergeInformation(arrSeq, subRoadDesig);

                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na junção de troços");
                            toastr.options.positionClass = 'toast-bottom-center';

                            break;
                    }
                }

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na junção de troços");
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /**
     * Merge subroad to road
     */
    this._MergeSubRoadToRoad = function()
    {
        // Close modal
        $('#id-modal-road-build-tool-road-add-subroad').hide();

        // Start engine
        myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Get id road
        var idRoad = myRoadBuilderTool._select.getFeatures().getArray()[0].getProperties().ARR_SEQ;

        // Number of subroad selected
        var countSubroadSeleced =  myRoadBuilderTool._select.getFeatures().getArray().length;

        // Get id subroad selected
        var arrayIdSubroad = [];
        for( var i = 1; i < countSubroadSeleced; i++)
        {
            arrayIdSubroad.push({
                idSubroad: myRoadBuilderTool._select.getFeatures().getArray()[i].getProperties().IDTROCO,
                idRoad: myRoadBuilderTool._select.getFeatures().getArray()[i].getProperties().ARR_SEQ
            });
        }

        // Build input
        var addSubRoadtoRoadInfo =
        {
            idRoad: idRoad,
            srid: myRoadBuilderTool._mapSgs._settings.projection.getCode().replace('EPSG:', ''),
            listSubRoad: arrayIdSubroad
        }

        $.ajax({
            type: 'POST',
            url: '/rest/app/RoadBuilderTool/MergeSubRoadToRoad',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(addSubRoadtoRoadInfo),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na adição dos troços ao arruamento");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Clean all feature
                            myRoadBuilderTool._layerDrawLineRoad.getSource().clear();
                            myRoadBuilderTool._layerPointRoad.getSource().clear();
                            myRoadBuilderTool._layerSubRoadLine.getSource().clear();
                            myRoadBuilderTool._collectionFeatureIntercepted.clear();
                            myRoadBuilderTool._hashFeatureIntercepted = {};

                            // Clean form
                            myRoadBuilderTool._CleanFormRoadInfo();

                            // Refresh all route layer
                            var lengthLayer = Object.keys(myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info).length;
                            for(var i = 0; i < lengthLayer; i++) {
                                var key = Object.keys(myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info)[i];
                                var layerInfo = myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info[key].layer_info;
                                if(layerInfo.layerName === myRoadBuilderTool._layerNameSubRoadInMap && layerInfo.kind === 'WFS') {
                                    var layer = myRoadBuilderTool._mapSgs._utility.GetLayerByName(myRoadBuilderTool._mapSgs.map, layerInfo.layerNameKey);
                                    layer.getSource().clear();
                                }
                            }
                            
                            // Clean all road
                            myRoadBuilderTool._CleanAllRoad();

                            // Clear highlight
                            myRoadBuilderTool._mapSgs.layerHighlightOverlay.getSource().clear();

                            // Clean selection
                            myRoadBuilderTool._CleanSelect();

                            toastr.options.positionClass = 'toast-top-center';
                            toastr["success"]("Troços adicionados com sucesso");
                            toastr.options.positionClass = 'toast-bottom-center';

                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na adição dos troços ao arruamento");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                    }
                }

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na adição dos troços ao arruamento");
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /**
     * Fill form
     * @param {object} objSubRoad, subroad info object
     */
    this._FillForm = function(objSubRoad, idNodeForm)
    {
        for (var key in objSubRoad)
        {
            var value = objSubRoad[key];
            if (value != null && value.toString().trim() !== "")
            {
                switch (key) {
                    case "oneway":
                    case "id_arruamento_class":
                    case "idtiporua":
                        $("#" + idNodeForm + " [name='" + key + "']").val(value);
                        $("#" + idNodeForm + " [name='" + key + "']").selectpicker("refresh");
                        break;
                    case "length":
                    case "length_shape":
                        $("#" + idNodeForm + " [name='" + key + "']").val(Math.round(value * 100)/100);
                        break;
                    case "data_actua":
                    case "arr_reg_data":
                        $("#" + idNodeForm + " [name='" + key + "']").val(myRoadBuilderTool._utility.TransformDateServerInDateII(value));
                        break;
                    default:
                        $("#" + idNodeForm + " [name='" + key + "']").val(value);
                }
            }
        }
    }

    /**
     * Actice for reade or write form road
     * @param {string} elementType, element type where to read or write option to apply
     * @param {boolean} readonly, true if readonly 
     */
    this._ActiveForWriteOrReadFormRoad = function(elementType, readonly)
    {
        switch(elementType)
        {
            case "road":
                if(!readonly)
                {
                    // Road info
                    $('#id-modal-road-build-tool-road-info-form').find("input.change-wr, textarea.change-wr").removeAttr("readonly");
                    $('#id-modal-road-build-tool-road-info-select-id-arruamento-class').prop("disabled", false);
                    $('#id-modal-road-build-tool-road-info-select-id-tipo-rua').prop("disabled", false);

                    // Road detail info
                    $('#id-modal-road-build-tool-road-info-detail-form').find("input.change-wr, textarea.change-wr").removeAttr("readonly");
                }
                else {
                    // Road info
                    $('#id-modal-road-build-tool-road-info-form').find("input.change-wr, textarea.change-wr").attr("readonly", "readonly");
                    $('#id-modal-road-build-tool-road-info-select-id-arruamento-class').prop("disabled", true);
                    $('#id-modal-road-build-tool-road-info-select-id-tipo-rua').prop("disabled", true);

                    // Road detail info
                    $('#id-modal-road-build-tool-road-info-detail-form').find("input.change-wr, textarea.change-wr").attr("readonly", "readonly");
                }
                break;
            case "subroad":
                if(!readonly)
                {
                    // Subroad info
                    $('#id-modal-road-build-tool-road-sub-road-info-form').find("input.change-wr, textarea.change-wr").removeAttr("readonly");
                    $('#id-modal-road-build-tool-road-sub-road-info-select-one-way').prop("disabled", false);
                    $('#id-modal-road-build-tool-road-sub-road-info-select-one-way').parent().removeClass('disabled');
                    $('#id-modal-road-build-tool-road-sub-road-info-select-one-way').parent().find('button').removeClass('disabled');
                }
                else {
                    // Subroad info
                    $('#id-modal-road-build-tool-road-sub-road-info-form').find("input.change-wr, textarea.change-wr").attr("readonly", "readonly");
                    $('#id-modal-road-build-tool-road-sub-road-info-select-one-way').prop("disabled", true);
                }
                break;
            case "list_subroad":
                if(!readonly)
                {
                    // Subroad info
                    $('#id-modal-road-build-tool-road-list-sub-road-info-form').find("input.change-wr, textarea.change-wr").removeAttr("readonly");
                    $('#id-modal-road-build-tool-road-list-sub-road-info-form one-way').prop("disabled", false);
                }
                else {
                    // Subroad info
                    $('#id-modal-road-build-tool-road-list-sub-road-info-form').find("input.change-wr, textarea.change-wr").attr("readonly", "readonly");
                    $('#id-modal-road-build-tool-road-list-sub-road-info-form one-way').prop("disabled", true);
                }
                break;
            default:
                // Do nothing
        }
    }

    /**
     * Get sub road information
     */
    this._GetRoadInformationRoadType = function()
    {
        // Verify if only one road is selected
        var lengthFeatureSelect = myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures().length;
        if(lengthFeatureSelect === 0)
        {
            toastr.options.positionClass = 'toast-top-center';
            toastr["warning"]("Seleccione um arruamento");
            toastr.options.positionClass = 'toast-bottom-center';
            return;
        }
        var hashRoad = {};
        myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures().forEach(function(featureIn, index)
        {
            var arrSeq = featureIn.getProperties().ARR_SEQ;
            if(!hashRoad[arrSeq])
                hashRoad[arrSeq] = 1;
        });
        if( Object.keys(hashRoad).length > 1)
        {
            toastr.options.positionClass = 'toast-top-center';
            toastr["warning"]("Seleccione apenas um arruamento");
            toastr.options.positionClass = 'toast-bottom-center';
            return;
        }
        
        // Get road identifier
        var idRoad = myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures()[0].getProperties().ARR_SEQ;

        // Start wait
        myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Mode save sub road
        myRoadBuilderTool._modeSaveSubRoad = "road";

        $.ajax({
            type: 'GET',
            url: '/rest/app/RoadBuilderTool/GetRoadInformation?arrSeq=' + idRoad,
            contentType: "application/json",
            dataType: 'json',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na obtenção de informação de arruamento");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Clean form
                            myRoadBuilderTool._CleanFormRoad();

                            // Active read in subroad
                            myRoadBuilderTool._ActiveForWriteOrReadFormRoad("subroad", true);

                            // Active write in road
                            myRoadBuilderTool._ActiveForWriteOrReadFormRoad("road", false);

                            // Title
                            $('#id-modal-road-build-tool-road-header-title')[0].innerHTML = 'Informação de Arruamento';

                            // Reset all active tab
                            $('#id-modal-road-build-tool-road-sub-road-info-li').parent().parent().find('li').removeClass('active');
                            $('#id-modal-road-build-tool-road-content .tab-pane').removeClass('active');

                            // Active tab edit sub road
                            $('#id-modal-road-build-tool-road-sub-road-info-li').parent().hide();

                            // Show and active tab road
                            $('#id-modal-road-build-tool-road-info-li').parent().show();
                            $('#id-modal-road-build-tool-road-info-li').parent().addClass('active');
                            $('#id-modal-road-build-tool-road-info').addClass('active');
                            $('#id-modal-road-build-tool-road-info-li').attr('title', 'Informação Geral');
                            $('#id-modal-road-build-tool-road-info-li')[0].innerHTML = 'Informação Geral';

                            // Active tab road detail
                            $('#id-modal-road-build-tool-road-info-detail-li').parent().show();
                            $('#id-modal-road-build-tool-road-info-detail-li').attr('title', 'Informação de detalhe');
                            $('#id-modal-road-build-tool-road-info-detail-li')[0].innerHTML = 'Informação de detalhe';

                            // Title tab list subroad
                            $('#id-modal-road-build-tool-road-list-sub-road-info-li').parent().show();
                            $('#id-modal-road-build-tool-road-list-sub-road-info-li').attr('title', 'Informação de troços');
                            $('#id-modal-road-build-tool-road-list-sub-road-info-li')[0].innerHTML = 'Informação de troços';

                            // Title tab road detail
                            $('#id-modal-road-build-tool-road-info-road-intersect-li').parent().hide();

                            // Fill button title save
                            $('#id-modal-road-build-tool-road-save').attr("title", "Gravar arruamento seleccionado");

                            // Fill form subroad info
                            //myRoadBuilderTool._FillForm(data.result.sub_road, 'id-modal-road-build-tool-road-sub-road-info-form');

                            // Fill road information
                            myRoadBuilderTool._FillForm(data.result.road, 'id-modal-road-build-tool-road-info-form');

                            // Fill road freguesia information
                            for(var i = 0; i < data.result.list_freguesia_road.length; i++)
                            {
                                var objRoadFreguesia = data.result.list_freguesia_road[i];

                                myRoadBuilderTool._hashTableFreguesia["road"].row.add({
                                    id_freguesia: objRoadFreguesia.id_freguesia,
                                    freguesia: objRoadFreguesia.freguesia,
                                    dtccfr: objRoadFreguesia.dtccfr
                                });
                                myRoadBuilderTool._hashTableFreguesia["road"].draw();
                            }

                            // Fill road detail information
                            myRoadBuilderTool._FillForm(data.result.road, 'id-modal-road-build-tool-road-info-detail-form');

                            // Fill subroad information
                            myRoadBuilderTool._BuildListSubRoadInformation(data.result.list_sub_road, data.result.hash_sub_road_freguesia, -1);

                            // Show modal
                            $('#id-modal-road-build-tool-road').show();

                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na obtenção de informação de arruamento");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                    }
                }

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na obtenção de informação de arruamento");
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /**
     * Get sub road information
     */
    this._GetRoadInformationSubRoadType = function()
    {
        var countSelectedFeature = myRoadBuilderTool._select.getFeatures().getArray().length;

        // Check if zero road is selected
        if( countSelectedFeature < 1)
        {
            toastr.options.positionClass = 'toast-top-center';
            toastr["warning"]("Seleccione um troço");
            toastr.options.positionClass = 'toast-bottom-center';
            return;
        }

        // Check if more then one road is selected
        if( countSelectedFeature > 1)
        {
            toastr.options.positionClass = 'toast-top-center';
            toastr["warning"]("Seleccione apenas um troço");
            toastr.options.positionClass = 'toast-bottom-center';
            return;
        }

        // Start wait
        myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Mode save sub road
        myRoadBuilderTool._modeSaveSubRoad = "sub_road";

        // Get feature selected
        var lengthFeatureSelect = myRoadBuilderTool._select.getFeatures().getArray().length;
        if(lengthFeatureSelect === 0)
        {
            toastr.options.positionClass = 'toast-top-center';
            toastr["warning"]("Seleccione um troço");
            toastr.options.positionClass = 'toast-bottom-center';
            return;
        }
        if(lengthFeatureSelect > 1)
        {
            toastr.options.positionClass = 'toast-top-center';
            toastr["warning"]("Seleccione apenas um troço");
            toastr.options.positionClass = 'toast-bottom-center';
            return;
        }
        var idSubRoad = myRoadBuilderTool._select.getFeatures().getArray()[0].getProperties().IDTROCO;

        $.ajax({
            type: 'GET',
            url: '/rest/app/RoadBuilderTool/GetSubRoadInformation?idSubRoad=' + idSubRoad,
            contentType: "application/json",
            dataType: 'json',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na obtenção de informação de troço");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Clean form
                            myRoadBuilderTool._CleanFormRoad();

                            // Active write in subroad
                            myRoadBuilderTool._ActiveForWriteOrReadFormRoad("subroad", false);

                            // Active read in road
                            myRoadBuilderTool._ActiveForWriteOrReadFormRoad("road", true);

                            // Fill title header
                            $('#id-modal-road-build-tool-road-header-title')[0].innerHTML = "Informação de Troço";

                            // Reset all active tab
                            $('#id-modal-road-build-tool-road-sub-road-info-li').parent().parent().find('li').removeClass('active');
                            $('#id-modal-road-build-tool-road-content .tab-pane').removeClass('active');

                            // Active tab subroad info
                            $('#id-modal-road-build-tool-road-sub-road-info-li').parent().show();
                            $('#id-modal-road-build-tool-road-sub-road-info-li').parent().addClass('active');
                            $('#id-modal-road-build-tool-road-sub-road-info').addClass('active');
                            $('#id-modal-road-build-tool-road-sub-road-info-li').attr('title', 'Troço seleccionado');
                            $('#id-modal-road-build-tool-road-sub-road-info-li')[0].innerHTML = 'Troço seleccionado';

                            // Active tab road info
                            $('#id-modal-road-build-tool-road-info-li').parent().show();
                            $('#id-modal-road-build-tool-road-info-li').attr('title', 'Arruamento do troço');
                            $('#id-modal-road-build-tool-road-info-li')[0].innerHTML = 'Arruamento do troço';

                            // Active tab road detail info
                            $('#id-modal-road-build-tool-road-info-detail-li').parent().show();
                            $('#id-modal-road-build-tool-road-info-detail-li').attr('title', 'Detalhe do arruamento');
                            $('#id-modal-road-build-tool-road-info-detail-li')[0].innerHTML = 'Detalhe do arruamento';

                            // Active tab list subroad info
                            $('#id-modal-road-build-tool-road-list-sub-road-info-li').parent().show();
                            $('#id-modal-road-build-tool-road-list-sub-road-info-li').attr('title', 'Restantes troços');
                            $('#id-modal-road-build-tool-road-list-sub-road-info-li')[0].innerHTML = 'Restantes Troços';

                            // Title tab road detail
                            $('#id-modal-road-build-tool-road-info-road-intersect-li').parent().hide();

                            // Fill button title save
                            $('#id-modal-road-build-tool-road-save').attr("title", "Gravar troço seleccionado");

                            // Fill form subroad info
                            myRoadBuilderTool._FillForm(data.result.sub_road, 'id-modal-road-build-tool-road-sub-road-info-form');

                            // Fill subroad freguesia
                            for(var i = 0; i < data.result.list_sub_road_freguesia.length; i++)
                            {
                                var objSubRoadFreguesia = data.result.list_sub_road_freguesia[i];

                                myRoadBuilderTool._hashTableFreguesia["subroad"].row.add({
                                    id_freguesia: objSubRoadFreguesia.id_freguesia,
                                    freguesia: objSubRoadFreguesia.freguesia,
                                    dtccfr: objSubRoadFreguesia.dtccfr
                                });
                                myRoadBuilderTool._hashTableFreguesia["subroad"].draw();
                            }

                            // Fill road information
                            myRoadBuilderTool._FillForm(data.result.road.road, 'id-modal-road-build-tool-road-info-form');

                            // Fill road freguesia information
                            for(var i = 0; i < data.result.road.list_freguesia_road.length; i++)
                            {
                                var objRoadFreguesia = data.result.road.list_freguesia_road[i];

                                myRoadBuilderTool._hashTableFreguesia["road"].row.add({
                                    id_freguesia: objRoadFreguesia.id_freguesia,
                                    freguesia: objRoadFreguesia.freguesia,
                                    dtccfr: objRoadFreguesia.dtccfr
                                });
                                myRoadBuilderTool._hashTableFreguesia["road"].draw();
                            }

                            // Fill road detail information
                            myRoadBuilderTool._FillForm(data.result.road.road, 'id-modal-road-build-tool-road-info-detail-form');

                            // Fill subroad information
                            myRoadBuilderTool._BuildListSubRoadInformation(data.result.road.list_sub_road, data.result.road.hash_sub_road_freguesia, data.result.sub_road.id_troco);

                            // Show modal
                            $('#id-modal-road-build-tool-road').show();

                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na obtenção de informação de troço");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                    }
                }

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na obtenção de informação de troço");
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /**
     * Save sub road information
     */
    this._SaveSubRoadInfo = function()
    {
        myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Close Modal
        $('#id-modal-road-build-tool-road').hide();

        // Json for subroad information
        var subRoad = $('#id-modal-road-build-tool-road-sub-road-info-form').serializeJSON();

        $.ajax({
            type: 'POST',
            url: '/rest/app/RoadBuilderTool/SaveSubRoadInfo',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(subRoad),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na gravação de um troço");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["success"]("Troços gravado com sucesso");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na criação do troço");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                    }
                }

                // Clean all road
                myRoadBuilderTool._CleanAllRoad();


                // Clean selection
                myRoadBuilderTool._CleanSelect();

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na gravação de um troço");
                toastr.options.positionClass = 'toast-bottom-center';

                // Clear selection
                myRoadBuilderTool._select.setMap(undefined);

                // Clean all road
                myRoadBuilderTool._CleanAllRoad();

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /**
     * Get Road information
     */
    this._GetRoadInformation = function()
    {
        // Get information according element type selected
        switch(myRoadBuilderTool._elementTypeForOperarion)
        {
            case "road":
                myRoadBuilderTool._GetRoadInformationRoadType();
                break;
            case "subroad":
                myRoadBuilderTool._GetRoadInformationSubRoadType();
                break;
            default:
                // do nothing
        }
    }

    /**
     * Add select interaction for all road layer
     */
    this._ActiveSelectRoad = function()
    {
        // Get all layer for selection
        var lengthLayer = Object.keys(myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info).length;
        var arrayLayer = [];
        for(var i = 0; i < lengthLayer; i++) {
            var key = Object.keys(myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info)[i];
            var layerInfo = myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info[key].layer_info;
            if(
               (
                (layerInfo.layerName === myRoadBuilderTool._layerNameSubRoadInMap) || // subroad layer
                (layerInfo.layerName === myRoadBuilderTool._layerSourceNamePoliceNumber) // police number layer
               ) &&
               layerInfo.kind === 'WFS'
              )
            {
                var layer = myRoadBuilderTool._mapSgs._utility.GetLayerByName(myRoadBuilderTool._mapSgs.map, layerInfo.layerNameKey);
                arrayLayer.push(layer);
            }
        }

        // Add layer array selection
        this._CreateSelect(arrayLayer);

        // Active select
        myRoadBuilderTool._select.setActive(true);
        myRoadBuilderTool._dragBox.setActive(true);
    }

    /**
     * Select road action
     */
    this._SelectRoadAction = function()
    {
        myRoadBuilderTool._featureSubRoadFromRoadSelected = myRoadBuilderTool._select.getFeatures().getArray()[0];
        var arrSeq = myRoadBuilderTool._featureSubRoadFromRoadSelected.getProperties().ARR_SEQ;
        var cqlFilter = "ARR_SEQ == " + arrSeq;
        myRoadBuilderTool._GetSubRoadInfoByIdRoad(myRoadBuilderTool._layerInfoSubRoad, cqlFilter);
        myRoadBuilderTool._GetRoadInfoByIdRoad(myRoadBuilderTool._layerInfoRoad, cqlFilter);

        // Clear select interaction
        myRoadBuilderTool._CleanSelect();
    }

    /**
     * Clear selection road
     */
    this._ClearSelectionRoad = function()
    {
        // Clear all the feature highlight
         myRoadBuilderTool._mapSgs.ClearSource(myRoadBuilderTool._mapSgs.layerHighlightOverlay);

        // Clear subroad feature selected
        myRoadBuilderTool._layerSubRoadFromRoad.getSource().clear();

        // Clear road feature selected
        myRoadBuilderTool._layerPointRoad.getSource().clear();

        // Clear subroad and police number selected
        myRoadBuilderTool._layerSubRoadPoliceSelected.getSource().clear();
        myRoadBuilderTool._layerPoliceAssociateToSubRoadSelected.getSource().clear();
    }

    /**
     * Clear selection road
     */
    this._ClearSelectionRoad2 = function () {
        // Clear all the feature highlight
        myRoadBuilderTool._mapSgs.ClearSource(myRoadBuilderTool._mapSgs.layerHighlightOverlay);

        // Clear subroad and police number selected
        myRoadBuilderTool._layerSubRoadPoliceSelected.getSource().clear();
        myRoadBuilderTool._layerPoliceAssociateToSubRoadSelected.getSource().clear();
    }

    /**
     * Select subroad action
     */
    this._SelectSubRoadAction = function()
    {
        // Clean selection highlight
        myRoadBuilderTool._mapSgs.layerHighlightOverlay.getSource().clear();

        var countFeatureSelected = myRoadBuilderTool._select.getFeatures().getArray().length;
        for(var i = 0; i < countFeatureSelected; i++)
        {
            var feature = myRoadBuilderTool._select.getFeatures().getArray()[i];

            // Do especific for road
            if(feature.getId().split('.')[0] === myRoadBuilderTool._layerNameSubRoadInMap)
            {
                var idSubRoad = feature.getProperties().IDTROCO;
                //feature.setStyle(myRoadBuilderTool._styleSelectRoad);
                //feature.getStyle()[myRoadBuilderTool._styleSelectRoad.length-1].getText().setText(evt.selected[0].getProperties().TROCO);
                //feature.set('text', idSubRoad);

                // Road mode
                if($('#target-gpi-road-mode').hasClass('active'))
                {
                    // Select subroad
                    if($('#target-gpi-road-tool-select-road').parent().hasClass("active")) {
                    }
                    //myRoadBuilderTool._HighLightSubRoad(idSubRoad);
                }

                // Police mode
                if($('#target-gpi-police-mode').hasClass('active'))
                {
                    // Add feature to layer subroad police
                    myRoadBuilderTool._layerSubRoadPoliceSelected.getSource().addFeature(feature);

                    // Highlight all police number of the sub road
                    myRoadBuilderTool._HighLightSubRoadPoliceNumber(idSubRoad);
                }
            }

            if(countFeatureSelected === 1)
            {
                var geom = feature.getGeometry();
                var subRoadDesig = feature.getProperties().TROCO;
                var idSubRoad = feature.getProperties().IDTROCO;
                var area_m2;
                var length_m;
                var area_ha;

                if (geom instanceof LineString || geom instanceof MultiLineString)
                {
                    length_m = myRoadBuilderTool._utility.LengthLine(geom);;

                    $('#offcanvas-rbt-info header')[0].innerHTML = 'Troço informação';
                    $('#offcanvas-rbt-info .sgs-element-rbt-input').html('#' + idSubRoad + " " + subRoadDesig);
                    $('#offcanvas-rbt-info .sgs-measure-rbt-input-m').html("Comprimento: " + length_m);

                    $('#offcanvas-rbt-info').addClass('show');
                }
                else if (geom instanceof Point || geom instanceof MultiPoint)
                {
                    var coordinates = geom.getCoordinates();
                    if (geom instanceof MultiPoint)
                        coordinates = coordinates[0]
        
                    $('#offcanvas-info header')[0].innerHTML = 'Número de polícia';
                    $('#sgs-measure-input-m').html('Coordenada X: ' + coordinates[0]);
                    $('#sgs-measure-input-ha').html('Coordenada Y: ' + coordinates[1]);
                    $('#offcanvas-info').addClass('show');
                    if (myRoadBuilderTool._utility.mobilecheck())
                        $('#offcanvas-info').addClass('showreponsive')
                    $('#offcanvas-info').removeClass('height-length');
                }
                else {
                    if (geom instanceof Polygon) {
                        area_m2 = myRoadBuilderTool._utility.AreaFunction(geom);
                        area_ha = Math.round(myRoadBuilderTool._utility.ConvertToHa(parseFloat(area_m2)) * 100) / 100;
                    }
                    else if (geom instanceof MultiPolygon) {
                        area_m2 = myRoadBuilderTool._utility.areaFunction(geom);
                        area_ha = Math.round(myRoadBuilderTool._utility.ConvertToHa(parseFloat(area_m2)) * 100) / 100;
                    }

                    var output_area_m2 = Math.round(area_m2 * 100) / 100 + ' m<sup>2</sup>';
                    var output_area_ha;
                    if (area_ha)
                        output_area_ha = area_ha + ' ha';

                    $('#offcanvas-info').addClass('show');
                    if (myRoadBuilderTool._utility.mobilecheck())
                        $('#offcanvas-info').addClass('showreponsive')
                    $('#offcanvas-info').removeClass('height-length');

                    $('#offcanvas-info header')[0].innerHTML = 'Área';
                    $('#sgs-measure-input-m').html(output_area_m2);
                    $('#sgs-measure-input-ha').html(output_area_ha);
                }
            }
        }

        // Active modify
        if (myRoadBuilderTool._useSelectModify)
        {    
            // Show submit button
            $('#target-gpi-submit-road-builder-tool').show("slide");

            myRoadBuilderTool._modify = new Modify({
                features: myRoadBuilderTool._select.getFeatures()
            });
            myRoadBuilderTool._modify.setActive(true);

            // On modify start
            myRoadBuilderTool._modify.on('modifystart', function(evt)
            {
                myRoadBuilderTool._layerPointRoad.getSource().clear();
                myRoadBuilderTool._layerSubRoadLine.getSource().clear();
                myRoadBuilderTool._collectionFeatureIntercepted.clear();
                myRoadBuilderTool._hashFeatureIntercepted = {};
                myRoadBuilderTool._startModify = true;
                // Need to restar snap on modify selection
                if ($('#target-gpi-snapping-road-builder-tool').hasClass('hold-single-button')) {
                    // Off snap
                    $('#target-gpi-snapping-road-builder-tool')[0].click();
                    // On snap
                    $('#target-gpi-snapping-road-builder-tool')[0].click();
                }
            });

            // On modify end
            myRoadBuilderTool._modify.on('modifyend', function(evt)
            {
                var geom = evt.features.getArray()[0].getGeometry();
                var length_m;
                var feature = evt.features.getArray()[0];
                var geojsonFormat = new GeoJSON();
                var idFeature = feature.getId();

                // Set feature modify
                if (myRoadBuilderTool._arraySubRoadFeatureModify.length > 0) {
                    // Replace feature if exists
                    myRoadBuilderTool._arraySubRoadFeatureModify = myRoadBuilderTool._arraySubRoadFeatureModify.filter(c => c.getId() != idFeature);                    
                }
                myRoadBuilderTool._arraySubRoadFeatureModify.push(feature);

                // Clone feature and transform to 4326
                var featureClone = feature.clone();
                featureClone.getGeometry().transform(myRoadBuilderTool._mapSgs._settings.projection.getCode(), myRoadBuilderTool._mapSgs._settings.projectionWgs84.getCode());
                var featureGeojsonWgs84 = geojsonFormat.writeFeatureObject(featureClone);

                var featureGeojson = geojsonFormat.writeFeatureObject(feature);

                if (geom instanceof LineString || geom instanceof MultiLineString) {
                    length_m = myRoadBuilderTool._utility.LengthLine(geom);

                    $('#offcanvas-info header')[0].innerHTML = 'Comprimento';
                    $('#sgs-measure-input-m').html(length_m);
                    $('#sgs-measure-input-ha').html("");

                    $('#offcanvas-info').addClass('show');
                    if (myRoadBuilderTool._utility.mobilecheck())
                        $('#offcanvas-info').addClass('showreponsive')
                    $('#offcanvas-info').addClass('height-length');
                }

                // Interception with feature road and freguesia
                myRoadBuilderTool._hasInterception = false;
                var hashSamePoint = {};
                myRoadBuilderTool._layerPointRoad.getSource().clear();
                myRoadBuilderTool._layerSubRoadLine.getSource().clear();
                myRoadBuilderTool._collectionFeatureIntercepted.clear();
                myRoadBuilderTool._hashFeatureIntercepted = {};

                // Get info from feature modify
                var layerNameFeature = "";
                var arrayIdSplitFeature = idFeature.split(".");
                if (arrayIdSplitFeature[0])
                    layerNameFeature = arrayIdSplitFeature[0];
                var arrSeqFeature = feature.getProperties().ARR_SEQ;

                myRoadBuilderTool.collectionFeatureSet.getArray().forEach(function(featureIn, index)
                {
                    var idFeatureIn = featureIn.getId();
                    var layerNameFeatureIn = "";
                    var arrayIdSplitFeatureIn = idFeatureIn.split(".");
                    if (arrayIdSplitFeatureIn[0])
                        layerNameFeatureIn = arrayIdSplitFeatureIn[0];
                    var arrSeqFeatureIn = (layerNameFeatureIn == "V_ESTRADAS") ? featureIn.getProperties().ARR_SEQ : "";
                    if (idFeature !== idFeatureIn)
                    {
                        // Clone feature and transform to 4326
                        var featureInClone = featureIn.clone();
                        featureInClone.getGeometry().transform(myRoadBuilderTool._mapSgs._settings.projection.getCode(), myRoadBuilderTool._mapSgs._settings.projectionWgs84.getCode());

                        var featureInGeojsonWgs84 = geojsonFormat.writeFeatureObject(featureInClone);
                        var featureIntersectGeojsonWgs84 = turf.lineIntersect(featureGeojsonWgs84, featureInGeojsonWgs84);
                        if (featureIntersectGeojsonWgs84 !== null && featureIntersectGeojsonWgs84.features.length > 0) {
                            myRoadBuilderTool._hasInterception = true;
                            myRoadBuilderTool._collectionFeatureIntercepted.push(featureIn);
                            var lengthPointFeature = featureIntersectGeojsonWgs84.features.length;
                            for (var i = 0; i < lengthPointFeature; i++) {
                                var featureToReadGeoJsonWgs84 = featureIntersectGeojsonWgs84.features[i];

                                var featureToReadTmp = new Feature({
                                    geometry: (new Point(featureToReadGeoJsonWgs84.geometry.coordinates)).transform(myRoadBuilderTool._mapSgs._settings.projectionWgs84.getCode(), myRoadBuilderTool._mapSgs._settings.projection.getCode())
                                });
                                var featureToRead = geojsonFormat.writeFeatureObject(featureToReadTmp);
                                var key = JSON.stringify(featureToRead.geometry.coordinates);
                                if(hashSamePoint[key])
                                    continue;
                                else
                                    hashSamePoint[key] = 1;
                                var featureIntersectPoint = geojsonFormat.readFeature(featureToRead);
                                myRoadBuilderTool._layerPointRoad.getSource().addFeature(featureIntersectPoint);

                                if( featureIn.getId().split('.')[0] === myRoadBuilderTool._layerNameSubRoadInMap)
                                {
                                    // Considere feature only if point coordinate diferent of last or first coordinate of the line
                                    if(
                                        !(
                                            (JSON.stringify(featureInGeojsonWgs84.geometry.coordinates[0]) === JSON.stringify(featureToReadGeoJsonWgs84.geometry.coordinates)) ||
                                            (JSON.stringify(featureInGeojsonWgs84.geometry.coordinates[featureInGeojsonWgs84.geometry.coordinates.length - 1]) === JSON.stringify(featureToReadGeoJsonWgs84.geometry.coordinates))
                                         )
                                    ) {
                                        var idSubRoadFeatureIn = featureIn.getProperties().IDTROCO;
                                        if(!myRoadBuilderTool._hashFeatureIntercepted[idSubRoadFeatureIn])
                                        {
                                            myRoadBuilderTool._hashFeatureIntercepted[idSubRoadFeatureIn] =
                                            {
                                                featureIntercepted: featureIn,
                                                arrayFeatureIntersectPoint: [featureIntersectPoint]
                                            };
                                        }
                                        else
                                        {
                                            myRoadBuilderTool._hashFeatureIntercepted[idSubRoadFeatureIn].arrayFeatureIntersectPoint.push(featureIntersectPoint);
                                        }
                                    }
                                }
                            }
                        }
                    }
                });

                if (myRoadBuilderTool._hasInterception) {
                    // Build subroad from point
                    var arraySubRoadGeojson = myRoadBuilderTool._SplitLine(featureGeojson, myRoadBuilderTool._layerPointRoad.getSource().getFeatures());

                    // Add subroad created to layer
                    var idSubRoad = feature.getProperties().IDTROCO;
                    var hashFreguesiaCheck = {};
                    if (!myRoadBuilderTool._updateSubRoadInfo.newSubRoad) {
                        myRoadBuilderTool._updateSubRoadInfo.newSubRoad = {
                            idRoad: feature.getProperties().ARR_SEQ,
                            geomSrid: myRoadBuilderTool._mapSgs._settings.projection.getCode().replace('EPSG:', ''),
                            userName: myRoadBuilderTool._mapSgs._settings.userInfo.userName,
                            roadGeometryChange: (arraySubRoadGeojson.length > 0) ? true : false,
                            hashSubRoad: {}
                        };
                    }
                    myRoadBuilderTool._updateSubRoadInfo.newSubRoad.hashSubRoad[idSubRoad] = [];
                    for (var t = 0; t < arraySubRoadGeojson.length; t++) {


                        var featureSubRoad = geojsonFormat.readFeature(arraySubRoadGeojson[t]);
                        var featureSubRoadGeojson = geojsonFormat.writeFeatureObject(featureSubRoad);

                        // Find freguesia by subroad generate
                        var arraySubRoadFreguesia = myRoadBuilderTool._GetFreguesiaOfSubRoad(featureSubRoadGeojson, feature.getProperties().IDTROCO);

                        myRoadBuilderTool._updateSubRoadInfo.newSubRoad.hashSubRoad[idSubRoad].push({
                            newSubRoadGeom: {
                                id_current_sub_road: idSubRoad,
                                id_sub_road: t,
                                geom_wkt: new WKT().writeGeometry(featureSubRoad.getGeometry()),
                                geom_srid: myRoadBuilderTool._mapSgs._settings.projection.getCode().replace('EPSG:', '')
                            },
                            listSubRoadFreguesia: arraySubRoadFreguesia
                        });
                    }

                    // Split intercepted subroad
                    for (var y = 0; y < Object.keys(myRoadBuilderTool._hashFeatureIntercepted).length; y++) {
                        var key = Object.keys(myRoadBuilderTool._hashFeatureIntercepted)[y];
                        var featureInterceptedGeojson = geojsonFormat.writeFeatureObject(myRoadBuilderTool._hashFeatureIntercepted[key].featureIntercepted);
                        var arrayFeatureIntersectPoint = myRoadBuilderTool._hashFeatureIntercepted[key].arrayFeatureIntersectPoint;

                        var arraySubRoadGeojson = myRoadBuilderTool._SplitLine(featureInterceptedGeojson, arrayFeatureIntersectPoint);

                        // Add subroad created from intercept subroad to layer
                        hashFreguesiaCheck = {};
                        myRoadBuilderTool._updateSubRoadInfo.newSubRoadOtherRoad = {
                            idRoad: -1,
                            geomSrid: "",
                            userName: "",
                            roadGeometryChange: false,
                            hashSubRoad: {}
                        };
                        for (var d = 0; d < arraySubRoadGeojson.length; d++) {
                            var featureSubRoad = geojsonFormat.readFeature(arraySubRoadGeojson[d]);
                            var featureSubRoadGeojson = geojsonFormat.writeFeatureObject(featureSubRoad);

                            // Find freguesia by subroad generate
                            var arraySubRoadFreguesia = myRoadBuilderTool._GetFreguesiaOfSubRoad(featureSubRoadGeojson, feature.getProperties().IDTROCO);

                            var idSubRoad = featureInterceptedGeojson.properties.IDTROCO;
                            var objSubRoad = {
                                newSubRoadGeom: {
                                    id_current_sub_road: idSubRoad,
                                    id_sub_road: d,
                                    geom_wkt: new WKT().writeGeometry(featureSubRoad.getGeometry()),
                                    geom_srid: myRoadBuilderTool._mapSgs._settings.projection.getCode().replace('EPSG:', '')
                                },
                                listSubRoadFreguesia: arraySubRoadFreguesia
                            };

                            if (!myRoadBuilderTool._updateSubRoadInfo.newSubRoadOtherRoad.hashSubRoad[idSubRoad]) {
                                myRoadBuilderTool._updateSubRoadInfo.newSubRoadOtherRoad.hashSubRoad[idSubRoad] = [objSubRoad];
                            }
                            else {
                                myRoadBuilderTool._updateSubRoadInfo.newSubRoadOtherRoad.hashSubRoad[idSubRoad].push(objSubRoad);
                            }
                        }
                    }
                }
                else { // No interception 
                    var idSubRoad = feature.getProperties().IDTROCO;

                    // Add road if not exists
                    if (myRoadBuilderTool._updateSubRoadInfo.newSubRoad == undefined) {
                        myRoadBuilderTool._updateSubRoadInfo.newSubRoad = {
                            idRoad: arrSeqFeature,
                            geomSrid: myRoadBuilderTool._mapSgs._settings.projection.getCode().replace('EPSG:', ''),
                            userName: myRoadBuilderTool._mapSgs._settings.userInfo.userName,
                            roadGeometryChange: true,
                            hashSubRoad: {}
                        };
                    }

                    // Find freguesia by subroad generate
                    var arraySubRoadFreguesia = myRoadBuilderTool._GetFreguesiaOfSubRoad(featureGeojson, idSubRoad);

                    // Add sub road to road structure
                    myRoadBuilderTool._updateSubRoadInfo.newSubRoad.hashSubRoad[idSubRoad] = [{
                        newSubRoadGeom: {
                            id_current_sub_road: idSubRoad,
                            id_sub_road: -1,
                            geom_wkt: new WKT().writeGeometry(feature.getGeometry()),
                            geom_srid: myRoadBuilderTool._mapSgs._settings.projection.getCode().replace('EPSG:', '')
                        },
                        listSubRoadFreguesia: arraySubRoadFreguesia
                    }];
                }

                // Highlight sub road
                myRoadBuilderTool._HighLightSubRoadToSave(myRoadBuilderTool._updateSubRoadInfo, false);
            });

            myRoadBuilderTool._mapSgs.map.addInteraction(myRoadBuilderTool._modify);
        }
        else {
            if (myRoadBuilderTool._modify) myRoadBuilderTool._modify.setActive(false);
        }
    }

    /**
     * Highlight sub road
     */
    this._HighLightSubRoadToSave = function (roadInfo, create) {
        myRoadBuilderTool._layerPointRoad.getSource().clear();
        myRoadBuilderTool._layerSubRoadLine.getSource().clear();
        const format = new WKT();
        var idSeq = 1;

        // highlight sub road from road
        if (roadInfo.newSubRoad && roadInfo.newSubRoad.hashSubRoad && Object.keys(roadInfo.newSubRoad.hashSubRoad).length > 0) {
            Object.keys(roadInfo.newSubRoad.hashSubRoad).forEach(function (idSubRoad) {
                var objSubRoad = roadInfo.newSubRoad.hashSubRoad[idSubRoad];

                if (objSubRoad instanceof Array) {
                    objSubRoad.forEach(function (subRoadInfo) {
                        if (subRoadInfo.newSubRoadGeom) {
                            var featureExtract = format.readFeature(subRoadInfo.newSubRoadGeom.geom_wkt, {
                                featureProjection: 'EPSG:' + subRoadInfo.newSubRoadGeom.geom_srid
                            });
                            featureExtract.setId(idSubRoad + "." + idSeq++)
                            myRoadBuilderTool._AddFeatureToHighlightLayer(myRoadBuilderTool._layerSubRoadLine, myRoadBuilderTool._layerPointRoad, featureExtract);
                        }
                    });
                }
                else {
                    if (objSubRoad.newSubRoadGeom) {
                        var featureExtract = format.readFeature(objSubRoad.newSubRoadGeom.geom_wkt, {
                            featureProjection: 'EPSG:' + objSubRoad.newSubRoadGeom.geom_srid
                        });
                        featureExtract.setId(idSubRoad)
                        featureExtract.setProperties({ other_road: false, id_tmp_sub_road: idSubRoad });
                        myRoadBuilderTool._AddFeatureToHighlightLayer(myRoadBuilderTool._layerSubRoadLine, myRoadBuilderTool._layerPointRoad, featureExtract);
                    }
                }
            });
        }

        // highlight sub road from other road
        if (roadInfo.newSubRoadOtherRoad && roadInfo.newSubRoadOtherRoad.hashSubRoad && Object.keys(roadInfo.newSubRoadOtherRoad.hashSubRoad).length > 0) {
            Object.keys(roadInfo.newSubRoadOtherRoad.hashSubRoad).forEach(function (idSubRoad) {
                var arraySubRoad = roadInfo.newSubRoadOtherRoad.hashSubRoad[idSubRoad];
                arraySubRoad.forEach(function (subRoadInfo) {
                    if (subRoadInfo.newSubRoadGeom) {
                        var featureExtract = format.readFeature(subRoadInfo.newSubRoadGeom.geom_wkt, {
                            featureProjection: 'EPSG:' + subRoadInfo.newSubRoadGeom.geom_srid
                        });
                        featureExtract.setId(idSubRoad + "." + idSeq++);
                        if (create) {
                            featureExtract.setProperties({ IDTROCO: idSubRoad, other_road: true });
                        }
                        myRoadBuilderTool._AddFeatureToHighlightLayer(myRoadBuilderTool._layerSubRoadLine, myRoadBuilderTool._layerPointRoad, featureExtract);
                    }
                });
            });
        }
    }

    /**
     * Add feature to layer highlight
     * @param {any} layerLine
     * @param {any} layerPoint
     * @param {any} feature
     */
    this._AddFeatureToHighlightLayer = function (layerLine, layerPoint, feature) {
        var idFeature = feature.getId();

        // Remove feaature line and feature point if exists
        //if (layerLine.getSource().getFeatures().length > 0 && idFeature != null && idFeature != undefined) {
        //    var featureFind = layerLine.getSource().getFeatureById(idFeature);
        //    if (featureFind) {
        //        layerLine.getSource().removeFeature(featureFind);
        //        if (layerPoint.getSource().getFeatures().length > 0) {
        //            var featureFindFirstPoint = layerPoint.getSource().getFeatureById(idFeature + ".first");
        //            if (featureFindFirstPoint)
        //                layerPoint.getSource().removeFeature(featureFindFirstPoint);
        //            var featureFindLastPoint = layerPoint.getSource().getFeatureById(idFeature + ".last");
        //            if (featureFindLastPoint)
        //                layerPoint.getSource().removeFeature(featureFindLastPoint);
        //        }
        //    }
        //}

        // Add layer line
        var newStyle = myRoadBuilderTool._styleLineSubRoad[0].clone();
        newStyle.getStroke().setColor('rgba(' + Math.round((Math.random() * (255 - 0) + 0)) + ', ' + Math.round((Math.random() * (255 - 0) + 0)) + ', ' + Math.round((Math.random() * (255 - 0) + 0)) + ', 0.5)');

        var styleRoad = [
            new Style({
                stroke: new Stroke({
                    color: 'rgba(255, 255, 0, 1)',
                    width: 6
                })
            })
        ];
        styleRoad.push(newStyle);

        feature.setStyle(styleRoad);
        layerLine.getSource().addFeature(feature);

        // First point
        var featureFirstPoint = new Feature({
            geometry: new Point(feature.getGeometry().getFirstCoordinate()),
            name: "first-point-info-line-subroad",
            id: idFeature + ".first"
        });
        featureFirstPoint.setId(idFeature + ".first");
        layerPoint.getSource().addFeature(featureFirstPoint);

        // Last point
        var featureLastPoint = new Feature({
            geometry: new Point(feature.getGeometry().getLastCoordinate()),
            name: "last-point-info-line-subroad",
            id: idFeature + ".last"
        });
        featureLastPoint.setId(idFeature + ".last");
        layerPoint.getSource().addFeature(featureLastPoint);
    }

    /**
     * Remove feature to layer highlight
     * @param {any} layerLine
     * @param {any} layerPoint
     * @param {any} idFeature
     */
    this._RemoveFeatureToHighlightLayer = function (layerLine, layerPoint, idFeature) {

        // Remove feaature line and feature point if exists
        if (layerLine.getSource().getFeatures().length > 0 && idFeature != null && idFeature != undefined) {
            var featureFind = layerLine.getSource().getFeatureById(idFeature);
            if (featureFind) {
                layerLine.getSource().removeFeature(featureFind);
                if (layerPoint.getSource().getFeatures().length > 0) {
                    var featureFindFirstPoint = layerPoint.getSource().getFeatureById(idFeature + ".first");
                    if (featureFindFirstPoint)
                        layerPoint.getSource().removeFeature(featureFindFirstPoint);
                    var featureFindLastPoint = layerPoint.getSource().getFeatureById(idFeature + ".last");
                    if (featureFindLastPoint)
                        layerPoint.getSource().removeFeature(featureFindLastPoint);
                }
            }
        }
    }

    /**
     * Get freguesia array of a sub road
     * @param {any} featureSubRoadGeojson
     */
    this._GetFreguesiaOfSubRoad = function (featureSubRoadGeojson, idSubRoad) {
        var geojsonFormat = new GeoJSON();
        var arraySubRoadFreguesia = [];
        var hashFreguesiaCheck = {};
        myRoadBuilderTool.collectionFeatureSet.getArray().forEach(function (featureIn, index) {
            var featureInGeojson = geojsonFormat.writeFeatureObject(featureIn);

            if (featureIn.getId().indexOf("FREGUESIA") >= 0) {
                if (turf.booleanCrosses(featureSubRoadGeojson, featureInGeojson) || turf.booleanContains(featureInGeojson, featureSubRoadGeojson)) {
                    var idSubRoadFeatureIn = idSubRoad;
                    var idFreguesia = featureIn.getProperties().IDFREGUESIA;
                    var freguesia = featureIn.getProperties()["FREGUESIA"];
                    var dtccfr = featureIn.getProperties()["DTCCFR01"];
                    var key = idSubRoadFeatureIn + "_" + idFreguesia;
                    if (!hashFreguesiaCheck[key]) {
                        arraySubRoadFreguesia.push({
                            id_freguesia_troco: -1,
                            id_troco: idSubRoadFeatureIn,
                            id_freguesia: idFreguesia,
                            freguesia: (freguesia != null && freguesia != undefined) ? freguesia: "",
                            dtccfr: (dtccfr != null && dtccfr != undefined) ? dtccfr : "",
                        });
                    }
                }
            }
        });

        return arraySubRoadFreguesia;
    }

    /**
     * Create select interaction
     * @param {array} arrayLayer, array of layer for interaction
     */
    this._CreateSelect = function (arrayLayer)
    {
        // desactive select if exists
        myRoadBuilderTool._ClearSelect()

        // Desactive modify if exists
        myRoadBuilderTool._ClearModify2();

        // If array empty
        arrayLayer = (arrayLayer && arrayLayer.length === 0) ? undefined : arrayLayer;

        // Define select
        myRoadBuilderTool._select = new Select({
            condition: function (e) {
                var clicke = false;
                if (altKeyOnly(e)) // If alt press then modify feature
                {
                    clicke = click(e);
                    if (clicke) {
                        myRoadBuilderTool._useSelectModify = true;
                    }
                    else {
                        myRoadBuilderTool._useSelectModify = true;
                    }
                }
                else {
                    myRoadBuilderTool._useSelectModify = false;
                    clicke = click(e);
                }

                return clicke; //click(e);
            },
            layers: arrayLayer,
            wrapX: false,
            style: myRoadBuilderTool._styleSelectRoad,
            multi: true,
            hitTolerance: 5
        });

        // Event on select
        myRoadBuilderTool._select.on('select', function (evt)
        {
            // Action select
            switch(myRoadBuilderTool._elementTypeForOperarion)
            {
                case "subroad":
                    // If more then one select, dont modify
                    if(evt.selected.length > 1)
                    {
                        myRoadBuilderTool._ClearModify();
                        return;
                    }

                    // Cannot select subroad from another road
                    if (evt.selected.length == 1) {
                        var feature = myRoadBuilderTool._select.getFeatures().getArray()[0];
                        var arrReqSelect = feature.getProperties().ARR_SEQ;
                        if (myRoadBuilderTool._idRoadSelectedInModify == null) {
                            myRoadBuilderTool._idRoadSelectedInModify = arrReqSelect;
                        }
                        else {
                            if (myRoadBuilderTool._idRoadSelectedInModify != arrReqSelect && app.sgs.Map._roadBuilderTool._arraySubRoadFeatureModify.length > 0) {
                                if (myRoadBuilderTool._modify && myRoadBuilderTool._modify.getActive()) {
                                    myRoadBuilderTool._UndoModify2();
                                }
                                $('#offcanvas-info').removeClass('show');

                                // Clean road selected
                                myRoadBuilderTool._ClearSelectionRoad();

                                // Remove subroad information
                                $('#offcanvas-info').removeClass('show');
                                $('#offcanvas-rbt-info').removeClass('show');

                                toastr.options.positionClass = 'toast-top-center';
                                toastr["warning"]("Não é possível seleccionar um troço de outra estrada");
                                toastr.options.positionClass = 'toast-bottom-center';

                                return;
                            }
                        }
                    }

                    // If 0 selected and active modify undo
                    if(evt.selected.length == 0)
                    {
                        if( myRoadBuilderTool._modify && myRoadBuilderTool._modify.getActive())
                        {
                            myRoadBuilderTool._UndoModify2();
                        }
                        $('#offcanvas-info').removeClass('show');

                        // Clean road selected
                        myRoadBuilderTool._ClearSelectionRoad2();

                        // Remove subroad information
                        $('#offcanvas-info').removeClass('show');
                        $('#offcanvas-rbt-info').removeClass('show');

                        return;
                    }

                    myRoadBuilderTool._SelectSubRoadAction();
                    break;
                case "road":
                    myRoadBuilderTool._SelectRoadAction();
                    break;
                default:
                    // do nothing
            }
        });

        // Add interaction
        myRoadBuilderTool._mapSgs.map.addInteraction(myRoadBuilderTool._select);
    };

    /**
     * Clean select
     */
    this._CleanSelect = function()
    {
        if (myRoadBuilderTool._select)
        {
            myRoadBuilderTool._select.setMap(undefined);
            if(myRoadBuilderTool._select.getActive())
            {
                myRoadBuilderTool._ActiveSelectRoad();
            }
        }
        $('#offcanvas-info').removeClass('show');
        $('#offcanvas-rbt-info').removeClass('show');
    }

    /**
     * Clear select interaction
     */
    this._ClearSelect = function()
    {
        // desactive select if exists
        if (myRoadBuilderTool._select) {
            myRoadBuilderTool._select.setActive(false);
            myRoadBuilderTool._dragBox.setActive(false);
            myRoadBuilderTool._select.setMap(undefined);
        }
        $('#offcanvas-info').removeClass('show');
        $('#offcanvas-rbt-info').removeClass('show');
    }

    /**
     * Clear select interaction
     */
    this._ClearModify = function()
    {
        // desactive modify if exists
        if (myRoadBuilderTool._modify) {
            myRoadBuilderTool._modify.setActive(false);
            myRoadBuilderTool._modify.setMap(undefined);
        }
        myRoadBuilderTool._useSelectModify = false;
        // Remove only if any road is selected
        if(myRoadBuilderTool._NumberRoadSelected() > 1)
            myRoadBuilderTool._layerPointRoad.getSource().clear();
        myRoadBuilderTool._layerSubRoadLine.getSource().clear();
        myRoadBuilderTool._layerSubRoadForModify.getSource().clear();
        myRoadBuilderTool._layerPointSubRoadForModify.getSource().clear();
        myRoadBuilderTool._collectionFeatureIntercepted.clear();
        myRoadBuilderTool._hashFeatureIntercepted = {};
        myRoadBuilderTool._updateSubRoadInfo = {};
        $('#offcanvas-info').removeClass('show');
        $('#offcanvas-rbt-info').removeClass('show');

        // Hide submit button
        $('#target-gpi-submit-road-builder-tool').hide("slide");
    }

    /**
     * Clear select interaction
     */
    this._ClearModify2 = function () {
        // desactive modify if exists
        if (myRoadBuilderTool._modify) {
            myRoadBuilderTool._modify.setActive(false);
            myRoadBuilderTool._modify.setMap(undefined);
        }
        myRoadBuilderTool._useSelectModify = false;
        // Remove only if any road is selected
        //if (myRoadBuilderTool._NumberRoadSelected() > 1)
        //    myRoadBuilderTool._layerPointRoad.getSource().clear();
        //myRoadBuilderTool._layerSubRoadLine.getSource().clear();
        myRoadBuilderTool._collectionFeatureIntercepted.clear();
        myRoadBuilderTool._hashFeatureIntercepted = {};
        $('#offcanvas-info').removeClass('show');
        $('#offcanvas-rbt-info').removeClass('show');

        // Hide submit button
        //$('#target-gpi-submit-road-builder-tool').hide("slide");
    }

    /**
     * High light all police number of a sub road
     * @param {int} idSubRoad, sub road id
     */
    this._HighLightSubRoad = function(idSubRoad)
    {
        $.ajax({
            type: 'GET',
            url: '/rest/app/RoadBuilderTool/GetRoadInfoByIdSubRoad?idSubRoad=' + idSubRoad,
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na obtenção da informação da rua");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Clear layer info road
                            myRoadBuilderTool._layerInfoLineRoad.getSource().clear();
                            myRoadBuilderTool._layerPointRoad.getSource().clear();

                            // Get layer information
                            var layerInfoRoad = myRoadBuilderTool._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName(myRoadBuilderTool._layerNameSubRoadInMap)[0];
                            var arrayIdString = data.result.list_sub_road_id_key.toString();
                            var url = layerInfoRoad.geoserver + "/wfs";

                            // Get all feature from layer
                            var getFeature = $.ajax({
                                method: "GET",
                                async: true,
                                url: url,
                                data: {
                                    "service": 'wfs',
                                    "version": '2.0.0',
                                    "request": 'GetFeature',
                                    "typeNames": layerInfoRoad.workspace + ':' + layerInfoRoad.layerName,
                                    "featureID": arrayIdString,
                                    "propertyName": layerInfoRoad.geomColumnName,
                                    "outputFormat": 'application/json'
                                }
                            });

                            getFeature.done(function (data, textStatus, jqXHR) {
                                if (data.features) {
                                    if (data.features.length > 0) {
                                        for (var i = 0; i < data.features.length; i++) {
                                            var feature = (new GeoJSON()).readFeatures(data)[i];
                                            var idSubRoadFeature = feature.getProperties().IDTROCO;
                                            myRoadBuilderTool._layerInfoLineRoad.getSource().addFeature(feature);
                                            if(idSubRoadFeature != idSubRoad)
                                                myRoadBuilderTool._select.getFeatures().getArray().push(feature);
                                        }
                                    }
                                }
                            });                            
                            break;
                        case 'ERROR':
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na obtenção da informação da rua");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na obtenção da informação da rua");
                toastr.options.positionClass = 'toast-bottom-center';
            }
        });
    }

    /**
     * High light all police number of a sub road
     * @param {int} idSubRoad, sub road id
     */
    this._HighLightSubRoadPoliceNumber = function(idSubRoad)
    {
        $.ajax({
            type: 'GET',
            url: '/rest/app/RoadBuilderTool/GetAllPoliceNumberIdOfSubRoad?idSubRoad=' + idSubRoad,
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na obtenção dos número de polícia do troço");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            var arrayIdPoliceNumber = data.result.list_id_police_number;
                            var layerInfoPolice = myRoadBuilderTool._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName(myRoadBuilderTool._layerSourceNamePoliceNumber)[0];
                            if(arrayIdPoliceNumber.length > 0) {
                                myRoadBuilderTool._mapSgs.SetFeaturesHighlightByArray(layerInfoPolice.workspace, layerInfoPolice.layerName, false, arrayIdPoliceNumber, myRoadBuilderTool._stylePoliceAssociateToSubRoad, false);
                            }

                            myRoadBuilderTool._mapSgs.layerHighlightOverlay.getSource().getFeatures().forEach(function(feature) {
                                myRoadBuilderTool._layerPoliceAssociateToSubRoadSelected.getSource().addFeature(feature);
                            });
                            
                            break;
                        case 'ERROR':
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na obtenção dos número de polícia do troço");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na obtenção dos número de polícia do troço");
                toastr.options.positionClass = 'toast-bottom-center';
            }
        });
    }

    /**
     * Fill sub road for police
     */
    this._FillSubRoadForPolice = function()
    {
        myRoadBuilderTool._listSubRoadPolice = [];
        var idSubRoadSelected = myRoadBuilderTool.layerSubRoadPoliceCloser.getSource().getFeatures()[0].getProperties().IDTROCO;

        // Get all road builder tool reference
        $.ajax({
            type: 'GET',
            url: '/rest/app/RoadBuilderTool/GetSubRoadByListId?listId=' + myRoadBuilderTool._listIdSubRoadPolice,
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na obtenção dos troços do número de polícia");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            myRoadBuilderTool._listSubRoadPolice = data.result.list_sub_road;

                            // First element is the closet
                            var subRoadSelected = myRoadBuilderTool._listSubRoadPolice.find(c => c.id_troco == idSubRoadSelected);

                            // Fill freguesia sub road combo box
                            myRoadBuilderTool._utility.FillSelect('id-modal-road-build-tool-add-police-info-body-select-freguesia', data.result.list_freguesia, 'freguesia', 'dtccfr');
                            $("#id-modal-road-build-tool-add-police-info-body-select-freguesia").val(subRoadSelected.dtccfr);
                            $('#id-modal-road-build-tool-add-police-info-body-select-freguesia').selectpicker("refresh");
                            $('#id-modal-road-build-tool-add-police-info-body-ddccfr').val((subRoadSelected.dtccfr === "-1")? "": subRoadSelected.dtccfr);

                            // Fill sub road combo box
                            var listSubroadFreguesia =myRoadBuilderTool._listSubRoadPolice.filter(c => c.dtccfr === subRoadSelected.dtccfr);
                            myRoadBuilderTool._utility.FillSelect('id-modal-road-build-tool-add-police-info-body-select-id-troco', listSubroadFreguesia, 'troco', 'id_troco');
                            $("#id-modal-road-build-tool-add-police-info-body-select-id-troco").val(subRoadSelected.id_troco);
                            $('#id-modal-road-build-tool-add-police-info-body-select-id-troco').selectpicker("refresh");

                            // Fil arruamento code
                            $('#id-modal-road-build-tool-add-police-info-body-arr-cod').val(subRoadSelected.arr_cod);

                            break;
                        case 'ERROR':
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na obtenção dos troços do número de polícia");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na obtenção dos troços do número de polícia");
                toastr.options.positionClass = 'toast-bottom-center';
            }
        });
    }

    /**
    * Get all references for road builder tool
    */
    this._GetAllReferences = function ()
    {
        // Get all road builder tool reference
        $.ajax({
            type: 'GET',
            url: '/rest/app/RoadBuilderTool/GetAllReference',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro de carregamento da informação de referência");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // Fill road type
                            myRoadBuilderTool._utility.FillSelect('id-modal-road-build-tool-road-info-select-id-tipo-rua', data.result.list_road_type, 'tiporua', 'idtiporua');

                            // Fill sub road one way
                            myRoadBuilderTool._hashReference["one_way"] = data.result.list_sub_road_one_way;
                            myRoadBuilderTool._utility.FillSelect('id-modal-road-build-tool-road-sub-road-info-select-one-way', data.result.list_sub_road_one_way, 'oneway', 'oneway');

                            // Fill use type
                            myRoadBuilderTool._utility.FillSelect('id-modal-road-build-tool-add-police-info-body-select-utilizacao', data.result.list_use_type, 'tipoUtilizacao', 'tipoUtilizacao');

                            break;
                        case 'ERROR':
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro de carregamento da informação de referência");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro de carregamento da informação de referência");
                toastr.options.positionClass = 'toast-bottom-center';
            }
        });
    };

    /**
     * Save road info
     */
    this._SaveRoadInfo = function()
    {
        myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Close Modal
        $('#id-modal-road-build-tool-road').hide();

        // Prepare data
        var jsonInfo = $('#id-modal-road-build-tool-road-info-form').serializeJSON();
        var jsonInfoDetail = $('#id-modal-road-build-tool-road-info-detail-form').serializeJSON();
        var jsonRoad = Object.assign(jsonInfo, jsonInfoDetail);

        $.ajax({
            type: 'POST',
            url: '/rest/app/RoadBuilderTool/SaveRoadInfo',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(jsonRoad),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na gravação da informação de arruamento");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Clean form
                            myRoadBuilderTool._CleanFormRoadInfo();

                            // Clear selection
                            myRoadBuilderTool._ClearSelectionRoad();

                            // Refresh all route layer
                            var lengthLayer = Object.keys(myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info).length;
                            for(var i = 0; i < lengthLayer; i++) {
                                var key = Object.keys(myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info)[i];
                                var layerInfo = myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info[key].layer_info;
                                if(layerInfo.layerName === myRoadBuilderTool._layerNameSubRoadInMap && layerInfo.kind === 'WFS') {
                                    var layer = myRoadBuilderTool._mapSgs._utility.GetLayerByName(myRoadBuilderTool._mapSgs.map, layerInfo.layerNameKey);
                                    layer.getSource().clear();
                                }
                            }

                            toastr.options.positionClass = 'toast-top-center';
                            toastr["success"]("Informação de arruamento gravado com sucesso");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na gravação da informação de arruamento");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                    }
                }

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na gravação da informação de arruamento");
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /**
     * Save split road
     */
    this._SaveSplitRoad = function()
    {
        myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Close Modal
        $('#id-modal-road-build-tool-road').hide();

        // Road information data
        var jsonInfo = $('#id-modal-road-build-tool-road-info-form').serializeJSON();
        var jsonInfoDetail = $('#id-modal-road-build-tool-road-info-detail-form').serializeJSON();
        var jsonRoad = Object.assign(jsonInfo, jsonInfoDetail);
        
        // Subroad information data
        var jsonSubRoadInfo = $('#id-modal-road-build-tool-road-list-sub-road-info-form').serializeJSON().TROCO;
        var arraySubRoadInfo = [];

        for(var i = 0; i < Object.keys(jsonSubRoadInfo).length; i++)
        {
            var subRoadInfo = jsonSubRoadInfo[Object.keys(jsonSubRoadInfo)[i]];
            arraySubRoadInfo.push({
                id_troco: subRoadInfo.IDTROCO
            });
        }

        // All the information
        var jsonSplitRoad = 
        {
            road: jsonRoad,
            listSubRoad: arraySubRoadInfo,
            listRoadFreguesia: null
        };

        $.ajax({
            type: 'POST',
            url: '/rest/app/RoadBuilderTool/SaveSplitRoad',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(jsonSplitRoad),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na gravação da informação de arruamento");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Clean form
                            myRoadBuilderTool._CleanFormRoadInfo();

                            // Clear selection
                            myRoadBuilderTool._ClearSelectionRoad();

                            // Clear split polygon and selection
                            myRoadBuilderTool._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-road-tool-split-road');
                            myRoadBuilderTool._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-road-tool-split-road');
                            myRoadBuilderTool._ActiveSplitRoadTool($('#target-gpi-road-tool-split-road').parent()[0], false);
                            //myRoadBuilderTool._CleanSplitRoad();

                            // Refresh all route layer
                            var lengthLayer = Object.keys(myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info).length;
                            for(var i = 0; i < lengthLayer; i++) {
                                var key = Object.keys(myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info)[i];
                                var layerInfo = myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info[key].layer_info;
                                if(layerInfo.layerName === myRoadBuilderTool._layerNameSubRoadInMap && layerInfo.kind === 'WFS') {
                                    var layer = myRoadBuilderTool._mapSgs._utility.GetLayerByName(myRoadBuilderTool._mapSgs.map, layerInfo.layerNameKey);
                                    layer.getSource().clear();
                                }
                            }

                            toastr.options.positionClass = 'toast-top-center';
                            toastr["success"]("Informação de arruamento gravado com sucesso");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na gravação da informação de arruamento");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                    }
                }

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na gravação da informação de arruamento");
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /**
     * Save new road
     */
    this._SaveNewRoad = function()
    {
        myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Close Modal
        $('#id-modal-road-build-tool-road').hide();

        // Prepare data
        var jsonInfo = $('#id-modal-road-build-tool-road-info-form').serializeJSON();
        var jsonInfoDetail = $('#id-modal-road-build-tool-road-info-detail-form').serializeJSON();
        var jsonRoad = Object.assign(jsonInfo, jsonInfoDetail);
        jsonRoad.arr_seq = -1;
        jsonRoad.geom_wkt = new WKT().writeGeometry(myRoadBuilderTool._layerDrawLineRoad.getSource().getFeatures()[0].getGeometry());
        jsonRoad.geom_srid = myRoadBuilderTool._mapSgs._settings.projection.getCode().replace('EPSG:', '');
        jsonRoad.arr_reg_data = myRoadBuilderTool._utility.getNewDateForServer();

        var jsonInfoSub = $('#id-modal-road-build-tool-road-list-sub-road-info-form').serializeJSON();
        var countKey = Object.keys(jsonInfoSub.TROCO).length;
        var listNewSubRoadRoad = [];
        for(var i = 0; i < countKey; i++) {
            var key =  Object.keys(jsonInfoSub.TROCO)[i];
            var idTmpSubRoad = jsonInfoSub.TROCO[key].IDTROCO;

            // Get geom subroad information
            var objSubRoadGeom = myRoadBuilderTool._createRoadInfo.newSubRoad.hashSubRoad[idTmpSubRoad];
            jsonInfoSub.TROCO[key].objectid = -1;
            jsonInfoSub.TROCO[key].arr_seq = -1;
            jsonInfoSub.TROCO[key].id_troco = jsonInfoSub.TROCO[key].IDTROCO;
            delete jsonInfoSub.TROCO[key].IDTROCO;
            jsonInfoSub.TROCO[key].extensao = jsonInfoSub.TROCO[key].EXTENSAO;
            delete jsonInfoSub.TROCO[key].EXTENSAO;
            jsonInfoSub.TROCO[key].geom_wkt = objSubRoadGeom.newSubRoadGeom.geom_wkt;
            jsonInfoSub.TROCO[key].geom_srid = objSubRoadGeom.newSubRoadGeom.geom_srid;
            jsonInfoSub.TROCO[key].troco = jsonRoad.arr_desig;
            listNewSubRoadRoad.push({
                newSubRoadGeom: jsonInfoSub.TROCO[key],
                listSubRoadFreguesia: objSubRoadGeom.listSubRoadFreguesia
            });
        }

        // Join data
        var dataInfo = {
            road: jsonRoad,
            listNewSubRoadRoad: listNewSubRoadRoad,
            newSubRoadOtherRoad: myRoadBuilderTool._createRoadInfo.newSubRoadOtherRoad
        }

        $.ajax({
            type: 'POST',
            url: '/rest/app/RoadBuilderTool/CreateRoad',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(dataInfo),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na criação do arruamento");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Clean all feature
                            myRoadBuilderTool._layerDrawLineRoad.getSource().clear();
                            myRoadBuilderTool._layerPointRoad.getSource().clear();
                            myRoadBuilderTool._layerSubRoadLine.getSource().clear();
                            myRoadBuilderTool._collectionFeatureIntercepted.clear();
                            myRoadBuilderTool._hashFeatureIntercepted = {};

                            // Clean form
                            myRoadBuilderTool._CleanFormRoadInfo();

                            // Refresh all route layer
                            var lengthLayer = Object.keys(myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info).length;
                            for(var i = 0; i < lengthLayer; i++) {
                                var key = Object.keys(myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info)[i];
                                var layerInfo = myRoadBuilderTool._mapSgs._settings.treeMap.dict_layer_info[key].layer_info;
                                if(layerInfo.layerName === myRoadBuilderTool._layerNameSubRoadInMap && layerInfo.kind === 'WFS') {
                                    var layer = myRoadBuilderTool._mapSgs._utility.GetLayerByName(myRoadBuilderTool._mapSgs.map, layerInfo.layerNameKey);
                                    layer.getSource().clear();
                                }
                            }

                            toastr.options.positionClass = 'toast-top-center';
                            toastr["success"]("Arruamento criado com sucesso");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na criação do arruamento");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                    }
                }

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na criação do arruamento");
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /**
     * Save new road
     */
    this._SaveNewPolice = function()
    {
        myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Close Modal
        $('#id-modal-road-build-tool-add-police').hide();

        // Prepare data
        var jsonPoliceInfo = $('#id-modal-road-build-tool-add-police-info-form').serializeJSON();

        jsonPoliceInfo.idedificado = parseFloat(jsonPoliceInfo.idedificado);

        jsonPoliceInfo.geom_wkt = new WKT().writeGeometry(myRoadBuilderTool._layerPolicePoint.getSource().getFeatures()[0].getGeometry());
        jsonPoliceInfo.geom_srid = myRoadBuilderTool._mapSgs._settings.projection.getCode().replace('EPSG:', '');
        jsonPoliceInfo.arr_reg_data = myRoadBuilderTool._utility.getNewDateForServer();

        $.ajax({
            type: 'POST',
            url: '/rest/app/RoadBuilderTool/CreatePoliceNumber',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(jsonPoliceInfo),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na criação do número de polícia");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Clean all police number
                            myRoadBuilderTool._CleanAllPolice();

                            // Refresh police number layer
                            var layerInfo = myRoadBuilderTool._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName(myRoadBuilderTool._layerSourceNamePoliceNumber)[0];
                            var layer = myRoadBuilderTool._mapSgs._utility.GetLayerByName(myRoadBuilderTool._mapSgs.map, layerInfo.layerNameKey);
                            layer.getSource().clear();

                            toastr.options.positionClass = 'toast-top-center';
                            toastr["success"]("Número de polícia criada com sucesso");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na criação do número de polícia");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                    }
                }

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na criação do número de polícia");
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /**
     * Select All feature subroad
     * @param {object} layerInfo, layer information
     * @param {string} cqlfilter, filter
     */
    this._GetSubRoadInfoByIdRoad = function (layerInfo, cqlFilter)
    {
        var ListData = [];
        var geoserver = layerInfo.geoserver;

        let urlString = geoserver + "/wfs";
        let layerString = layerInfo.workspace + ':' + layerInfo.layerName;

        let featureSubRoadCall = $.ajax({
            method: "GET",
            async: true,
            url: urlString,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature ',
                "cql_filter": cqlFilter,
                "typeNames": layerString,
                "propertyName": layerInfo.allColumn,
                "outputFormat": 'application/json'
            }
        });

        // Don't Clear subroad layer for multi road selection
        if(!myRoadBuilderTool._shiftPressed)
        {
            myRoadBuilderTool._layerSubRoadFromRoad.getSource().clear();
            myRoadBuilderTool._layerPointRoad.getSource().clear();
        }
        featureSubRoadCall.done(function (data)
        {
            for (var i = 0; i < data.features.length; i++)
            {
                // Add feature
                var featureSubRoad = (new GeoJSON()).readFeatures(data)[i];                
                myRoadBuilderTool._layerSubRoadFromRoad.getSource().addFeature(featureSubRoad);

                // First point
                var featureFirstPoint = new Feature({
                    geometry: new Point(featureSubRoad.getGeometry().getFirstCoordinate()),
                    name: "first-point-info-line-subroad",
                    id: featureSubRoad.getId() + ".first" 
                });
                myRoadBuilderTool._layerPointRoad.getSource().addFeature(featureFirstPoint);

                // Last point
                var featureLastPoint = new Feature({
                    geometry: new Point(featureSubRoad.getGeometry().getLastCoordinate()),
                    name: "last-point-info-line-subroad",
                    id: featureSubRoad.getId() + ".last"
                });
                myRoadBuilderTool._layerPointRoad.getSource().addFeature(featureLastPoint);
            }
        });
    }

    /**
     * Select All feature subroad
     * @param {object} layerInfo, layer information
     * @param {string} cqlfilter, filter
     */
    this._GetRoadInfoByIdRoad = function (layerInfo, cqlFilter)
    {
        var ListData = [];
        var geoserver = layerInfo.geoserver;

        let urlString = geoserver + "/wfs";
        let layerString = layerInfo.workspace + ':' + layerInfo.layerName;

        let featureSubRoadCall = $.ajax({
            method: "GET",
            async: true,
            url: urlString,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature ',
                "cql_filter": cqlFilter,
                "typeNames": layerString,
                "propertyName": "*",
                "outputFormat": 'application/json'
            }
        });

        // Clear subroad layer
        featureSubRoadCall.done(function (data)
        {
            if(data.features.length > 0)
                myRoadBuilderTool._featureRoadSelected = (new GeoJSON()).readFeatures(data)[0];
        });
    }

    /**
     * Get feature property information
     * @param {object} layerInfo, layer information
     * @param {string} cqlfilter, filter
     */
    this._GetRoadInfoById = function (layerInfo, cqlFilter)
    {
        var ListData = [];
        var geoserver = layerInfo.geoserver;

        let urlString = geoserver + "/wfs";
        let layerString = layerInfo.workspace + ':' + layerInfo.layerName;

        let featureRoadCall = $.ajax({
            method: "GET",
            async: true,
            url: urlString,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature ',
                "cql_filter": cqlFilter,
                "typeNames": layerString,
                "propertyName": layerInfo.allColumn,
                "outputFormat": 'application/json'
            }
        });

        featureRoadCall.done(function (data)
        {
            for (var i = 0; i < data.features.length; i++)
            {
                var featureProperty = data.features[i].properties;
                var key = featureProperty.ARR_SEQ + "-" + i 

                // Clone
                var cloneRoadIntersect = $('#id-modal-road-build-tool-road-info-sub-body-road-intersect').clone(true);
                var idClone = "id-modal-road-build-tool-road-info-sub-body-road-intersect-" + key;
                cloneRoadIntersect.attr("id", idClone);
                $('#id-modal-road-build-tool-road-info-sub-body-road-intersect-zone').append(cloneRoadIntersect);
                $('#' + idClone).show();
                $('#' + idClone).find("input,select,a").each(function() {
                    $(this).attr('id' , $(this).attr('id') + "-" + key);
                    this.name = this.name.replace('[0]', '[' + i + ']');
                });

                // Fill name road
                $('#' + idClone + ' input.road-name').val(featureProperty.ARR_DESIG);

                // Fill length road
                if(featureProperty.LENGTH)
                {
                    var lengthRoad = Math.round(featureProperty.LENGTH * 100)/100;
                    $('#' + idClone + ' input.road-length').val(lengthRoad);
                }
            }
        });

        return ListData;
    }

    /**
     * Check if point is in building
     * @param {string} layerBuildingName, layer building name
     ª @param {array} coordinate, point coordinate
     */
    this._IsPointInBuilding = function(layerBuildingName, coordinate)
    {
        var idBuilding = -1;

        // Get layer
        var layerBuilding = myRoadBuilderTool._utility.GetLayerByName(myRoadBuilderTool._mapSgs.map, layerBuildingName);

        // Build url
        var url = layerBuilding.getSource().getGetFeatureInfoUrl(
            coordinate,
            myRoadBuilderTool._mapSgs.map.getView().getResolution(),
            myRoadBuilderTool._mapSgs.map.getView().getProjection().getCode(),
            { 'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 10 }
        );

        // Call Geoserver - Syncrone
        var parser = new GeoJSON();
        var request = $.ajax(
        {
            method: "GET",
            async: false,
            url: url
        });

        // Geoserver Response
        request.done(function (data, textStatus, jqXHR) {
            if (data.features.length > 0) {
                var featureBuilding = parser.readFeatures(data['features'][0])[0];
                //idBuilding = featureBuilding.getProperties().IDEDIFICADO;
                idBuilding = featureBuilding.id_.split('.')[1];
            }
        });

        return idBuilding;
    }

    /**
     * Build freguesia table
     * @param {string} idTable, datatable identifier
     * @param {string} keyNodeTable, jquery key node table
     */
    this._BuildFreguesiaTable = function(idTable, keyNodeTable)
    {
        var columnDefArray = [];

        columnDefArray.push({
            'data': 'id_freguesia',
            'type': 'readonly',
            'visible': false
        });
        columnDefArray.push({
            'data': 'freguesia',
            'title': 'Nome',
            'name': 'Nome',
            'label': 'Nome',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-freguesia',
            'width': '50%'
        });
        columnDefArray.push({
            'data': 'dtccfr',
            'title': 'DTCCFR',
            'name': 'DTCCFR',
            'label': 'DTCCFR',
            'type': 'readonly',
            'orderable': false,
            'className': 'dt-body-center dt-freguesia',
            'width': '50%'
        });
        myRoadBuilderTool._hashTableFreguesia[idTable] = $(keyNodeTable).DataTable({
            "dom": '<rtip',
            "destroy": true,
            "language": {
                "emptyTable": 'Nenhuma freguesia encontrada'
            },
            "fixedHeader": true,
            "info": false,
            "scrollY": $(keyNodeTable + '-zone').height() - 27,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": false,
            "ordering": false,
            "columns": columnDefArray,
            "select": false,
            "name": idTable,
            "rowId": 'id_freguesia'
        });
    }

    /**
     * Check if point is vertex of a line
     * @param {any} featureLineGeojson
     * @param {any} pointCoord
     */
    this._IsPointVertex = function (featureLineGeojson, pointCoord)
    {
        var result = false;
        var stringPoint = JSON.stringify(pointCoord.geometry.coordinates);

        for (var i = 0; i < featureLineGeojson.geometry.coordinates.length; i++)
        {
            var stringVertex = JSON.stringify(featureLineGeojson.geometry.coordinates[i])
            if (stringPoint === stringVertex)
            {
                result = true;
                break;
            }
        }

        return result;
    }

    /**
     * Split line by point
     * @param {any} featureLineGeojson
     * @param {any} pointCoord
     */
    this._LineSplitByPoint = function (featureLineGeojson, pointCoord)
    {
        var listSegment = null;

        if (myRoadBuilderTool._IsPointVertex(featureLineGeojson, pointCoord)) {
            var pointStart = turf.point(featureLineGeojson.geometry.coordinates[0]);
            var pointEnd = turf.point(featureLineGeojson.geometry.coordinates[featureLineGeojson.geometry.coordinates.length - 1]);

            listSegment = turf.featureCollection([
                turf.lineSlice(pointStart, pointCoord, featureLineGeojson),
                turf.lineSlice(pointCoord, pointEnd, featureLineGeojson)
            ])
        }
        else {
            listSegment = turf.lineSplit(featureLineGeojson, pointCoord);
        }

        return listSegment;
    }

    /**
     * Split line by layer of Point and gif the result in array of feature geojson segment
     * @param {GeoJson} featureLineGeojson, feature line in geojson
     * @param {array} arrayFeaturePoint, array of feature  point
     */
    this._SplitLine = function(featureLineGeojson, arrayFeaturePoint)
    {
        var lineSegment = null;
        var listSegment = null;
        var arraySegment = [];
        for(var i = 0; i < arrayFeaturePoint.length; i++)
        {
            var featureIntersectPoint = arrayFeaturePoint[i];
            var pointCoord = turf.point(featureIntersectPoint.getGeometry().getCoordinates());

            var stringFirstPointLine = JSON.stringify(featureLineGeojson.geometry.coordinates[0]);
            var stringLastPointLine = JSON.stringify(featureLineGeojson.geometry.coordinates[featureLineGeojson.geometry.coordinates.length - 1]);
            var stringPointCoord = JSON.stringify(pointCoord.geometry.coordinates);

            if (stringFirstPointLine === stringPointCoord || stringLastPointLine === stringPointCoord) {
                arraySegment.push(featureLineGeojson);
            }
            else {
                if (i === 0) {
                    listSegment = myRoadBuilderTool._LineSplitByPoint(featureLineGeojson, pointCoord);
                    arraySegment.push(listSegment.features[0]);
                    if (listSegment.features[1])
                        arraySegment.push(listSegment.features[1]);
                }
                else {
                    var index = arraySegment.findIndex(c => myRoadBuilderTool._LineSplitByPoint(c, pointCoord).features.length > 1);
                    if (index >= 0) {
                        var lineSeg = arraySegment[index];
                        arraySegment.splice(index, 1);
                        listSegment = myRoadBuilderTool._LineSplitByPoint(lineSeg, pointCoord);
                        arraySegment.push(listSegment.features[0]);
                        if (listSegment.features[1])
                            arraySegment.push(listSegment.features[1]);
                    }
                }
            }
        }
    
        return arraySegment;
    }

    /**
     * Action when feature draw road is added or changed
     * @param {Feature} feature, feature input
     */
    this._ActionFeatureDrawLineRoad = function(feature)
    {
        var geom = feature.getGeometry();
        var length_m;
        var geojsonFormat = new GeoJSON();

        // Clone feature and transform to 4326
        var featureClone = feature.clone();
        featureClone.getGeometry().transform(myRoadBuilderTool._mapSgs._settings.projection.getCode(), myRoadBuilderTool._mapSgs._settings.projectionWgs84.getCode());
        var featureGeojsonWgs84 = geojsonFormat.writeFeatureObject(featureClone);
        
        var featureGeojson = geojsonFormat.writeFeatureObject(feature);
        if (geom instanceof LineString || geom instanceof MultiLineString) {
            length_m = myRoadBuilderTool._utility.LengthLine(geom);

            $('#offcanvas-info header')[0].innerHTML = 'Comprimento';
            $('#sgs-measure-input-m').html(length_m);
            $('#sgs-measure-input-ha').html("");

            $('#offcanvas-info').addClass('show');
            if (myRoadBuilderTool._utility.mobilecheck())
                $('#offcanvas-info').addClass('showreponsive')
            $('#offcanvas-info').addClass('height-length');
        }

        // Interception with feature road and freguesia
        myRoadBuilderTool._hasInterception = false;
        var hashSamePoint = {};
        myRoadBuilderTool.collectionFeatureSet.getArray().forEach(function(featureIn, index)
        {
            if (1 == 1) { //featureIn.getId().indexOf("V_ESTRADAS") == 0 && featureIn.getProperties().IDTROCO == 6813) {
                // Clone feature and transform to 4326
                var featureInClone = featureIn.clone();
                featureInClone.getGeometry().transform(myRoadBuilderTool._mapSgs._settings.projection.getCode(), myRoadBuilderTool._mapSgs._settings.projectionWgs84.getCode());

                var featureInGeojsonWgs84 = geojsonFormat.writeFeatureObject(featureInClone);
                var featureIntersectGeojsonWgs84 = turf.lineIntersect(featureGeojsonWgs84, featureInGeojsonWgs84);
                if (featureIntersectGeojsonWgs84 !== null && featureIntersectGeojsonWgs84.features.length > 0) {
                    myRoadBuilderTool._hasInterception = true;
                    myRoadBuilderTool._collectionFeatureIntercepted.push(featureIn);
                    var lengthPointFeature = featureIntersectGeojsonWgs84.features.length;
                    for (var i = 0; i < lengthPointFeature; i++) {
                        var featureToReadGeoJsonWgs84 = featureIntersectGeojsonWgs84.features[i];

                        var featureToReadTmp = new Feature({
                            geometry: (new Point(featureToReadGeoJsonWgs84.geometry.coordinates)).transform(myRoadBuilderTool._mapSgs._settings.projectionWgs84.getCode(), myRoadBuilderTool._mapSgs._settings.projection.getCode())
                        });
                        var featureToRead = geojsonFormat.writeFeatureObject(featureToReadTmp);

                        var key = JSON.stringify(featureToRead.geometry.coordinates);
                        if (hashSamePoint[key])
                            continue;
                        else
                            hashSamePoint[key] = 1;
                        var featureIntersectPoint = geojsonFormat.readFeature(featureToRead);
                        myRoadBuilderTool._layerPointRoad.getSource().addFeature(featureIntersectPoint);

                        if (featureIn.getId().split('.')[0] === myRoadBuilderTool._layerNameSubRoadInMap) {
                            // Only if point coordinate diferent of last or first coordinate of the line
                            if (
                                !(
                                    //(JSON.stringify(featureIn.getGeometry().getFirstCoordinate()) === JSON.stringify(featureIntersectPoint.getGeometry().getCoordinates())) ||
                                    //(JSON.stringify(featureIn.getGeometry().getLastCoordinate()) === JSON.stringify(featureIntersectPoint.getGeometry().getCoordinates()))
                                    (JSON.stringify(featureInGeojsonWgs84.geometry.coordinates[0]) === JSON.stringify(featureToReadGeoJsonWgs84.geometry.coordinates)) ||
                                    (JSON.stringify(featureInGeojsonWgs84.geometry.coordinates[featureInGeojsonWgs84.geometry.coordinates.length - 1]) === JSON.stringify(featureToReadGeoJsonWgs84.geometry.coordinates))
                                )
                            ) {
                                var idSubRoadFeatureIn = featureIn.getProperties().IDTROCO;
                                if (!myRoadBuilderTool._hashFeatureIntercepted[idSubRoadFeatureIn]) {
                                    myRoadBuilderTool._hashFeatureIntercepted[idSubRoadFeatureIn] =
                                    {
                                        featureIntercepted: featureIn,
                                        arrayFeatureIntersectPoint: [featureIntersectPoint]
                                    };
                                }
                                else {
                                    myRoadBuilderTool._hashFeatureIntercepted[idSubRoadFeatureIn].arrayFeatureIntersectPoint.push(featureIntersectPoint);
                                }
                            }
                        }
                    }
                }
            }
        });
        if (myRoadBuilderTool._hasInterception)
        {
            // Build subroad from point
            var arraySubRoadGeojson = myRoadBuilderTool._SplitLine(featureGeojson, myRoadBuilderTool._layerPointRoad.getSource().getFeatures());
                
            // Add subroad to layer
            var hashFreguesiaCheck = {};
            myRoadBuilderTool._createRoadInfo.newSubRoad = {
                geomSrid: myRoadBuilderTool._mapSgs._settings.projection.getCode().replace('EPSG:', ''),
                userName: myRoadBuilderTool._mapSgs._settings.userInfo.userName,
                hashSubRoad: {}
            };
            for(var t = 0; t < arraySubRoadGeojson.length; t++)
            {
                var featureSubRoad = geojsonFormat.readFeature(arraySubRoadGeojson[t]);
                var idTmpSubRoad = t;
                featureSubRoad.setProperties({ other_road: false, id_tmp_sub_road: idTmpSubRoad });
                if (featureSubRoad.getId() == undefined)
                    featureSubRoad.setId(idTmpSubRoad);
                var featureSubRoadGeojson = geojsonFormat.writeFeatureObject(featureSubRoad);

                // High light interception feature
                //myRoadBuilderTool._AddFeatureToHighlightLayer(myRoadBuilderTool._layerSubRoadLine, myRoadBuilderTool._layerPointRoad, featureSubRoad);

                // Find freguesia by subroad generate
                var arraySubRoadFreguesia = myRoadBuilderTool._GetFreguesiaOfSubRoad(featureSubRoadGeojson, featureSubRoad.getProperties().id_tmp_sub_road);

                myRoadBuilderTool._createRoadInfo.newSubRoad.hashSubRoad[idTmpSubRoad] = {
                    newSubRoadGeom: {
                        geom_wkt: new WKT().writeGeometry(featureSubRoad.getGeometry()),
                        geom_srid: myRoadBuilderTool._mapSgs._settings.projection.getCode().replace('EPSG:', '')
                    },
                    listSubRoadFreguesia: arraySubRoadFreguesia
                };
            }

            // Split intercepted subroad
            for(var y = 0; y < Object.keys(myRoadBuilderTool._hashFeatureIntercepted).length; y++)
            {
                var key = Object.keys(myRoadBuilderTool._hashFeatureIntercepted)[y];
                var featureInterceptedGeojson = geojsonFormat.writeFeatureObject(myRoadBuilderTool._hashFeatureIntercepted[key].featureIntercepted);
                var arrayFeatureIntersectPoint = myRoadBuilderTool._hashFeatureIntercepted[key].arrayFeatureIntersectPoint;

                var arraySubRoadGeojson = myRoadBuilderTool._SplitLine(featureInterceptedGeojson, arrayFeatureIntersectPoint);

                // Add subroad created from intercept subroad to layer
                hashFreguesiaCheck = {};
                myRoadBuilderTool._createRoadInfo.newSubRoadOtherRoad = {
                    idRoad: -1,
                    geomSrid: "",
                    userName: "",
                    roadGeometryChange: false,
                    hashSubRoad: {}
                };
                for(var d = 0; d < arraySubRoadGeojson.length; d++)
                {
                    var featureSubRoad = geojsonFormat.readFeature(arraySubRoadGeojson[d]);
                    featureSubRoad.setProperties({ IDTROCO: featureInterceptedGeojson.properties.IDTROCO, other_road: true });
                    var featureSubRoadGeojson = geojsonFormat.writeFeatureObject(featureSubRoad);

                    // High light interception feature
                    //myRoadBuilderTool._AddFeatureToHighlightLayer(myRoadBuilderTool._layerSubRoadLine, myRoadBuilderTool._layerPointRoad, featureSubRoad);

                    // Find freguesia by subroad generate
                    var arraySubRoadFreguesia = myRoadBuilderTool._GetFreguesiaOfSubRoad(featureSubRoadGeojson, feature.getProperties().IDTROCO);

                    var idSubRoad = featureInterceptedGeojson.properties.IDTROCO;
                    var objSubRoad = {
                        newSubRoadGeom: {
                            id_current_sub_road: idSubRoad,
                            id_sub_road: d,
                            geom_wkt: new WKT().writeGeometry(featureSubRoad.getGeometry()),
                            geom_srid: myRoadBuilderTool._mapSgs._settings.projection.getCode().replace('EPSG:', '')
                        },
                        listSubRoadFreguesia: arraySubRoadFreguesia
                    };

                    if(!myRoadBuilderTool._createRoadInfo.newSubRoadOtherRoad.hashSubRoad[idSubRoad])
                    {
                        myRoadBuilderTool._createRoadInfo.newSubRoadOtherRoad.hashSubRoad[idSubRoad] = [objSubRoad];
                    }
                    else {
                        myRoadBuilderTool._createRoadInfo.newSubRoadOtherRoad.hashSubRoad[idSubRoad].push(objSubRoad);
                    }
                }
            }
        }

        // Highlight sub road on create road
        myRoadBuilderTool._HighLightSubRoadToSave(myRoadBuilderTool._createRoadInfo, true);
    }

    /**
     * Action when feature split road
     * @param {Feature} featurePointSplit, feature point split input
     */
    this._ActionFeatureSplitRoad = function(featurePointSplit)
    {
        // Get subroad to split
        var featurePointSplitGeojson = turf.point(featurePointSplit.getGeometry().getCoordinates());
        var lengthSubRoadRoad = myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures().length;
        var featureSubRoadToSplit = null;
        var foundSubRoad = false;
        var splitState = {
            left: false,
            middle: false,
            right: false
        };
        for(var i = 0; i < lengthSubRoadRoad; i++)
        {
            featureSubRoadToSplit = myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures()[i];
            var featureSubRoadGeojson = myRoadBuilderTool._geojsonFormat.writeFeatureObject(featureSubRoadToSplit);

            if(turf.booleanPointOnLine(featurePointSplitGeojson, featureSubRoadGeojson) || turf.lineSplit(featureSubRoadGeojson, featurePointSplitGeojson).features.length > 1)
            {
                // Split road on the edge of the subroad - no split
                if(turf.lineSplit(featureSubRoadGeojson, featurePointSplitGeojson).features.length == 1)
                {
                    // Compare first point
                    if(turf.booleanEqual(featurePointSplitGeojson, turf.point(featureSubRoadGeojson.geometry.coordinates[0])))
                    {
                        splitState.right = true;
                    }
                    // Compare last point
                    if(turf.booleanEqual(featurePointSplitGeojson, turf.point(featureSubRoadGeojson.geometry.coordinates[featureSubRoadGeojson.geometry.coordinates.length-1])))
                    {
                        splitState.left = true;
                    }
                }
                else {
                    splitState.middle = true;
                }

                foundSubRoad = true;
                break;
            }
        }
        if(!foundSubRoad)
        {
            toastr.options.positionClass = 'toast-top-center';
            toastr["warning"]("Atenção, o ponto não intercepta o arruamento");
            toastr.options.positionClass = 'toast-bottom-center';
            myRoadBuilderTool._layerPointSplit.getSource().clear();
            return;
        }

        if(splitState.middle)
        {
            // Split subroad information
            myRoadBuilderTool._ActionFeatureSplitSubRoad(featurePointSplit, featureSubRoadToSplit, false);

            myRoadBuilderTool._splitRoadInfo = {
                idRoad: featureSubRoadToSplit.getProperties().ARR_SEQ,
                idSubRoad: featureSubRoadToSplit.getProperties().IDTROCO,
                splitState: 'middle',
                newSubRoadRoad: myRoadBuilderTool._splitSubRoadInfo.newSubRoadRoad
            }
        }
        else {
            myRoadBuilderTool._splitRoadInfo = {
                idRoad: featureSubRoadToSplit.getProperties().ARR_SEQ,
                idSubRoad: featureSubRoadToSplit.getProperties().IDTROCO,
                splitState: (splitState.right)? 'right': 'left',
                newSubRoadRoad: myRoadBuilderTool._splitSubRoadInfo.newSubRoadRoad
            }
        }

        // Slipt road
        var arrayFeatureRoadGeojson = [];
        switch(myRoadBuilderTool._featureRoadSelected.getGeometry().getType())
        {
            case "MultiLineString":
                for(var p = 0; p < myRoadBuilderTool._featureRoadSelected.getGeometry().getCoordinates().length; p++)
                {
                    arrayFeatureRoadGeojson.push(turf.lineString(myRoadBuilderTool._featureRoadSelected.getGeometry().getCoordinates()[p], {ARR_SEQ: myRoadBuilderTool._featureRoadSelected.getProperties().ARR_SEQ }));
                }
                break;
            default:
                arrayFeatureRoadGeojson.push(myRoadBuilderTool._geojsonFormat.writeFeatureObject(myRoadBuilderTool._featureRoadSelected));
        }

        // Separate subroad
        var hashSplitRoad = {}
        for(var x = 0; x < arrayFeatureRoadGeojson.length; x++)
        {
            var arrayRoadGeojson = myRoadBuilderTool._SplitLine(arrayFeatureRoadGeojson[x], [featurePointSplit]);

            for(var j = 0; j < arrayRoadGeojson.length; j++)
            {
                var featureRoadGeojson = arrayRoadGeojson[j];

                for(var k = 0; k < lengthSubRoadRoad; k++)
                {
                    var featureSubRoadFromRoad = myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures()[k];
                    var featureSubRoadFromRoadGeojson = myRoadBuilderTool._geojsonFormat.writeFeatureObject(featureSubRoadFromRoad);

                    var inLine = false;
                    featureSubRoadFromRoad.getGeometry().getCoordinates().forEach(function(coordinate) {
                        if(turf.lineSplit(featureRoadGeojson, turf.point(coordinate)).features.length > 1)
                        {
                            inLine = true;
                        }
                    });

                    //var featureIntersectGeojson = turf.lineIntersect(featureRoadGeojson, featureSubRoadFromRoadGeojson);
                    //if(featureIntersectGeojson !== null && featureIntersectGeojson.features.length > 0) {
                    if(inLine) {
                        if(hashSplitRoad[j])
                            hashSplitRoad[j].push(featureSubRoadFromRoad.getProperties().IDTROCO);
                        else
                            hashSplitRoad[j] = [featureSubRoadFromRoad.getProperties().IDTROCO];
                    }
                }
            }
        }

        var re = 1;

    }

    /**
     * Action when feature split subroad
     * @param {Feature} featurePointSplit, feature point split input
     * @param {Feature} featureSubRoadToSplit, feature subroadto slit
     */
    this._ActionFeatureSplitSubRoad = function(featurePointSplit, featureSubRoadToSplit, addToLayer)
    {
        // Get subroad to split in geojson
        var featureSubRoadToSplitGeojson = myRoadBuilderTool._geojsonFormat.writeFeatureObject(featureSubRoadToSplit);

        // Get segment split
        var arraySubRoadGeojson = myRoadBuilderTool._SplitLine(featureSubRoadToSplitGeojson, [featurePointSplit]);

        // Add subroad created from intercept subroad to layer
        var hashFreguesiaCheck = {};
        myRoadBuilderTool._splitSubRoadInfo = {};
        myRoadBuilderTool._splitSubRoadInfo.newSubRoadRoad = {
            idRoad: featureSubRoadToSplit.getProperties().ARR_SEQ,
            geomSrid: "",
            userName: "",
            roadGeometryChange: false,
            hashSubRoad: {}
        };
        for(var d = 0; d < arraySubRoadGeojson.length; d++)
        {
            var newStyle = myRoadBuilderTool._styleLineSubRoad[0].clone();
            newStyle.getStroke().setColor('rgba(' + Math.round((Math.random()*(255 - 0) + 0)) + ', ' + Math.round((Math.random()*(255 - 0) + 0)) + ', ' + Math.round((Math.random()*(255 - 0) + 0)) + ', 0.5)');
            var featureSubRoad = myRoadBuilderTool._geojsonFormat.readFeature(arraySubRoadGeojson[d]);
            featureSubRoad.setStyle(newStyle);
            featureSubRoad.setProperties({ IDTROCO: featureSubRoadToSplitGeojson.properties.IDTROCO, other_road: true});
            var featureSubRoadGeojson = myRoadBuilderTool._geojsonFormat.writeFeatureObject(featureSubRoad);
            if(addToLayer)
            {
                myRoadBuilderTool._layerSubRoadLine.getSource().addFeature(featureSubRoad);

                // First point
                var featureFirstPoint = new Feature({
                    geometry: new Point(featureSubRoad.getGeometry().getFirstCoordinate()),
                    name: "first-point-info-line-subroad",
                    id: featureSubRoad.getId() + ".first" 
                });
                myRoadBuilderTool._layerPointRoad.getSource().addFeature(featureFirstPoint);

                // Last point
                var featureLastPoint = new Feature({
                    geometry: new Point(featureSubRoad.getGeometry().getLastCoordinate()),
                    name: "last-point-info-line-subroad",
                    id: featureSubRoad.getId() + ".last"
                });
                myRoadBuilderTool._layerPointRoad.getSource().addFeature(featureLastPoint);
            }

            // Find freguesia by subroad generate
            var arraySubRoadFreguesia = [];
            myRoadBuilderTool.collectionFeatureSet.getArray().forEach(function(featureIn, index)
            {
                var featureInGeojson = myRoadBuilderTool._geojsonFormat.writeFeatureObject(featureIn);

                if(featureIn.getId().indexOf("FREGUESIA") >= 0)
                {
                    if(turf.booleanCrosses(featureSubRoadGeojson, featureInGeojson) || turf.booleanContains(featureInGeojson, featureSubRoadGeojson))
                    {
                        var idSubRoadFeatureIn = featureSubRoadToSplit.getProperties().IDTROCO;
                        var idFreguesia = featureIn.getProperties().IDFREGUESIA;
                        var key = idSubRoadFeatureIn + "_" + idFreguesia;
                        if(!hashFreguesiaCheck[key])
                        {
                            arraySubRoadFreguesia.push({
                                id_freguesia: idFreguesia,
                                id_troco: idSubRoadFeatureIn,
                                freguesia: featureIn.getProperties().FREGUESIA,
                                dtccfr: featureIn.getProperties().DTCCFR01
                            });
                        }
                    }
                }
            });

            var idSubRoad = featureSubRoad.getProperties().IDTROCO;
            var objSubRoad = {
                newSubRoadGeom: {
                    id_current_sub_road: idSubRoad,
                    id_sub_road: d,
                    geom_wkt: new WKT().writeGeometry(featureSubRoad.getGeometry()),
                    geom_srid: myRoadBuilderTool._mapSgs._settings.projection.getCode().replace('EPSG:', '')
                },
                listSubRoadFreguesia: arraySubRoadFreguesia
            };

            if(!myRoadBuilderTool._splitSubRoadInfo.newSubRoadRoad.hashSubRoad[idSubRoad])
            {
                myRoadBuilderTool._splitSubRoadInfo.newSubRoadRoad.hashSubRoad[idSubRoad] = [objSubRoad];
            }
            else {
                myRoadBuilderTool._splitSubRoadInfo.newSubRoadRoad.hashSubRoad[idSubRoad].push(objSubRoad);
            }
        }
    }

    /**
     * Associate police number to subroad
     */
    this._AssociatePoliceNumberToSubRoad = function()
    {
        // Validate if any subroad seletecd
        if(myRoadBuilderTool._layerSubRoadPoliceSelected.getSource().getFeatures().length !== 1)
        {
            if (myRoadBuilderTool._layerSubRoadPoliceSelected.getSource().getFeatures().length === 0) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["warning"]("Não existe nenhum troço seleccionado");
                toastr.options.positionClass = 'toast-bottom-center';
            }

            if (myRoadBuilderTool._layerSubRoadPoliceSelected.getSource().getFeatures().length > 1) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["warning"]("Seleccione apenas um troço");
                toastr.options.positionClass = 'toast-bottom-center';
            }

            return;
        }

        // Validate if any police number are selected
        if(myRoadBuilderTool._selectedFeaturesPoliceNumber.getArray().length === 0)
        {
            toastr.options.positionClass = 'toast-top-center';
            toastr["warning"]("Seleccione pelo menos um número de polícia");
            toastr.options.positionClass = 'toast-bottom-center';
            return;
        }

        // Start wait
        myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', true);

        // Build input parameter
        var arrayPoliceNumber = [];
        for(var i = 0; i < myRoadBuilderTool._selectedFeaturesPoliceNumber.getArray().length; i++)
        {
            var featurePoliceNumber = myRoadBuilderTool._selectedFeaturesPoliceNumber.getArray()[i];
            arrayPoliceNumber.push(featurePoliceNumber.getProperties().POL_SEQ);
        }
        var objPoliceNumberToSubRoad = {
            idSubRoad: myRoadBuilderTool._layerSubRoadPoliceSelected.getSource().getFeatures()[0].getProperties().IDTROCO,
            arrayPoliceNumber: arrayPoliceNumber
        }

        $.ajax({
            type: 'POST',
            url: '/rest/app/RoadBuilderTool/AssociatePoliceNumberToSubRoad',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(objPoliceNumberToSubRoad),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na associação dos números de polícia ao troço");
                    toastr.options.positionClass = 'toast-bottom-center';
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Clean all element selected
                            myRoadBuilderTool._layerPoliceAssociateToSubRoadSelected.getSource().clear();
                            myRoadBuilderTool._CleanSelectPoliceNumberByPolygonTool();

                            // Highlight all police number of the sub road
                            myRoadBuilderTool._HighLightSubRoadPoliceNumber(myRoadBuilderTool._layerSubRoadPoliceSelected.getSource().getFeatures()[0].getProperties().IDTROCO);

                            toastr.options.positionClass = 'toast-top-center';
                            toastr["success"]("Números de polícia associados com sucesso");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                        case "FREGUESIA_NOT_COMPATIBLE":
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Freguesia de um números de polícia não compatível com troço");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                        default:
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na associação dos números de polícia ao troço");
                            toastr.options.positionClass = 'toast-bottom-center';
                            break;
                    }
                }

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na associação dos números de polícia ao troço");
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });        
    }

    /**
     * Check if subroad selected are from diferente road
     */
    this._CheckIfSubroadSelectedDiferenteRoad = function ()
    {
        switch(myRoadBuilderTool._elementTypeForOperarion)
        {
            case "subroad":
                var countRoadSelected = myRoadBuilderTool._select.getFeatures().getArray().length;
                var hashRoad = {};

                if(countRoadSelected <= 1)
                    return false;

                for(var i = 0; i < countRoadSelected; i++)
                {
                    var idRoad = myRoadBuilderTool._select.getFeatures().getArray()[i].getProperties().ARR_SEQ;
                    if(!hashRoad[idRoad])
                        hashRoad[idRoad] = 1;
                }

                if(Object.keys(hashRoad).length > 1)
                    return true;
                break;
            default:
                return false;
        }

        return false;
    }

    this.getRoadHistory = function () {

        $('#id-offcanvas-body-layer-history-detail-field table').remove();        

        var historyRow = "";

        if (myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures()[0] && myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures()[0].getProperties().ARR_SEQ) {

            $('#id-modal-road-build-tool-road-history').modal('show');

            $('#id-spinner-modal-road-build-tool-road-history').removeClass('ol-hidden');

            $.ajax({
                type: 'GET',
                url: '/rest/app/RoadBuilderTool/GetHistoryFromRoadById?idArruamento=' + myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures()[0].getProperties().ARR_SEQ,
                contentType: "application/json",
                dataType: 'json',
                async: false,
                success: function (data) {

                    myRoadBuilderTool._listHistoryRoad = data.result;

                    myRoadBuilderTool._datatablehistoryRoad.clear();

                    myRoadBuilderTool._datatablehistoryRoad.rows.add(data.result);

                    myRoadBuilderTool._datatablehistoryRoad.draw();

                    $('#id-idArruamento-road-history-edit').val(myRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures()[0].getProperties().ARR_SEQ);

                    $('#id-spinner-modal-road-build-tool-road-history').addClass('ol-hidden');

                    // Reset cursor
                    document.body.style.cursor = 'default';

                },
                error: function (request, status, error) {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro no carregamento do histórico");
                    toastr.options.positionClass = 'toast-bottom-center';

                    $('#id-spinner-modal-road-build-tool-road-history').addClass('ol-hidden');

                }
            });

        } else {
            toastr.options.positionClass = 'toast-top-center';
            toastr["warning"]("Seleccione um arruamento");
            toastr.options.positionClass = 'toast-bottom-center';

        }

    }

    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    // -- init column def --
    var columnDefArrayRoadHistory = [];

    // button
    columnDefArrayRoadHistory.push({
        'id': 'id',
        'data': 'id',
        'className': 'dt-body-center dt-font',
        'orderable': false,
        'visible': false
    });

    // button
    columnDefArrayRoadHistory.push({
        'name': 'button_config_element',
        'className': 'dt-body-center dt-font',
        'title': 'Editar',
        'data': null,
        'orderable': false,
        'defaultContent': '<a class="edit-history-road"><i class="material-icons">edit</i></a>'
    });

    // button
    columnDefArrayRoadHistory.push({
        'name': 'button_config_element',
        'className': 'dt-body-center dt-font',
        'title': 'Remover',
        'data': null,
        'orderable': false,
        'defaultContent': '<a class="remove-history-road"><i class="material-icons">delete</i></a>'
    });


    // Description
    columnDefArrayRoadHistory.push({
        'id': 'nomE_FINAL',
        'data': 'nomE_FINAL',
        'title': 'Nome',
        'name': 'Nome',
        'type': 'readonly',
    });

    // Description
    columnDefArrayRoadHistory.push({
        'id': 'ordem',
        'data': 'ordem',
        'title': 'Ordem',
        'name': 'Ordem',
        'type': 'readonly',
    });

    myRoadBuilderTool._datatablehistoryRoad = $('#id-table-history-road').DataTable({
        "destroy": true,
        "language": {
            "search": "Procurar",
            "emptyTable": 'Nenhum histórico',
            "paginate": {
                "previous": '<i class="fa fa-caret-left"></i>',
                "next": '<i class="fa fa-caret-right"></i>',
                "first": '<i class="fa fa-step-backward"></i>',
                "last": '<i class="fa fa-step-forward"></i>'
            }
        },
        "fixedHeader": false,
        "filter": false,
        "info": false,
        "scrollCollapse": false,
        "deferRender": false,
        "scroller": false,
        "ordering": false,
        "columns": columnDefArrayRoadHistory,
        "bPaginate": true,
        "name": "LayerSource_style",
        "rowId": 'id',
        "searchable": false,
        "lengthChange": false,
        "autoWidth": false,
        "select": false,
        "iDisplayLength": 5
    });

    

    myRoadBuilderTool._datatablehistoryRoad.on('draw', function () {

        if (myRoadBuilderTool._mapSgs._settings._mapSettings.operation_visible.CreateRemoveEditHistory) {

            $('.edit-history-road').off('click').on('click', function () {

                $('#id-modal-road-history-tool-road-save-edit').show();
                $('#id-modal-road-history-tool-road-save-new').hide();
                $('#id-modal-road-history-tool-road-delete').show();

                var historyRoad = myRoadBuilderTool._listHistoryRoad.find(c => c.id == this.closest('tr').id);

                $('#id-id-road-history-edit').val(historyRoad.id);
                $('#id-name-road-history-edit').val(historyRoad.nomE_FINAL);
                $('#id-order-road-history-edit').val(historyRoad.ordem);
                $('#id-observation-road-history-edit').val(historyRoad.observacoes);

                if (!$('#id-content-edit-road-history').is(":visible"))
                    $('#id-content-edit-road-history').toggle('ol-hidden');

            });

            $('.remove-history-road').off('click').on('click', function () {

                myRoadBuilderTool._utility.ShowWait('id-spinner-modal-road-build-tool-road-history', true);

                $.ajax({
                    type: 'DELETE',
                    url: '/rest/app/RoadBuilderTool/RemoveHistoryById?Id=' + this.closest('tr').id,
                    contentType: "application/json",
                    dataType: 'json',
                    async: true,
                    success: function (data) {

                        if (data.result) {

                            // Stop wait
                            myRoadBuilderTool._utility.ShowWait('id-spinner-modal-road-build-tool-road-history', false);

                            toastr.options.positionClass = 'toast-top-center';
                            toastr["success"]("Histórico removido com sucesso");
                            toastr.options.positionClass = 'toast-bottom-center';

                            myRoadBuilderTool.getRoadHistory();

                        } else {
                            toastr.options.positionClass = 'toast-top-center';
                            toastr["error"]("Erro na remoção do historico");
                            toastr.options.positionClass = 'toast-bottom-center';

                            // Stop wait
                            myRoadBuilderTool._utility.ShowWait('id-spinner-modal-road-build-tool-road-history', false);

                        }

                    },
                    error: function (request, status, error) {
                        toastr.options.positionClass = 'toast-top-center';
                        toastr["error"]("Erro na remoção do historico");
                        toastr.options.positionClass = 'toast-bottom-center';

                        // Stop wait
                        myRoadBuilderTool._utility.ShowWait('id-spinner-modal-road-build-tool-road-history', false);
                    }
                });


            });

        }
        else {

            myRoadBuilderTool._datatablehistoryRoad.column(1).visible(false);
            myRoadBuilderTool._datatablehistoryRoad.column(2).visible(false);
            $('#id-button-road-history-add').hide();

        }

    });

    


    $('#id-button-road-history-add').on('click', function () {

        $('#id-modal-road-history-tool-road-save-edit').hide();
        $('#id-modal-road-history-tool-road-delete').hide();
        $('#id-modal-road-history-tool-road-save-new').show();

        $('#id-id-road-history-edit').val('');
        $('#id-name-road-history-edit').val('');
        $('#id-order-road-history-edit').val('');
        $('#id-observation-road-history-edit').val('');

        if (!$('#id-content-edit-road-history').is(":visible"))
            $('#id-content-edit-road-history').toggle('ol-hidden');

    });
    
    $('#id-modal-close-save-road').on('click', function () {

        if ($('#id-content-edit-road-history').is(":visible"))
            $('#id-content-edit-road-history').toggle('ol-hidden');

    });

    $('#id-modal-road-history-tool-road-save-edit').on('click', function () {

        var roadHistoryEdit = $('#id-form-edit-road-history').serializeJSON();

        myRoadBuilderTool._utility.ShowWait('id-spinner-modal-road-build-tool-road-history', true);

        $.ajax({
            type: 'POST',
            url: '/rest/app/RoadBuilderTool/SaveHistoryEdit',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(roadHistoryEdit),
            async: true,
            success: function (data) {

                if (data.result) {
                    
                    // Stop wait
                    myRoadBuilderTool._utility.ShowWait('id-spinner-modal-road-build-tool-road-history', false);

                    toastr.options.positionClass = 'toast-top-center';
                    toastr["success"]("Gravação concluida com sucesso");
                    toastr.options.positionClass = 'toast-bottom-center';

                    //$('#id-content-edit-road-history').toggle('ol-hidden');
                    $('#id-content-edit-road-history').toggle('ol-hidden');

                    myRoadBuilderTool.getRoadHistory();

                } else {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na gravação do historico");
                    toastr.options.positionClass = 'toast-bottom-center';

                    // Stop wait
                    myRoadBuilderTool._utility.ShowWait('id-spinner-modal-road-build-tool-road-history', false);

                }

            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na gravação do historico");
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('id-spinner-modal-road-build-tool-road-history', false);
            }
        });

    })
    

    $('#id-modal-road-history-tool-road-save-new').on('click', function () {

        var roadHistoryEdit = $('#id-form-edit-road-history').serializeJSON();

        myRoadBuilderTool._utility.ShowWait('id-spinner-modal-road-build-tool-road-history', true);

        $.ajax({
            type: 'POST',
            url: '/rest/app/RoadBuilderTool/SaveHistoryNew',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(roadHistoryEdit),
            async: true,
            success: function (data) {

                if (data.result) {
                    
                    // Stop wait
                    myRoadBuilderTool._utility.ShowWait('id-spinner-modal-road-build-tool-road-history', false);

                    toastr.options.positionClass = 'toast-top-center';
                    toastr["success"]("Gravação concluida com sucesso");
                    toastr.options.positionClass = 'toast-bottom-center';

                    //$('#id-content-edit-road-history').toggle('ol-hidden');
                    $('#id-content-edit-road-history').toggle('ol-hidden');

                    myRoadBuilderTool.getRoadHistory();

                } else {
                    toastr.options.positionClass = 'toast-top-center';
                    toastr["error"]("Erro na gravação do historico");
                    toastr.options.positionClass = 'toast-bottom-center';

                    // Stop wait
                    myRoadBuilderTool._utility.ShowWait('id-spinner-modal-road-build-tool-road-history', false);

                }

            },
            error: function (request, status, error) {
                toastr.options.positionClass = 'toast-top-center';
                toastr["error"]("Erro na gravação do historico");
                toastr.options.positionClass = 'toast-bottom-center';

                // Stop wait
                myRoadBuilderTool._utility.ShowWait('id-spinner-modal-road-build-tool-road-history', false);
            }
        });

    })

    /**
     * Close modal create road form
     */
    $('#id-modal-road-build-tool-add-road-close').on('click', function() {
        $('#id-modal-road-build-tool-add-road').hide();
    });

    /**
     * Save new road on create new road form
     */
    //$('#id-modal-road-build-tool-add-road-save').on('click', myRoadBuilderTool._SaveNewRoad);

    /**
     * Close modal create police number form
     */
    $('#id-modal-road-build-tool-add-police-close').on('click', function() {
        $('#id-modal-road-build-tool-add-police').hide();
    });

    /**
     * Close modal road form
     */
    $('#id-modal-road-build-tool-road-close').on('click', function() {
        $('#id-modal-road-build-tool-road').hide();
    });

    /**
     * Save new police number on create police number form
     */
    $('#id-modal-road-build-tool-add-police-save').on('click', myRoadBuilderTool._SaveNewPolice);

    /**
     * Event on change freguesia on police number form
     */
    $('#id-modal-road-build-tool-add-police-info-body-select-freguesia').on('changed.bs.select', function()
    {
        var dtccfr = $('#id-modal-road-build-tool-add-police-info-body-select-freguesia').val();
        var listSubroadFreguesia = myRoadBuilderTool._listSubRoadPolice.filter(c => c.dtccfr == dtccfr);
        myRoadBuilderTool._utility.FillSelect('id-modal-road-build-tool-add-police-info-body-select-id-troco', listSubroadFreguesia, 'troco', 'id_troco');

        $('#id-modal-road-build-tool-add-police-info-body-ddccfr').val((dtccfr === "-1")? "": dtccfr);
    });

    /**
     * Event on change subroad on police number form
     */
    $('#id-modal-road-build-tool-add-police-info-body-select-id-troco').on('changed.bs.select', function()
    {
        var idSubRoadSelected = $('#id-modal-road-build-tool-add-police-info-body-select-id-troco').val();
        var subRoadSelected = myRoadBuilderTool._listSubRoadPolice.find(c => c.id_troco == idSubRoadSelected);

        // Fil arruamento code
        $('#id-modal-road-build-tool-add-police-info-body-arr-cod').val(subRoadSelected.arr_cod);
    });

    /**
     * Event save sub road
     */
    $('#id-modal-road-build-tool-road-save').on('click', function()
    {
        switch(myRoadBuilderTool._modeSaveSubRoad) {
            case "merge_sub_road":
                myRoadBuilderTool._SaveSubRoadMerge();
                break;
            case "sub_road":
                myRoadBuilderTool._SaveSubRoadInfo();
                break;
            case "road":
                myRoadBuilderTool._SaveRoadInfo();
                break;
            case 'create_road':
                myRoadBuilderTool._SaveNewRoad();
                break;
            case 'merge_road':
                myRoadBuilderTool._SaveMergeRoad();
                break;
            case 'split_road':
                myRoadBuilderTool._SaveSplitRoad();
                break;
            default:
                // do nothing
        }   
    });

    /**
     * Event confirm modal delete element
     */
    $('#id-modal-road-build-tool-road-delete-confirm').on('click', myRoadBuilderTool._DeleteElementSecondStep);

    /**
     * Event close modal delete element
     */
    $('#id-modal-road-build-tool-road-delete-cancel').on('click', function() {
        $('#id-modal-road-build-tool-road-delete').hide();
    });

    /**
     * Event close modal add subroad to road
     */
    $('#id-modal-road-build-tool-road-add-subroad-cancel').on('click', function() {
        $('#id-modal-road-build-tool-road-add-subroad').hide();
    });

    /**
     * Event confirm modal add subroad to road
     */
    $('#id-modal-road-build-tool-road-add-subroad-confirm').on('click', myRoadBuilderTool._MergeSubRoadToRoad);

    /**
     * Event to close area info
     */
    $('#close-offcanvas-rbt-info').on('click', function () {
        $('#offcanvas-rbt-info').removeClass('show');
    });

    /**
     * Evend key shit press for road multi selection
     */
    window.addEventListener('keydown', function (e) {
        switch(myRoadBuilderTool._elementTypeForOperarion)
        {
            case "road":
                if(e.which === 16 )
                {
                    if($('#target-gpi-road-tool-select-road.hold-button').hasClass('select-multi'))
                    {
                        myRoadBuilderTool._shiftPressed = false;
                        $('#target-gpi-road-tool-select-road.hold-button').removeClass('select-multi')
                    }
                    else {
                        if($('#target-gpi-road-tool-select-road').hasClass('hold-button'))
                        {
                            myRoadBuilderTool._shiftPressed = true;
                            $('#target-gpi-road-tool-select-road').addClass('select-multi');
                        }
                    }
                }
                break;
            default:
                 myRoadBuilderTool._shiftPressed = false;
                 $('#target-gpi-road-tool-select-road').removeClass('select-multi');
        }
    }, false);

    // -- end event -------------------------------------------------------------------------------
}

/**
 * Init road builder tool
 * @param {object} mapSgs, map object
 */
RoadBuilderTool.prototype.Init = function (mapSgs) {

    if(!this._toolInitialize)
    {
        this._toolInitialize = true;

        // Set map info
        this._mapSgs = mapSgs;

        // This object 
        var objRoadBuilderTool = this;

        // Layer source name of police number
        this._layerSourceNamePoliceNumber = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ROAD_BUILDER_TOOL", "POLICE_NUMBER", "LAYER_SOURCE_NAME").value;

        // Layer info police number
        this._layerInfoPoliceNumber = this._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName(objRoadBuilderTool._layerSourceNamePoliceNumber)[0];

        // Layer name subroad in map
        this._layerNameSubRoadInMap = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "ROAD_BUILDER_TOOL", "SECTION_LAYER_IN_MAP", "LAYER_NAME").value;

        // Layer info road
        this._layerInfoRoad = {
            workspace: objRoadBuilderTool._utility.GetPropertyInfoInConfigArray(objRoadBuilderTool._mapSgs._settings.configurationInfo.propertyInfo, "ROAD_BUILDER_TOOL", "ARRUAMENTO_LAYER", "WORKSPACE").value,
            layerName: objRoadBuilderTool._utility.GetPropertyInfoInConfigArray(objRoadBuilderTool._mapSgs._settings.configurationInfo.propertyInfo, "ROAD_BUILDER_TOOL", "ARRUAMENTO_LAYER", "LAYER_NAME").value,
            geoserver: objRoadBuilderTool._utility.GetPropertyInfoInConfigArray(objRoadBuilderTool._mapSgs._settings.configurationInfo.propertyInfo, "ROAD_BUILDER_TOOL", "ARRUAMENTO_LAYER", "GEOSERVER").value,
            allColumn: objRoadBuilderTool._utility.GetPropertyInfoInConfigArray(objRoadBuilderTool._mapSgs._settings.configurationInfo.propertyInfo, "ROAD_BUILDER_TOOL", "ARRUAMENTO_LAYER", "COLUMN").value
        };

        // Layer info road
        this._layerInfoSubRoad = {
            workspace: objRoadBuilderTool._utility.GetPropertyInfoInConfigArray(objRoadBuilderTool._mapSgs._settings.configurationInfo.propertyInfo, "ROAD_BUILDER_TOOL", "TROCO_LAYER", "WORKSPACE").value,
            layerName: objRoadBuilderTool._utility.GetPropertyInfoInConfigArray(objRoadBuilderTool._mapSgs._settings.configurationInfo.propertyInfo, "ROAD_BUILDER_TOOL", "TROCO_LAYER", "LAYER_NAME").value,
            geoserver: objRoadBuilderTool._utility.GetPropertyInfoInConfigArray(objRoadBuilderTool._mapSgs._settings.configurationInfo.propertyInfo, "ROAD_BUILDER_TOOL", "TROCO_LAYER", "GEOSERVER").value,
            allColumn: objRoadBuilderTool._utility.GetPropertyInfoInConfigArray(objRoadBuilderTool._mapSgs._settings.configurationInfo.propertyInfo, "ROAD_BUILDER_TOOL", "TROCO_LAYER", "COLUMN").value
        };

        // -- Drag box ----------------------------------------------------------------------------

        // Drag box for select
        this._dragBox = new DragBox({
            condition: platformModifierKeyOnly
        });

        // Add drag box interaction for select to map
        this._mapSgs.map.addInteraction(this._dragBox);

        // Set active drag box
        this._dragBox.setActive(false);

        // On draw box end
        this._dragBox.on('boxend', function() {
            // features that intersect the box geometry are added to the
            // collection of selected features

            // if the view is not obliquely rotated the box geometry and
            // its extent are equalivalent so intersecting features can
            // be added directly to the collection
            var rotation = objRoadBuilderTool._mapSgs.map.getView().getRotation();
            var oblique = rotation % (Math.PI / 2) !== 0;
            var candidateFeatures = oblique ? [] : objRoadBuilderTool._select.getFeatures();
            var extent = objRoadBuilderTool._dragBox.getGeometry().getExtent();
            objRoadBuilderTool.collectionFeatureSet.getArray().forEach(function(feature, index)
            {
                if(feature.getId().indexOf(objRoadBuilderTool._layerNameSubRoadInMap) >= 0 && feature.getGeometry().intersectsExtent(extent)) {
                    candidateFeatures.push(feature);
                }
            });

            // when the view is obliquely rotated the box extent will
            // exceed its geometry so both the box and the candidate
            // feature geometries are rotated around a common anchor
            // to confirm that, with the box geometry aligned with its
            // extent, the geometries intersect
            if (oblique) {
                var anchor = [0, 0];
                var geometry = objRoadBuilderTool._dragBox.getGeometry().clone();
                geometry.rotate(-rotation, anchor);
                var extent$1 = geometry.getExtent();
                candidateFeatures.forEach(function(feature) {
                    var geometry = feature.getGeometry().clone();
                    geometry.rotate(-rotation, anchor);
                    if (geometry.intersectsExtent(extent$1)) {
                        objRoadBuilderTool._select.getFeatures().push(feature);
                    }
                });
            }

            // Action select
            objRoadBuilderTool._SelectSubRoadAction();
        });

        // Box draw start - clear selection when drawing a new box and when clicking on the map
        this._dragBox.on('boxstart', function() {
            objRoadBuilderTool._select.getFeatures().clear();
        });

        // -- Init table freguesia road info ------------------------------------------------------
        objRoadBuilderTool._BuildFreguesiaTable('road', '#id-modal-road-build-tool-road-info-form .table-node');

        // -- Init table freguesia subroad info ---------------------------------------------------
        objRoadBuilderTool._BuildFreguesiaTable('subroad', '#id-modal-road-build-tool-road-sub-road-info-form .table-node');

        // -- Get all refeence --------------------------------------------------------------------
        objRoadBuilderTool._GetAllReferences();

        // -- Init state date ---------------------------------------------------------------------
        $('#id-modal-road-build-tool-road-info-detail-form [name="data_actua"]').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

        // -- Info road line ----------------------------------------------------------------------

        // Layer draw line road
        this._layerInfoLineRoad = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._styleDrawLineRoad,
            name: 'current_info_line_road'
        });
        this._mapSgs.map.addLayer(this._layerInfoLineRoad);

        // Layer draw line road - event on add feature
        this._layerInfoLineRoad.getSource().on('addfeature', function (evt)
        {
            // -- Add point - edge of the road ----------------------------------------------------
            var feature = evt.feature;

            // First point
            var featureFirstPoint = new Feature({
                geometry: new Point(feature.getGeometry().getFirstCoordinate()),
                name: "first-point-info-line-road",
                id: feature.getId() + ".first" 
            });
            objRoadBuilderTool._layerPointRoad.getSource().addFeature(featureFirstPoint);

            // Last point
            var featureLastPoint = new Feature({
                geometry: new Point(feature.getGeometry().getLastCoordinate()),
                name: "last-point-info-line-road",
                id: feature.getId() + ".last"
            });
            objRoadBuilderTool._layerPointRoad.getSource().addFeature(featureLastPoint);
        });

        // -- Road - Select all subroad from road -------------------------------------------------

        // Layer subroad from road
        this._layerSubRoadFromRoad = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._styleSelectAllSubRoadFromRoad,
            name: 'subroad_from_road'
        });
        this._mapSgs.map.addLayer(this._layerSubRoadFromRoad);

        // -- Draw road line interaction ----------------------------------------------------------

        // Layer draw line road
        this._layerDrawLineRoad = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._styleDrawLineRoad,
            name: 'draw_road'
        });
        this._mapSgs.map.addLayer(this._layerDrawLineRoad);

        // Layer draw line subroad
        this._layerSubRoadLine = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._styleLineSubRoad,
            name: 'subroad'
        });
        this._mapSgs.map.addLayer(this._layerSubRoadLine);

        // Layer draw line road
        this._layerPointRoad = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._stylePointRoad,
            name: 'point_road'
        });
        this._mapSgs.map.addLayer(this._layerPointRoad);

        // Layer highlight to modify 
        this._layerSubRoadForModify = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._styleLineSubRoad,
            name: 'subroadModify'
        });
        this._mapSgs.map.addLayer(this._layerSubRoadForModify);

        // Layer draw line road
        this._layerPointSubRoadForModify = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._stylePointRoad,
            name: 'point_sub_road_modify'
        });
        this._mapSgs.map.addLayer(this._layerPointSubRoadForModify);

        // Layer draw line road - event on add feature
        this._layerDrawLineRoad.getSource().on('addfeature', function (evt)
        {
            objRoadBuilderTool._ActionFeatureDrawLineRoad(evt.feature);
            objRoadBuilderTool._drawLineRoad.setActive(false);
        });

        // Modify draw line road
        this._modifyDrawLineRoad = new Modify({
            source: this._layerDrawLineRoad.getSource()
        });
        this._mapSgs.map.addInteraction(this._modifyDrawLineRoad);
        this._modifyDrawLineRoad.setActive(false);

        // Modify draw line road - modify end
        this._modifyDrawLineRoad.on('modifyend', function (evt)
        {
            if(evt.features.getArray().length != 1)
            {
                return;
            }
            objRoadBuilderTool._ActionFeatureDrawLineRoad(evt.features.getArray()[0]);
        });

        // Modify draw line road - modify start
        this._modifyDrawLineRoad.on('modifystart', function (evt)
        {
            if(evt.features.getArray().length != 1)
            {
                return;
            }
            var feature = evt.features.getArray()[0];

            objRoadBuilderTool._layerPointRoad.getSource().clear();
            objRoadBuilderTool._layerSubRoadLine.getSource().clear();
            objRoadBuilderTool._collectionFeatureIntercepted.clear();
            objRoadBuilderTool._hashFeatureIntercepted = {};
            objRoadBuilderTool._createRoadInfo = {};

            var geom = feature.getGeometry();
            $('#offcanvas-info header')[0].innerHTML = 'Comprimento';
            $('#offcanvas-info').addClass('show');
            if( objRoadBuilderTool._utility.mobilecheck())
                $('#offcanvas-info').addClass('showreponsive')
            $('#offcanvas-info').addClass('height-length');

            var lst = geom.on('change', function (e) {
                var geomE = e.target;
                var tooltipCoord = e.target.getCoordinates()[e.target.getCoordinates().length - 1];
                var length_m = objRoadBuilderTool._utility.LengthLine(geomE);
                objRoadBuilderTool._mapSgs.measureTooltipElement.innerHTML = length_m;
                objRoadBuilderTool._mapSgs.measureTooltip.setPosition(tooltipCoord);
                objRoadBuilderTool._mapSgs.measureTooltip.setVisible(true);
                $(objRoadBuilderTool._mapSgs.measureTooltipElement).removeClass('hidden');

                $('#sgs-measure-input-m').html(length_m);
                $('#sgs-measure-input-ha').html("");
            });
        });

        // Draw object road
        this._drawLineRoad = new Draw({
            source: this._layerDrawLineRoad.getSource(),
            type: 'LineString',
            style: this._styleDrawLineRoad,
            condition: function (evt) {
                return true;
            },
            finishCondition: function (evt) {
                return true;
            }
        });

        // Event draw road line start
        this._drawLineRoad.on('drawstart', function (evt)
        {
            objRoadBuilderTool._layerDrawLineRoad.getSource().clear();
            objRoadBuilderTool._layerPointRoad.getSource().clear();
            objRoadBuilderTool._layerSubRoadLine.getSource().clear();
            objRoadBuilderTool._collectionFeatureIntercepted.clear();
            objRoadBuilderTool._hashFeatureIntercepted = {};
            objRoadBuilderTool._createRoadInfo = {};
            objRoadBuilderTool._modifyDrawLineRoad.setActive(false);

            var geom = evt.feature.getGeometry();
            $('#offcanvas-info header')[0].innerHTML = 'Comprimento';
            $('#offcanvas-info').addClass('show');
            if( objRoadBuilderTool._utility.mobilecheck())
                $('#offcanvas-info').addClass('showreponsive')
            $('#offcanvas-info').addClass('height-length');

            var lst = geom.on('change', function (e) {
                var geomE = e.target;
                var tooltipCoord = e.target.getCoordinates()[e.target.getCoordinates().length - 1];
                var length_m = objRoadBuilderTool._utility.LengthLine(geomE);
                objRoadBuilderTool._mapSgs.measureTooltipElement.innerHTML = length_m;
                objRoadBuilderTool._mapSgs.measureTooltip.setPosition(tooltipCoord);
                objRoadBuilderTool._mapSgs.measureTooltip.setVisible(true);
                $(objRoadBuilderTool._mapSgs.measureTooltipElement).removeClass('hidden');

                $('#sgs-measure-input-m').html(length_m);
                $('#sgs-measure-input-ha').html("");
            });
        });

        // Event draw road line end
        this._drawLineRoad.on('drawend', function (evt) {
            $(objRoadBuilderTool._mapSgs.measureTooltipElement).addClass('hidden');
            objRoadBuilderTool._mapSgs.measureTooltip.setVisible(false);
            objRoadBuilderTool._modifyDrawLineRoad.setActive(true);
        });

        // Set active draw road line
        this._drawLineRoad.setActive(false);

        // Add draw interaction road line to map
        this._mapSgs.map.addInteraction(this._drawLineRoad);

        // -- Select by polygon for road split ----------------------------------------------------

        // Source draw select
        this._sourceDrawPolygonSplitRoad = new VectorSource({
            useSpatialIndex : false
        });
        // Layer draw select
        this._layerDrawPolygonSplitRoad = new VectorLayer({
            source: this._sourceDrawPolygonSplitRoad,
            style: this._stylePolygonLayerDraw
        });
        this._mapSgs.map.addLayer(this._layerDrawPolygonSplitRoad);

        // Draw interaction select
        this._interactionDrawSplitRoad = new Draw({
            source :  this._sourceDrawPolygonSplitRoad,
            type : 'Polygon',
            style: this._stylePolygonDraw
            //only draw when Ctrl is pressed.
            //condition : platformModifierKeyOnly
        });
        this._interactionDrawSplitRoad.setActive(false);
        this._mapSgs.map.addInteraction(this._interactionDrawSplitRoad);

        // Create select interaction
        this._interactionSelectSplitRoad = new Select({
            style: this._styleSelectAllSubRoadFromSplitRoad,
        });
        this._interactionSelectSplitRoad.setActive(false);
        this._mapSgs.map.addInteraction(this._interactionSelectSplitRoad);
        this._selectedFeaturesSplitRoad = this._interactionSelectSplitRoad.getFeatures();


        // On draw start polygon
        this._interactionDrawSplitRoad.on('drawstart',function(event)
        {
            objRoadBuilderTool._sourceDrawPolygonSplitRoad.clear();
            objRoadBuilderTool._selectedFeaturesSplitRoad.clear();
            objRoadBuilderTool._interactionSelectSplitRoad.setActive(false);
        },this);

        // Set active select split road function delay
        this._delaySelectSplitRoadActivate = function(){
            setTimeout(function(){
                objRoadBuilderTool._interactionSelectSplitRoad.setActive(true);
            },300);
        }

        // On draw end polygon
        this._interactionDrawSplitRoad.on('drawend', function(event)
        {
            var polygonFeature = event.feature;
            var polygon = polygonFeature.getGeometry();

            if(objRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures().length > 0)
            {
                // Active select split road
                objRoadBuilderTool._delaySelectSplitRoadActivate();

                // Insert all subroad feature in polygon
                var features = objRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures();
                for (var i = 0 ; i < features.length; i++)
                {
                    if(polygon.intersectsExtent(features[i].getGeometry().getExtent()))
                    {
                        var feature = features[i];
                        objRoadBuilderTool._selectedFeaturesSplitRoad.push(feature);
                    }
                }
            }
        });

        // Modify polygon
        this._interactionModifySplitRoad = new Modify({
            //only allow modification of drawn polygons
            features: objRoadBuilderTool._sourceDrawPolygonSplitRoad.getFeaturesCollection(),
            style: this._stylePolygonDrawModify,
            deleteCondition: function(event) {
                return shiftKeyOnly(event) && click(event);
            }
        });
        this._interactionModifySplitRoad.setActive(false);
        this._mapSgs.map.addInteraction(this._interactionModifySplitRoad);

        // Modify start
        this._interactionModifySplitRoad.on('modifystart',function(event)
        {
            objRoadBuilderTool._interactionSelectSplitRoad.setActive(false);
        },this);

        // Modify end -  reactivate select function
        this._interactionModifySplitRoad.on('modifyend',function(event)
        {
            var polygonFeatures = event.features;

            if(objRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures().length > 0)
            {
                // Active select split road
                objRoadBuilderTool._delaySelectSplitRoadActivate();

                // Clear last selection
                objRoadBuilderTool._selectedFeaturesSplitRoad.clear();

                // Insert all subroad feature in polygon
                var features = objRoadBuilderTool._layerSubRoadFromRoad.getSource().getFeatures();

                for( var j = 0; j < polygonFeatures.getArray().length; j++)
                {
                    var polygonFeature = polygonFeatures.getArray()[j];
                    var polygon = polygonFeature.getGeometry();

                    for (var i = 0 ; i < features.length; i++)
                    {
                        if(polygon.intersectsExtent(features[i].getGeometry().getExtent()))
                        {
                            var feature = features[i];
                            objRoadBuilderTool._selectedFeaturesSplitRoad.push(feature);
                        }
                    }
                }
            }
        },this);

        // -- Split subroad -----------------------------------------------------------------------

        // Layer subroad for split
        this._layerSubRoadSplit = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._styleLineSubRoad,
            name: 'subroad_split'
        });
        this._mapSgs.map.addLayer(this._layerSubRoadSplit);

        // Layer road for slit
        this._layerRoadSplit = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._styleLineSubRoad,
            name: 'road_split'
        });
        this._mapSgs.map.addLayer(this._layerRoadSplit);


        // Layer point split
        this._layerPointSplit = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._styleSplit
        });
        this._mapSgs.map.addLayer(this._layerPointSplit);

        // Draw split interaction
        this._drawPointSplit = new Draw({
            source: this._layerPointSplit.getSource(),
            type: 'Point',
            style: this._styleSplit,
            condition: function (evt) {
                return true;
            },
            finishCondition: function (evt) {
                return true;
            }
        });
        this._drawPointSplit.setActive(false);
        this._mapSgs.map.addInteraction(this._drawPointSplit);

        // Event on add split feature point
        this._layerPointSplit.getSource().on('addfeature', function (evt)
        {
            // Get feature point split
            var featurePointSplit = evt.feature;

            switch(objRoadBuilderTool._elementTypeForOperarion)
            {
                case "road":
                    objRoadBuilderTool._ActionFeatureSplitRoad(featurePointSplit);
                    break;
                case "subroad":
                    var featureSubRoadToSplit = objRoadBuilderTool._layerSubRoadSplit.getSource().getFeatures()[0];
                    objRoadBuilderTool._ActionFeatureSplitSubRoad(featurePointSplit, featureSubRoadToSplit, true);
                    break;
            }
        });
        
        // Event start draw split point
        this._drawPointSplit.on('drawstart', function (e)
        {
            objRoadBuilderTool._CleanSplitSubroad(false);
        });

        // Event end draw split point
        this._drawPointSplit.on('drawend', function (e)
        {
        });

        // -- Draw police number interaction ------------------------------------------------------

        // Layer buffer for police number
        this._layerBufferPolice = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: [
                this._bufferPoliceStyle
            ],
            name: 'police_layer_buffer'
        });
        this._mapSgs.map.addLayer(this._layerBufferPolice);

        // Layer sub road police number closer
        this.layerSubRoadPoliceCloser = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._styleSubRoadPoliceCloser
        });
        this._mapSgs.map.addLayer(this.layerSubRoadPoliceCloser);

        // Layer sub road police number
        this.layerSubRoadPolice = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._styleSubRoadPolice
        });
        this._mapSgs.map.addLayer(this.layerSubRoadPolice);

        // Layer police number
        this._layerPolicePoint = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._stylePolicePoint
        });

        // Draw police number point interaction
        this._drawPointPolice = new Draw({
            source: this._layerPolicePoint.getSource(),
            type: 'MultiPoint',
            style: this._stylePolicePoint,
            condition: function (evt) {
                return true;
            },
            finishCondition: function (evt) {
                return true;
            }
        });

        // Event on add feature point
        this._layerPolicePoint.getSource().on('addfeature', function (evt)
        {
            var coordinates = evt.feature.getGeometry().getCoordinates();

            // Build coordinate info
            $('#offcanvas-info header')[0].innerHTML = 'Coordenada';
            $('#sgs-measure-input-m').html('Coordenada X: ' + coordinates[0][0]);
            $('#sgs-measure-input-ha').html('Coordenada Y: ' + coordinates[0][1]);
            $('#offcanvas-info').addClass('show');
            if (objRoadBuilderTool._utility.mobilecheck())
                $('#offcanvas-info').addClass('showreponsive')
            $('#offcanvas-info').removeClass('height-length');

            // Create buffer
            var bufferFeature = new Feature({ geometry: new Circle(coordinates[0], objRoadBuilderTool._bufferSize) });
            //var bufferFeatureInWgs84 = bufferFeature.clone;
            //bufferFeatureInWgs84.getGeometry().transform(objRoadBuilderTool._mapSgs._settings.projection.code_, objRoadBuilderTool._mapSgs._settings.projectionWgs84.code_);
            objRoadBuilderTool._layerBufferPolice.getSource().addFeature(bufferFeature);

            // Calculate interception whit sub road
            var featureInWgs84 = evt.feature.clone();
            featureInWgs84.getGeometry().transform(objRoadBuilderTool._mapSgs._settings.projection.code_, objRoadBuilderTool._mapSgs._settings.projectionWgs84.code_);

            var pointCoord = turf.point(featureInWgs84.getGeometry().getCoordinates()[0]);
            var listIdInString = "";
            objRoadBuilderTool._arrayFeatureSubRoadPolice = [];
            var geojsonFormat = new GeoJSON();
            objRoadBuilderTool.collectionFeatureSet.getArray().forEach(function(featureIn, index)
            {
                if(featureIn.getId().indexOf(objRoadBuilderTool._layerNameSubRoadInMap) >= 0)
                {
                    var featureInWgs84 = featureIn.clone();
                    featureInWgs84.getGeometry().transform(objRoadBuilderTool._mapSgs._settings.projection.code_, objRoadBuilderTool._mapSgs._settings.projectionWgs84.code_);
                    var featureInGeoJson = geojsonFormat.writeFeatureObject(featureInWgs84);

                    var distance = turf.pointToLineDistance(pointCoord, featureInGeoJson, {units: 'kilometers'});

                    if( distance <= objRoadBuilderTool._bufferPoliceSizeKm) {
                        objRoadBuilderTool._arrayFeatureSubRoadPolice.push({
                            distance: distance,
                            feature: featureIn
                        });
                        listIdInString += featureIn.getProperties().IDTROCO + ",";
                    }

                    // Get all road in buffer
                    //if(bufferFeature.getGeometry().intersectsExtent(featureIn.getGeometry().getExtent()))
                    //{
                    //    var distance = turf.pointToLineDistance(pointCoord, featureInGeoJson, {units: 'kilometers'});

                    //    objRoadBuilderTool._arrayFeatureSubRoadPolice.push({
                    //        distance: distance,
                    //        feature: featureIn
                    //    });
                    //    listIdInString += featureIn.getProperties().IDTROCO + ",";
                    //}
                }
            });

            // Remove last
            if(objRoadBuilderTool._arrayFeatureSubRoadPolice.length != 0) {
                // Order to get closet distance 
                objRoadBuilderTool._arrayFeatureSubRoadPolice = objRoadBuilderTool._arrayFeatureSubRoadPolice.sort((a, b) => (a.distance > b.distance) ? 1 : -1);

                // Build list of id sub road
                objRoadBuilderTool._listIdSubRoadPolice = [];
                for(var t = 0; t < objRoadBuilderTool._arrayFeatureSubRoadPolice.length; t++)
                {
                    if(t === 0)
                        objRoadBuilderTool.layerSubRoadPoliceCloser.getSource().addFeature(objRoadBuilderTool._arrayFeatureSubRoadPolice[t].feature);
                    else
                        objRoadBuilderTool.layerSubRoadPolice.getSource().addFeature(objRoadBuilderTool._arrayFeatureSubRoadPolice[t].feature);
                    objRoadBuilderTool._listIdSubRoadPolice.push(objRoadBuilderTool._arrayFeatureSubRoadPolice[t].feature.getProperties().IDTROCO);
                }            
            }
            else {
                toastr.options.positionClass = 'toast-top-center';
                toastr["warning"]("Atenção, nenhum troço na proximidade");
                toastr.options.positionClass = 'toast-bottom-center';
            }
        });

        this._mapSgs.map.addLayer(this._layerPolicePoint);

         // Event start draw police number point
        this._drawPointPolice.on('drawstart', function (e)
        {
            // Clear layer police number point
            objRoadBuilderTool._layerPolicePoint.getSource().clear();

            // Clear layer buffer police number
            objRoadBuilderTool._layerBufferPolice.getSource().clear();

            // Clear layer sub road police number closer
            objRoadBuilderTool.layerSubRoadPoliceCloser.getSource().clear();

            // Clear layer sub road police number
            objRoadBuilderTool.layerSubRoadPolice.getSource().clear();
            
            // Clear list sub road id
            objRoadBuilderTool._listIdSubRoadPolice = [];
        });

        // Event end draw police number point
        this._drawPointPolice.on('drawend', function (e) {
        });

        this._drawPointPolice.setActive(false);
        this._mapSgs.map.addInteraction(this._drawPointPolice);

        // -- Layer sub road police number selected -----------------------------------------------
        this._layerSubRoadPoliceSelected = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            visible: false,
            style: this._styleSelectRoad
        });
        this._mapSgs.map.addLayer(this._layerSubRoadPoliceSelected);

        // -- Layer police number associate to a sub road selected --------------------------------
        this._layerPoliceAssociateToSubRoadSelected = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            zIndex: 99,
            visible: false,
            style: this._stylePoliceAssociateToSubRoad
        });
        this._mapSgs.map.addLayer(this._layerPoliceAssociateToSubRoadSelected);

        // -- Select police number by polygon -----------------------------------------------------

        // Source draw select
        this._sourceDrawPolygonPoliceNumber = new VectorSource({
            useSpatialIndex : false
        });
        // Layer draw select
        this._layerDrawPolygonPoliceNumber = new VectorLayer({
            source: this._sourceDrawPolygonPoliceNumber,
            style: this._stylePolygonLayerDraw
        });
        this._mapSgs.map.addLayer(this._layerDrawPolygonPoliceNumber);

        // Draw interaction select
        this._interactionDrawPoliceNumber = new Draw({
            source :  this._sourceDrawPolygonPoliceNumber,
            type : 'Polygon',
            style: this._stylePolygonDraw
            //only draw when Ctrl is pressed.
            //condition : platformModifierKeyOnly
        });
        this._interactionDrawPoliceNumber.setActive(false);
        this._mapSgs.map.addInteraction(this._interactionDrawPoliceNumber);

        // Create select interaction
        var layerPoliceNumberForSelect = this._mapSgs._utility.GetLayerByName(this._mapSgs.map, this._layerInfoPoliceNumber.layerNameKey);
        this._interactionSelectPoliceNumber = new Select({
            layers: [layerPoliceNumberForSelect],
            wrapX: false,
            style: this._stylePoliceAssociateToSubRoadSelect,
            multi: true,
            hitTolerance: 10
        });
        this._interactionSelectPoliceNumber.setActive(false);
        this._mapSgs.map.addInteraction(this._interactionSelectPoliceNumber);
        this._selectedFeaturesPoliceNumber = this._interactionSelectPoliceNumber.getFeatures();

        // On draw start polygon
        this._interactionDrawPoliceNumber.on('drawstart',function(event)
        {
            // Desactive select police number
            objRoadBuilderTool._interactionSelectPoliceNumber.setActive(false);
        },this);

        // Set active select police number function delay
        this._delaySelectPoliceNumberActivate = function(){
            setTimeout(function(){
                objRoadBuilderTool._interactionSelectPoliceNumber.setActive(true)
            },300);
        }

        // On draw end polygon
        this._interactionDrawPoliceNumber.on('drawend', function(event)
        {
            // Active select police number
            objRoadBuilderTool._delaySelectPoliceNumberActivate();

            var polygonFeature = event.feature;
            var polygon = polygonFeature.getGeometry();
            var layerPoliceNumber = objRoadBuilderTool._mapSgs._utility.GetLayerByName(objRoadBuilderTool._mapSgs.map, objRoadBuilderTool._layerInfoPoliceNumber.layerNameKey);
            var features = layerPoliceNumber.getSource().getFeatures();

            // Insert all police number feature in polygon
            for (var i = 0 ; i < features.length; i++)
            {
                if(polygon.intersectsExtent(features[i].getGeometry().getExtent()))
                {
                    var feature = features[i];
                    objRoadBuilderTool._selectedFeaturesPoliceNumber.push(feature);
                }
            }
        });

        // Modify polygon
        this._interactionModifyPoliceNumber = new Modify({
            //only allow modification of drawn polygons
            features: objRoadBuilderTool._sourceDrawPolygonPoliceNumber.getFeaturesCollection(),
            style: this._stylePolygonDrawModify,
            deleteCondition: function(event) {
                return shiftKeyOnly(event) && click(event);
            }
        });
        this._interactionModifyPoliceNumber.setActive(false);
        this._mapSgs.map.addInteraction(this._interactionModifyPoliceNumber);

        // Modify start
        this._interactionModifyPoliceNumber.on('modifystart',function(event)
        {
            // Desactive select police number
            objRoadBuilderTool._interactionSelectPoliceNumber.setActive(false)
        },this);

        // Modify end -  reactivate select function
        this._interactionModifyPoliceNumber.on('modifyend',function(event)
        {
            // Active select police number
            objRoadBuilderTool._delaySelectPoliceNumberActivate();

            // Clear all the police number selected before select all the police number intercepted by all the polygon draw
            objRoadBuilderTool._selectedFeaturesPoliceNumber.clear();

            var polygonFeatures = event.features;
            var layerPoliceNumber = objRoadBuilderTool._mapSgs._utility.GetLayerByName(objRoadBuilderTool._mapSgs.map, objRoadBuilderTool._layerInfoPoliceNumber.layerNameKey);
            var features = layerPoliceNumber.getSource().getFeatures();

            for( var j = 0; j < polygonFeatures.getArray().length; j++)
            {
                var polygonFeature = polygonFeatures.getArray()[j];
                var polygon = polygonFeature.getGeometry();

                for (var i = 0 ; i < features.length; i++)
                {
                    if(polygon.intersectsExtent(features[i].getGeometry().getExtent()))
                    {
                        var feature = features[i];
                        objRoadBuilderTool._selectedFeaturesPoliceNumber.push(feature);
                    }
                }
            }
        },this);
    }
}